/* eslint-disable simple-import-sort/imports */
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from '@app/data/graphqlHooks'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** Scalar defined on BE - unified date format. */
  Date: string
  /** Unified date + time format */
  DateTime: string
}

export type AccuracyScore = {
  __typename?: 'AccuracyScore'
  delta: Scalars['Int']
  points: Scalars['Int']
}

export enum ActivityResult {
  ALMOST_CORRECT = 'ALMOST_CORRECT',
  CORRECT = 'CORRECT',
  NOT_INVOLVED = 'NOT_INVOLVED',
  SKIPPED = 'SKIPPED',
  WRONG = 'WRONG'
}

export enum ActivitySkill {
  LISTENING = 'LISTENING',
  READING = 'READING',
  SPEAKING = 'SPEAKING',
  WRITING = 'WRITING'
}

export enum ActivityType {
  ANAGRAM = 'ANAGRAM',
  FLASHCARDS = 'FLASHCARDS',
  FLIPCARDS = 'FLIPCARDS',
  HUNTWORDS = 'HUNTWORDS',
  LINKMANIA = 'LINKMANIA',
  MILLIONAIRE = 'MILLIONAIRE',
  PEXESO = 'PEXESO',
  PICSMATCH = 'PICSMATCH',
  PREPOSITIONS = 'PREPOSITIONS',
  QUIZ = 'QUIZ',
  SPELL_WIZARD = 'SPELL_WIZARD',
  TEXT_COMPREHENSION = 'TEXT_COMPREHENSION',
  WHEEL = 'WHEEL',
  WILD_WEST = 'WILD_WEST',
  WORD_AHOY = 'WORD_AHOY',
  WORD_LADDERS = 'WORD_LADDERS',
  WORKSHEETS_MATCH_ELEMENTS = 'WORKSHEETS_MATCH_ELEMENTS',
  WORKSHEETS_ONE_TO_MANY = 'WORKSHEETS_ONE_TO_MANY',
  WORKSHEETS_PUZZLE = 'WORKSHEETS_PUZZLE'
}

export enum AssignmentMode {
  GAME = 'GAME',
  HOMEWORK = 'HOMEWORK',
  PERSONALIZED_REPETITION = 'PERSONALIZED_REPETITION',
  SELF_STUDY = 'SELF_STUDY',
  STUDENT_LIBRARY_EXERCISE = 'STUDENT_LIBRARY_EXERCISE',
  TEST = 'TEST',
  WORKSHEET = 'WORKSHEET'
}

export enum AuthorizationCodeScope {
  CLASSROOM = 'CLASSROOM',
  QUIZ = 'QUIZ'
}

export type AuthorizationCodeValidationResult = {
  __typename?: 'AuthorizationCodeValidationResult'
  scopes: Array<AuthorizationCodeValidationScope>
  valid: Scalars['Boolean']
}

export type AuthorizationCodeValidationScope = {
  __typename?: 'AuthorizationCodeValidationScope'
  code: Scalars['String']
  type: AuthorizationCodeScope
}

export type AvatarAction = {
  actionId: Scalars['ID']
}

export type AvatarCompleteQuestAction = AvatarAction & {
  __typename?: 'AvatarCompleteQuestAction'
  actionId: Scalars['ID']
  questId: Scalars['String']
}

export type AvatarRephraseInput = {
  actionId: Scalars['ID']
  conversationId: Scalars['ID']
}

export type AvatarRephraseResponse = {
  __typename?: 'AvatarRephraseResponse'
  actionId: Scalars['ID']
  rephrased: Scalars['Boolean']
  rephrasedText: Scalars['String']
  severity: Scalars['Int']
}

export type AvatarScenario = {
  __typename?: 'AvatarScenario'
  conversationId?: Maybe<Scalars['ID']>
  isEnabled: Scalars['Boolean']
  quests: Array<AvatarScenarioQuest>
  scenarioId: Scalars['String']
}

export type AvatarScenarioAsset = {
  assetId: Scalars['String']
  type: AvatarScenarioAssetType
}

export type AvatarScenarioAssetCellDefinition = {
  colspan?: Maybe<Scalars['Int']>
  key: Scalars['String']
  type: AvatarScenarioAssetCellDefinitionType
}

export type AvatarScenarioAssetCellDefinitionCollection = AvatarScenarioAssetCellDefinition & {
  __typename?: 'AvatarScenarioAssetCellDefinitionCollection'
  colspan?: Maybe<Scalars['Int']>
  config?: Maybe<AvatarScenarioAssetCellDefinitionTextConfig>
  key: Scalars['String']
  type: AvatarScenarioAssetCellDefinitionType
}

export type AvatarScenarioAssetCellDefinitionImage = AvatarScenarioAssetCellDefinition & {
  __typename?: 'AvatarScenarioAssetCellDefinitionImage'
  colspan?: Maybe<Scalars['Int']>
  key: Scalars['String']
  type: AvatarScenarioAssetCellDefinitionType
}

export type AvatarScenarioAssetCellDefinitionText = AvatarScenarioAssetCellDefinition & {
  __typename?: 'AvatarScenarioAssetCellDefinitionText'
  colspan?: Maybe<Scalars['Int']>
  config?: Maybe<AvatarScenarioAssetCellDefinitionTextConfig>
  key: Scalars['String']
  type: AvatarScenarioAssetCellDefinitionType
}

export type AvatarScenarioAssetCellDefinitionTextConfig = {
  __typename?: 'AvatarScenarioAssetCellDefinitionTextConfig'
  align?: Maybe<Scalars['String']>
  color?: Maybe<AvatarScenarioConfigColor>
  heading?: Maybe<Scalars['Int']>
  size?: Maybe<Scalars['String']>
  type: AvatarScenarioAssetCellDefinitionTextConfigType
  weight?: Maybe<Scalars['String']>
}

export enum AvatarScenarioAssetCellDefinitionTextConfigType {
  CHECKLIST = 'CHECKLIST',
  HEADING = 'HEADING',
  PARAGRAPH = 'PARAGRAPH'
}

export enum AvatarScenarioAssetCellDefinitionType {
  COLLECTION = 'COLLECTION',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT'
}

export type AvatarScenarioAssetRow = {
  __typename?: 'AvatarScenarioAssetRow'
  cells: Array<AvatarScenarioAssetRowCell>
  id: Scalars['String']
}

export type AvatarScenarioAssetRowCell = {
  __typename?: 'AvatarScenarioAssetRowCell'
  collection?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  key: Scalars['String']
  text?: Maybe<Scalars['String']>
}

export enum AvatarScenarioAssetType {
  COLLECTION = 'COLLECTION',
  IMAGE = 'IMAGE',
  QUEST_LIST = 'QUEST_LIST',
  VIDEO = 'VIDEO'
}

export type AvatarScenarioCollectionAsset = AvatarScenarioAsset & {
  __typename?: 'AvatarScenarioCollectionAsset'
  assetId: Scalars['String']
  backgroundImageUrl: Scalars['String']
  cellDefinition: Array<AvatarScenarioAssetCellDefinition>
  rows: Array<AvatarScenarioAssetRow>
  type: AvatarScenarioAssetType
}

export type AvatarScenarioConfig = {
  __typename?: 'AvatarScenarioConfig'
  assets: Array<AvatarScenarioAsset>
  chatBackground: AvatarScenarioConfigChatBackground
  modelBackground: ImageType
  scenarioId: Scalars['String']
  scenarioOverviewHolePunchesColor: AvatarScenarioConfigColor
  scenarioOverviewScrollIndicatorColor: AvatarScenarioConfigColor
}

export type AvatarScenarioConfigChatBackground = {
  __typename?: 'AvatarScenarioConfigChatBackground'
  gradientEndColor: AvatarScenarioConfigColor
  gradientStartColor: AvatarScenarioConfigColor
  images: Array<Scalars['String']>
}

export type AvatarScenarioConfigColor = {
  __typename?: 'AvatarScenarioConfigColor'
  name?: Maybe<Scalars['String']>
  opacity?: Maybe<Scalars['Int']>
  value?: Maybe<Scalars['String']>
}

export type AvatarScenarioConfigInput = {
  scenarioId: Scalars['String']
  subject: Subject
}

export type AvatarScenarioImageAsset = AvatarScenarioAsset & {
  __typename?: 'AvatarScenarioImageAsset'
  altText?: Maybe<Scalars['String']>
  assetId: Scalars['String']
  image: ImageType
  type: AvatarScenarioAssetType
}

export type AvatarScenarioQuest = {
  __typename?: 'AvatarScenarioQuest'
  isCompleted: Scalars['Boolean']
  questId: Scalars['String']
}

export type AvatarScenarioQuestListAsset = AvatarScenarioAsset & {
  __typename?: 'AvatarScenarioQuestListAsset'
  assetId: Scalars['String']
  backgroundImageUrl: Scalars['String']
  cellDefinition: Array<AvatarScenarioAssetCellDefinition>
  quests: Array<AvatarScenarioQuestListItem>
  rows: Array<AvatarScenarioAssetRow>
  type: AvatarScenarioAssetType
}

export type AvatarScenarioQuestListItem = {
  __typename?: 'AvatarScenarioQuestListItem'
  completed: Scalars['Boolean']
  questId: Scalars['String']
  text: Scalars['String']
}

export type AvatarScenarioVideoAsset = AvatarScenarioAsset & {
  __typename?: 'AvatarScenarioVideoAsset'
  altText?: Maybe<Scalars['String']>
  assetId: Scalars['String']
  type: AvatarScenarioAssetType
  video: VideoType
}

export type AvatarSendActionsResponse = {
  __typename?: 'AvatarSendActionsResponse'
  actions: Array<AvatarAction>
  conversationId: Scalars['ID']
  stopped: Scalars['Boolean']
  userId: Scalars['ID']
}

export type AvatarShowAssetAction = AvatarAction & {
  __typename?: 'AvatarShowAssetAction'
  actionId: Scalars['ID']
  assetId: Scalars['ID']
}

export type AvatarStartConversationInput = {
  subject: Subject
  subjectLanguage: Language
  topicPackageId?: InputMaybe<Scalars['String']>
}

export type AvatarStartScenarioInput = {
  scenarioId: Scalars['String']
  subject: Subject
  subjectLanguage: Language
}

export type AvatarSubmitEventsInput = {
  conversationId: Scalars['ID']
  events: Array<AvatarTextSubmissionEventInput>
}

export type AvatarTextAction = AvatarAction & {
  __typename?: 'AvatarTextAction'
  actionId: Scalars['ID']
  animation?: Maybe<Scalars['String']>
  audio?: Maybe<Scalars['String']>
  facialExpression?: Maybe<Scalars['String']>
  lipSync?: Maybe<LipSync>
  text: Scalars['String']
}

export type AvatarTextSubmissionEventInput = {
  eventId: Scalars['ID']
  message: Scalars['String']
}

export type AvatarTranslationInput = {
  actionId: Scalars['ID']
  conversationId: Scalars['ID']
  targetLanguage: Language
}

export type AvatarTranslationResponse = {
  __typename?: 'AvatarTranslationResponse'
  actionId: Scalars['ID']
  translatedFrom: Scalars['String']
  translatedText: Scalars['String']
  translatedTo: Scalars['String']
}

export type BlockAsset = {
  __typename?: 'BlockAsset'
  name: Scalars['String']
  url: Scalars['String']
}

export type BlockAssetInput = {
  name: Scalars['String']
  url: Scalars['String']
}

export type Book = {
  __typename?: 'Book'
  id: Scalars['ID']
  image?: Maybe<ImageType>
  learningFeatureCount: Scalars['Int']
  level: Array<CEFRLevel>
  name: Scalars['String']
  sourceLanguage: Language
  subject: Subject
  units: Array<LibraryItemCollection>
}

export type BreakCardSimpleText = FlashCardV2 & {
  __typename?: 'BreakCardSimpleText'
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type BugReport = {
  __typename?: 'BugReport'
  createdDate: Scalars['DateTime']
  externalId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  message?: Maybe<Scalars['String']>
  resolvedDate?: Maybe<Scalars['DateTime']>
  type: BugReportMessageType
}

export type BugReportMessageInput = {
  context: Scalars['String']
  message: Scalars['String']
  type: BugReportMessageType
}

export enum BugReportMessageType {
  BUG = 'BUG',
  SUGGESTION = 'SUGGESTION'
}

export enum CEFRLevel {
  A0 = 'A0',
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2'
}

export type Classroom = {
  __typename?: 'Classroom'
  color?: Maybe<Scalars['String']>
  endOfYear: Scalars['Date']
  enforcePinLogin: Scalars['Boolean']
  id: Scalars['ID']
  identificator: Scalars['String']
  isReadyToMigrate: Scalars['Boolean']
  isSetupComplete: Scalars['Boolean']
  name: Scalars['String']
  pictureId?: Maybe<Scalars['String']>
  showSubjectIcon: Scalars['Boolean']
  startOfYear: Scalars['Date']
  subject: Subject
  timeZone: Scalars['String']
  weekStart: WeekStart
}

export type ClassroomInput = {
  bookId?: InputMaybe<Scalars['ID']>
  color?: InputMaybe<Scalars['String']>
  endOfYear?: InputMaybe<Scalars['Date']>
  enforcePinLogin?: InputMaybe<Scalars['Boolean']>
  identificator?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  pictureId?: InputMaybe<Scalars['String']>
  showSubjectIcon?: InputMaybe<Scalars['Boolean']>
  startOfYear?: InputMaybe<Scalars['Date']>
  subject: Subject
  timeZone?: InputMaybe<Scalars['String']>
  weekStart?: InputMaybe<WeekStart>
}

export type ClassroomLogin = {
  __typename?: 'ClassroomLogin'
  classroomLoginCode: ClassroomLoginCode
  students: Array<UserProfile>
}

export type ClassroomLoginCode = {
  __typename?: 'ClassroomLoginCode'
  classroomId: Scalars['ID']
  classroomLoginCode: Scalars['String']
  expirationTime: Scalars['DateTime']
}

export type CommonMistake = {
  __typename?: 'CommonMistake'
  learningFeature: LearningFeatureTranslationV2
  mistakeCount: Scalars['Int']
}

export type CompletedLearningExecution = {
  __typename?: 'CompletedLearningExecution'
  answers: Array<FlashCardAnswer>
  classRank: Scalars['Int']
  learningExecution: LearningExecution
  studentCount: Scalars['Int']
  studyTimeSeconds: Scalars['Int']
  summary?: Maybe<Scalars['String']>
  timestamp: Scalars['DateTime']
  totalSkippedCount: Scalars['Int']
}

export type ComposedFlashCard = FlashCard & {
  __typename?: 'ComposedFlashCard'
  assignedLearningFeatures: Array<LearningFeatureTranslationV2>
  flashCardAssignmentType: FlashCardAssignmentType
  flashCardLexicalType: FlashCardLexicalType
  flashCardResponseType: FlashCardResponseType
  id: Scalars['ID']
  learningExecutionProgress: Scalars['Int']
  learningExecutionState: LearningExecutionState
  responseLearningFeatures: Array<LearningFeatureTranslationV2>
  subjectLanguage: Language
  totalPoints: Scalars['Int']
}

export enum ConversationRole {
  ASSISTANT = 'ASSISTANT',
  USER = 'USER'
}

export enum Device {
  MOBILE = 'MOBILE',
  PRINTER = 'PRINTER',
  PROJECTOR = 'PROJECTOR',
  TABLET = 'TABLET'
}

export enum Difficulty {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MIDDLE = 'MIDDLE'
}

export type ExecutionExitInput = {
  elapsedTimeMilliseconds: Scalars['Int']
  enforceStatus?: InputMaybe<LearningExecutionState>
  learningExecutionId: Scalars['ID']
}

export type FlashCard = {
  id: Scalars['ID']
  learningExecutionProgress: Scalars['Int']
  learningExecutionState: LearningExecutionState
  totalPoints: Scalars['Int']
}

export type FlashCardAnswer = {
  __typename?: 'FlashCardAnswer'
  flashCardAssignmentType?: Maybe<FlashCardAssignmentType>
  flashCardFullScreenType?: Maybe<FullScreenFlashCardType>
  flashCardId: Scalars['ID']
  flashCardResponseType?: Maybe<FlashCardResponseType>
  points: Scalars['Int']
  skipCount: Scalars['Int']
  userAnswers: Array<UserAnswer>
}

export enum FlashCardAssignmentType {
  IMAGE = 'IMAGE',
  SOUND = 'SOUND',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO'
}

export type FlashCardChooseV2 = FlashCardV2 & {
  __typename?: 'FlashCardChooseV2'
  assignment: FlashCardSimpleAssignment
  flashCardId: Scalars['ID']
  options: Array<FlashCardSimpleAssignment>
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardConnectionAssignmentV2 = {
  __typename?: 'FlashCardConnectionAssignmentV2'
  from: FlashCardSimpleAssignment
  to: FlashCardSimpleAssignment
}

export type FlashCardConnectionV2 = FlashCardV2 & {
  __typename?: 'FlashCardConnectionV2'
  assignments: Array<FlashCardConnectionAssignmentV2>
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardGapFillAssignment = {
  __typename?: 'FlashCardGapFillAssignment'
  assignmentId: Scalars['ID']
  content: Array<FlashCardGapFillContentAssignment>
  items: Array<FlashCardGapFillItemAssignment>
  target: Scalars['String']
  type: Scalars['String']
}

export type FlashCardGapFillClozeBankSentencesV2 = FlashCardV2 & {
  __typename?: 'FlashCardGapFillClozeBankSentencesV2'
  assignments: Array<FlashCardGapFillAssignment>
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardGapFillContentAssignment = {
  __typename?: 'FlashCardGapFillContentAssignment'
  originalText: Scalars['String']
  person?: Maybe<Scalars['String']>
  soundUrl?: Maybe<Scalars['String']>
  template: Scalars['String']
}

export type FlashCardGapFillItemAssignment = {
  __typename?: 'FlashCardGapFillItemAssignment'
  correctOptions: Array<Scalars['String']>
  hints: Array<Scalars['String']>
  incorrectOptions: Array<Scalars['String']>
  index: Scalars['Int']
}

export type FlashCardGapFillOpenV2 = FlashCardV2 & {
  __typename?: 'FlashCardGapFillOpenV2'
  assignment: FlashCardGapFillAssignment
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardGapFillOptionsDialogueMiniV2 = FlashCardV2 & {
  __typename?: 'FlashCardGapFillOptionsDialogueMiniV2'
  assignments: Array<FlashCardGapFillAssignment>
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardGapFillOptionsSentencesV2 = FlashCardV2 & {
  __typename?: 'FlashCardGapFillOptionsSentencesV2'
  assignments: Array<FlashCardGapFillAssignment>
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardGapFillResponse = {
  asText: Array<Scalars['String']>
  assignmentId: Scalars['ID']
}

export enum FlashCardLexicalType {
  ANTONYM = 'ANTONYM',
  DEFINITION = 'DEFINITION',
  SYNONYM = 'SYNONYM',
  TRANSLATION = 'TRANSLATION'
}

export type FlashCardPairResponse = {
  from: FlashCardSimpleResponse
  to: FlashCardSimpleResponse
}

export enum FlashCardResponseType {
  CHOICE_IMAGE = 'CHOICE_IMAGE',
  CHOICE_TEXT = 'CHOICE_TEXT',
  SCRABBLE = 'SCRABBLE',
  SOUND = 'SOUND',
  TEXT = 'TEXT',
  WORD_PICKING = 'WORD_PICKING'
}

export type FlashCardScrabbleV2 = FlashCardV2 & {
  __typename?: 'FlashCardScrabbleV2'
  assignment: FlashCardSimpleAssignment
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardSimpleAssignment = {
  __typename?: 'FlashCardSimpleAssignment'
  assignmentId: Scalars['ID']
  fullscreenImage?: Maybe<ImageType>
  fullscreenVideo?: Maybe<VideoType>
  language: Language
  soundUrl?: Maybe<Scalars['String']>
  talkingHeadUrl?: Maybe<Scalars['String']>
  text: Scalars['String']
  transparentImage?: Maybe<ImageType>
}

export type FlashCardSimpleResponse = {
  answerText?: InputMaybe<Scalars['String']>
  assignmentId: Scalars['ID']
  language: Language
}

export type FlashCardSpeakingResponse = {
  asText: Scalars['String']
  assignmentId: Scalars['ID']
  language: Language
  pronunciation?: InputMaybe<PronunciationInput>
}

export type FlashCardSpeakingV2 = FlashCardV2 & {
  __typename?: 'FlashCardSpeakingV2'
  assignment: FlashCardSimpleAssignment
  expectedResponse: FlashCardSimpleAssignment
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardTransformationAssignment = {
  __typename?: 'FlashCardTransformationAssignment'
  assignmentId: Scalars['ID']
  correctOptions: Array<Scalars['String']>
  originalText: Scalars['String']
  soundUrl?: Maybe<Scalars['String']>
  target: Scalars['String']
  template: Scalars['String']
}

export type FlashCardTransformationResponse = {
  asText: Scalars['String']
  assignmentId: Scalars['ID']
}

export type FlashCardTransformationSentenceV2 = FlashCardV2 & {
  __typename?: 'FlashCardTransformationSentenceV2'
  assignment: FlashCardTransformationAssignment
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardTransformationSpeakingV2 = FlashCardV2 & {
  __typename?: 'FlashCardTransformationSpeakingV2'
  assignment: FlashCardTransformationAssignment
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export enum FlashCardTypeV2 {
  BREAK_CARD_TEXT = 'BREAK_CARD_TEXT',
  CHOOSE = 'CHOOSE',
  CONNECTION = 'CONNECTION',
  GAPFILL_CLOZE_BANK_SENTENCES = 'GAPFILL_CLOZE_BANK_SENTENCES',
  GAPFILL_OPEN = 'GAPFILL_OPEN',
  GAPFILL_OPTIONS_DIALOGUE_MINI = 'GAPFILL_OPTIONS_DIALOGUE_MINI',
  GAPFILL_OPTIONS_SENTENCES = 'GAPFILL_OPTIONS_SENTENCES',
  SCRABBLE = 'SCRABBLE',
  SPEAKING_PRONUNCIATION = 'SPEAKING_PRONUNCIATION',
  SPEAKING_TRANSLATION = 'SPEAKING_TRANSLATION',
  TRANSFORMATION_SENTENCE = 'TRANSFORMATION_SENTENCE',
  TRANSFORMATION_SPEAKING = 'TRANSFORMATION_SPEAKING',
  UNSCRAMBLE = 'UNSCRAMBLE',
  WORD_PICKING = 'WORD_PICKING'
}

export type FlashCardV2 = {
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FlashCardWordPickingV2 = FlashCardV2 & {
  __typename?: 'FlashCardWordPickingV2'
  assignment: FlashCardSimpleAssignment
  flashCardId: Scalars['ID']
  skills: Array<Skill>
  title: Scalars['String']
  type: FlashCardTypeV2
}

export type FrequentMistakes = {
  __typename?: 'FrequentMistakes'
  learningFeature: LearningFeatureTranslationV2
  mistakeCount: Scalars['Int']
}

export type FullScreenFlashCard = FlashCard & {
  __typename?: 'FullScreenFlashCard'
  assignedLearningFeatures: Array<LearningFeatureTranslationV2>
  flashCardLexicalType: FlashCardLexicalType
  fullScreenFlashCardType: FullScreenFlashCardType
  id: Scalars['ID']
  learningExecutionProgress: Scalars['Int']
  learningExecutionState: LearningExecutionState
  responseLearningFeatures: Array<LearningFeatureTranslationV2>
  subjectLanguage: Language
  totalPoints: Scalars['Int']
}

export enum FullScreenFlashCardType {
  BALLOONS = 'BALLOONS',
  SHOPPING_CART = 'SHOPPING_CART',
  SOUND_TO_TEXT_CONNECTION = 'SOUND_TO_TEXT_CONNECTION',
  TEXT_TO_IMAGE_CONNECTION = 'TEXT_TO_IMAGE_CONNECTION',
  TEXT_TO_TEXT_CONNECTION = 'TEXT_TO_TEXT_CONNECTION',
  WHEEL_OF_FORTUNE_IMAGE = 'WHEEL_OF_FORTUNE_IMAGE',
  WHEEL_OF_FORTUNE_TEXT = 'WHEEL_OF_FORTUNE_TEXT'
}

export enum GQLWorksheetLexicalType {
  ANTONYMS = 'ANTONYMS',
  DEFINITIONS = 'DEFINITIONS',
  SYNONYMS = 'SYNONYMS',
  TRANSLATIONS = 'TRANSLATIONS'
}

export enum GQLWorksheetType {
  MATCH_ELEMENTS = 'MATCH_ELEMENTS',
  ONE_TO_MANY = 'ONE_TO_MANY',
  PUZZLE = 'PUZZLE'
}

export type GameProperties = {
  __typename?: 'GameProperties'
  coverStyle?: Maybe<Scalars['String']>
  huntwordsAllDirections?: Maybe<Scalars['Boolean']>
  isSoundEnabled?: Maybe<Scalars['Boolean']>
  questionCount?: Maybe<Scalars['Int']>
  wheelOfFortuneType?: Maybe<WheelOfFortuneType>
  worksheetLexicalType?: Maybe<Scalars['String']>
}

export type GamePropertiesInput = {
  coverStyle?: InputMaybe<Scalars['String']>
  huntwordsAllDirections?: InputMaybe<Scalars['Boolean']>
  isSoundEnabled?: InputMaybe<Scalars['Boolean']>
  questionCount?: InputMaybe<Scalars['Int']>
  wheelOfFortuneType?: InputMaybe<WheelOfFortuneType>
  worksheetLexicalType?: InputMaybe<Scalars['String']>
}

export type ImageIdInput = {
  commonName: Scalars['String']
  namespace: Scalars['String']
}

export type ImageIdType = {
  __typename?: 'ImageIdType'
  commonName: Scalars['String']
  namespace: Scalars['String']
}

export type ImageType = {
  __typename?: 'ImageType'
  default: Scalars['String']
  imageId?: Maybe<ImageIdType>
  large?: Maybe<Scalars['String']>
  medium?: Maybe<Scalars['String']>
  small?: Maybe<Scalars['String']>
  thumbnail?: Maybe<Scalars['String']>
}

export type ImageVerificationInput = {
  imageUrl: Scalars['String']
  isGood: Scalars['Boolean']
  learningFeatureId: Scalars['ID']
}

export type ImageVerificationType = {
  __typename?: 'ImageVerificationType'
  imageUrl: Scalars['String']
  learningFeatureId: Scalars['ID']
  sourceLanguage: Scalars['String']
  sourceLanguageText: Scalars['String']
  targetLanguage: Scalars['String']
  targetLanguageText: Scalars['String']
}

export type InfoFlashCard = FlashCard & {
  __typename?: 'InfoFlashCard'
  id: Scalars['ID']
  informationType: InformationFlashCardType
  learningExecutionProgress: Scalars['Int']
  learningExecutionState: LearningExecutionState
  totalPoints: Scalars['Int']
}

export enum InformationFlashCardType {
  LISTENING = 'LISTENING',
  MISTAKES = 'MISTAKES',
  PROGRESS = 'PROGRESS',
  READING = 'READING',
  SPEAKING = 'SPEAKING',
  WRITING = 'WRITING'
}

export enum InteractionType {
  LISTENING = 'LISTENING',
  SPEAKING = 'SPEAKING'
}

export enum Language {
  CZECH = 'CZECH',
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  ITALIAN = 'ITALIAN',
  SPANISH = 'SPANISH'
}

export type LearningActivitiesSearchInput = {
  activityStates: Array<LearningActivityState>
  activityTypes: Array<ActivityType>
  assignmentModes: Array<AssignmentMode>
  classroomIds: Array<Scalars['ID']>
  textSearch?: InputMaybe<Scalars['String']>
}

export type LearningActivity = {
  __typename?: 'LearningActivity'
  activityType: ActivityType
  assignmentMode: AssignmentMode
  contentSourceLabel?: Maybe<Scalars['String']>
  estimatedTimeInSeconds: Scalars['Int']
  executions?: Maybe<Array<LearningExecution>>
  gameProperties?: Maybe<GameProperties>
  id: Scalars['ID']
  learningActivityExecutionId?: Maybe<Scalars['ID']>
  learningFeatureCount: Scalars['Int']
  learningFeatures: Array<LearningFeatureV2>
  name: Scalars['String']
  progress?: Maybe<LearningActivityProgress>
  skills: Array<LearningActivitySkill>
  state: LearningActivityState
  subject: Subject
  timeLimitSeconds?: Maybe<Scalars['Int']>
}

export type LearningActivityInput = {
  activityType?: InputMaybe<ActivityType>
  assignmentMode?: InputMaybe<AssignmentMode>
  contentSourceLabel?: InputMaybe<Scalars['String']>
  deadline?: InputMaybe<Scalars['DateTime']>
  gameProperties?: InputMaybe<GamePropertiesInput>
  learningFeatureFilter?: InputMaybe<Array<LearningFeatureType>>
  learningFeatures?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  skills?: InputMaybe<Array<LearningActivitySkillInput>>
  studentIds?: InputMaybe<Array<Scalars['ID']>>
  timeLimitSeconds?: InputMaybe<Scalars['Int']>
}

export type LearningActivityParticipantResult = {
  __typename?: 'LearningActivityParticipantResult'
  answers: Array<FlashCardAnswer>
  correctAnswers?: Maybe<Scalars['Int']>
  interactions?: Maybe<Scalars['Int']>
  interventionNeeded: Scalars['Boolean']
  learningActivityId: Scalars['ID']
  participant: Participant
  points?: Maybe<Scalars['Int']>
  progress?: Maybe<Scalars['Int']>
  successMeasure?: Maybe<Scalars['Int']>
  totalAnswers?: Maybe<Scalars['Int']>
}

export type LearningActivityProgress = {
  __typename?: 'LearningActivityProgress'
  deadline?: Maybe<Scalars['DateTime']>
  progress?: Maybe<Scalars['Int']>
  total?: Maybe<Scalars['Int']>
  type?: Maybe<LearningActivityProgressType>
}

export enum LearningActivityProgressType {
  COUNT = 'COUNT',
  PERCENTAGE = 'PERCENTAGE',
  TIME_IN_SECONDS = 'TIME_IN_SECONDS'
}

export type LearningActivityResult = {
  __typename?: 'LearningActivityResult'
  frequentMistakes: Array<FrequentMistakes>
  learningActivityId: Scalars['ID']
  participantResults: Array<LearningActivityParticipantResult>
  skillResults: Array<LearningActivitySkillResult>
  timestamp: Scalars['DateTime']
}

export type LearningActivitySkill = {
  __typename?: 'LearningActivitySkill'
  isActive: Scalars['Boolean']
  skill: Skill
}

export type LearningActivitySkillInput = {
  isActive: Scalars['Boolean']
  skill: Skill
}

export type LearningActivitySkillResult = {
  __typename?: 'LearningActivitySkillResult'
  skill: UserStatisticsSkills
  successMeasure: Scalars['Int']
}

export enum LearningActivityState {
  EXPIRED = 'EXPIRED',
  FINISHED = 'FINISHED',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING = 'WAITING'
}

export type LearningAssignment = {
  __typename?: 'LearningAssignment'
  activityType: ActivityType
  assignedByTeacher?: Maybe<Scalars['Boolean']>
  assignmentMode: AssignmentMode
  averageSuccessMeasure?: Maybe<Scalars['Int']>
  contentSourceLabel?: Maybe<Scalars['String']>
  difficulty: Difficulty
  endDateAndTime?: Maybe<Scalars['DateTime']>
  executions: Array<LearningExecution>
  gameProperties?: Maybe<GameProperties>
  id: Scalars['ID']
  image?: Maybe<ImageType>
  imageURL?: Maybe<Scalars['String']>
  learningFeatureCount: Scalars['Int']
  learningFeatures: Array<LearningFeatureV2>
  level: CEFRLevel
  name: Scalars['String']
  notes?: Maybe<Scalars['String']>
  skills: Array<Skill>
  startDateAndTime: Scalars['DateTime']
  state: LearningAssignmentState
  studentsCount?: Maybe<Scalars['Int']>
  subject: Subject
  submissionCount?: Maybe<Scalars['Int']>
  timeLimitSeconds?: Maybe<Scalars['Int']>
}

export enum LearningAssignmentState {
  CONCEPT = 'CONCEPT',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  FINISHED = 'FINISHED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type LearningExecution = {
  __typename?: 'LearningExecution'
  id: Scalars['ID']
  learningAssignment: LearningAssignment
  name: Scalars['String']
  progress: Scalars['Int']
  remainingTimeSeconds?: Maybe<Scalars['Int']>
  state: LearningExecutionState
  student: Student
  successMeasure: Scalars['Int']
}

export enum LearningExecutionState {
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  FINISHED = 'FINISHED',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING = 'WAITING'
}

export type LearningExecutionStatistics = {
  __typename?: 'LearningExecutionStatistics'
  learningFeatureCount: Scalars['Int']
  progress: Scalars['Int']
  successMeasure: Scalars['Int']
  successfulLearningFeatureCount: Scalars['Int']
  totalSkippedCount: Scalars['Int']
}

export type LearningExecutionStatisticsInput = {
  endDateTime: Scalars['DateTime']
  learningExecutionId: Scalars['ID']
  learningTimeSeconds: Scalars['Int']
}

export enum LearningFeatureDirection {
  SOURCE = 'SOURCE',
  SOURCE_TARGET = 'SOURCE_TARGET',
  TARGET = 'TARGET',
  TARGET_SOURCE = 'TARGET_SOURCE'
}

export type LearningFeatureGrammarExample = {
  __typename?: 'LearningFeatureGrammarExample'
  fullText: Scalars['String']
  template: Scalars['String']
}

export type LearningFeatureGrammarV2 = LearningFeatureV2 & {
  __typename?: 'LearningFeatureGrammarV2'
  countGapFill: Scalars['Int']
  countTransformation: Scalars['Int']
  example: LearningFeatureGrammarExample
  id: Scalars['ID']
  level: CEFRLevel
  name: Scalars['String']
  origin: LearningFeatureOrigin
  subtitle: Scalars['String']
  targetLanguage: Language
  type: LearningFeatureType
}

export enum LearningFeatureOrigin {
  BOOK = 'BOOK',
  CATALOGUE = 'CATALOGUE',
  USER = 'USER'
}

export enum LearningFeatureState {
  CONFIRMED = 'CONFIRMED',
  CRITICAL = 'CRITICAL',
  MASTERED = 'MASTERED',
  PROGRESSING = 'PROGRESSING',
  REVISED = 'REVISED'
}

export type LearningFeatureTranslationV2 = LearningFeatureV2 & {
  __typename?: 'LearningFeatureTranslationV2'
  fullscreenImages: Array<ImageType>
  fullscreenVideo: Array<VideoType>
  hasAntonyms: Scalars['Boolean']
  hasCompletions: Scalars['Boolean']
  hasDefinitions: Scalars['Boolean']
  hasSynonyms: Scalars['Boolean']
  id: Scalars['ID']
  images: Array<ImageType>
  level?: Maybe<CEFRLevel>
  origin: LearningFeatureOrigin
  sourceLanguage: Language
  sourceLanguageText: Scalars['String']
  sourceSoundUrls: Array<Scalars['String']>
  sourceVideoUrls: Array<Scalars['String']>
  targetLanguage: Language
  targetLanguageText: Scalars['String']
  targetSoundUrls: Array<Scalars['String']>
  targetVideoUrls: Array<Scalars['String']>
  type: LearningFeatureType
}

export enum LearningFeatureType {
  GRAMMAR = 'GRAMMAR',
  MULTIWORD_EXPRESSION = 'MULTIWORD_EXPRESSION',
  SENTENCE = 'SENTENCE',
  WORD = 'WORD'
}

export type LearningFeatureV2 = {
  id: Scalars['ID']
  origin: LearningFeatureOrigin
  type: LearningFeatureType
}

export type LearningPlan = {
  __typename?: 'LearningPlan'
  book?: Maybe<Book>
  color?: Maybe<Scalars['String']>
  extendLessons: Scalars['Boolean']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isArchived: Scalars['Boolean']
  title: Scalars['String']
  unitNaming: Scalars['String']
  unitNumbering: NumberingType
}

export type LearningPlanInput = {
  bookId?: InputMaybe<Scalars['ID']>
  color?: InputMaybe<Scalars['String']>
  extendLessons?: InputMaybe<Scalars['Boolean']>
  isActive?: InputMaybe<Scalars['Boolean']>
  title?: InputMaybe<Scalars['String']>
  unitNaming?: InputMaybe<Scalars['String']>
  unitNumbering?: InputMaybe<NumberingType>
}

export type LearningPlanPageActivity = {
  __typename?: 'LearningPlanPageActivity'
  endMinute: Scalars['Int']
  id: Scalars['ID']
  startMinute: Scalars['Int']
}

export type LearningPlanPageCategory = {
  __typename?: 'LearningPlanPageCategory'
  archivedPageCount: Scalars['Int']
  categoryType: LearningPlanPageCategoryType
  finishedPageCount: Scalars['Int']
  id: Scalars['ID']
  image?: Maybe<ImageType>
  isArchived: Scalars['Boolean']
  name: Scalars['String']
  pageCount: Scalars['Int']
  previousCategoryId?: Maybe<Scalars['ID']>
}

export type LearningPlanPageCategoryInput = {
  isFinished?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  previousCategory?: InputMaybe<LinkedListInput>
}

export enum LearningPlanPageCategoryType {
  FOXINO = 'FOXINO',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export type LearningPlanPageInputV2 = {
  isFinished?: InputMaybe<Scalars['Boolean']>
  learningFeatures?: InputMaybe<Array<LearningPlanPageLfInputV2>>
  title?: InputMaybe<Scalars['String']>
}

export type LearningPlanPageLfInputV2 = {
  id: Scalars['ID']
  isDisabled: Scalars['Boolean']
  origin: LearningFeatureOrigin
  originId?: InputMaybe<Scalars['ID']>
}

export type LearningPlanPageStream = {
  __typename?: 'LearningPlanPageStream'
  blocks: Array<LessonBlock>
  id: Scalars['ID']
  name: Scalars['String']
}

export type LearningPlanPageStreamInput = {
  blockOrder?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
}

export type LearningPlanPageV2 = {
  __typename?: 'LearningPlanPageV2'
  canBeExtended: Scalars['Boolean']
  category: LearningPlanPageCategory
  disabledLearningFeatures: Array<Scalars['ID']>
  id: Scalars['ID']
  isArchived: Scalars['Boolean']
  isFinished: Scalars['Boolean']
  isGenerated: Scalars['Boolean']
  learningFeatureCount: Scalars['Int']
  learningFeatures: Array<LearningFeatureV2>
  learningPlanId: Scalars['ID']
  nextPageId?: Maybe<Scalars['ID']>
  previousPageId?: Maybe<Scalars['ID']>
  streams: Array<LearningPlanPageStream>
  title: Scalars['String']
}

export type LearningPlanPageV2LearningFeaturesArgs = {
  preview: Scalars['Boolean']
}

export type LessonBlock = {
  id: Scalars['ID']
  isPresentable: Scalars['Boolean']
  name: Scalars['String']
  streamId: Scalars['ID']
  type: LessonBlockType
}

export type LessonBlockActivity = LessonBlock & {
  __typename?: 'LessonBlockActivity'
  activity: LearningActivity
  id: Scalars['ID']
  isPresentable: Scalars['Boolean']
  name: Scalars['String']
  streamId: Scalars['ID']
  type: LessonBlockType
}

export type LessonBlockBookOrientation = LessonBlock & {
  __typename?: 'LessonBlockBookOrientation'
  book?: Maybe<Book>
  id: Scalars['ID']
  isPresentable: Scalars['Boolean']
  name: Scalars['String']
  pageFrom: Scalars['Int']
  pageTo: Scalars['Int']
  streamId: Scalars['ID']
  type: LessonBlockType
}

export type LessonBlockBookOrientationInput = {
  bookId?: InputMaybe<Scalars['ID']>
  pageFrom: Scalars['Int']
  pageTo: Scalars['Int']
}

export type LessonBlockContent = LessonBlock & {
  __typename?: 'LessonBlockContent'
  id: Scalars['ID']
  isPresentable: Scalars['Boolean']
  learningFeatures: Array<LearningFeatureV2>
  name: Scalars['String']
  streamId: Scalars['ID']
  type: LessonBlockType
}

export type LessonBlockFreeText = LessonBlock & {
  __typename?: 'LessonBlockFreeText'
  content: Scalars['String']
  id: Scalars['ID']
  isPresentable: Scalars['Boolean']
  name: Scalars['String']
  streamId: Scalars['ID']
  type: LessonBlockType
}

export type LessonBlockImages = LessonBlock & {
  __typename?: 'LessonBlockImages'
  description: Scalars['String']
  id: Scalars['ID']
  images?: Maybe<Array<BlockAsset>>
  isPresentable: Scalars['Boolean']
  name: Scalars['String']
  streamId: Scalars['ID']
  type: LessonBlockType
}

export type LessonBlockInput = {
  activity?: InputMaybe<LearningActivityInput>
  bookOrientation?: InputMaybe<LessonBlockBookOrientationInput>
  freeText?: InputMaybe<Scalars['String']>
  images?: InputMaybe<Array<BlockAssetInput>>
  isPresentable: Scalars['Boolean']
  mistakes?: InputMaybe<Array<LessonBlockMistakesInput>>
  name: Scalars['String']
  type: LessonBlockType
  videos?: InputMaybe<Array<BlockAssetInput>>
}

export type LessonBlockMistakes = LessonBlock & {
  __typename?: 'LessonBlockMistakes'
  id: Scalars['ID']
  isPresentable: Scalars['Boolean']
  mistakeCount: Scalars['Int']
  mistakes: Array<Mistake>
  name: Scalars['String']
  streamId: Scalars['ID']
  type: LessonBlockType
}

export type LessonBlockMistakesInput = {
  correctAnswer?: InputMaybe<Scalars['String']>
  explanation?: InputMaybe<Scalars['String']>
  learningFeatureId?: InputMaybe<Scalars['ID']>
  textWithMistake?: InputMaybe<Scalars['String']>
  wrongPart?: InputMaybe<Scalars['String']>
}

export enum LessonBlockType {
  ACTIVITY = 'ACTIVITY',
  BOOK_ORIENTATION = 'BOOK_ORIENTATION',
  CONTENT = 'CONTENT',
  FREE_TEXT = 'FREE_TEXT',
  GOALS = 'GOALS',
  IMAGES = 'IMAGES',
  MISTAKES = 'MISTAKES',
  VIDEOS = 'VIDEOS'
}

export type LessonBlockVideos = LessonBlock & {
  __typename?: 'LessonBlockVideos'
  description: Scalars['String']
  id: Scalars['ID']
  isPresentable: Scalars['Boolean']
  name: Scalars['String']
  streamId: Scalars['ID']
  type: LessonBlockType
  videos?: Maybe<Array<BlockAsset>>
}

export type LibraryBooks = {
  __typename?: 'LibraryBooks'
  books: Array<Book>
  filters: LibraryItemsFilter
}

export type LibraryCollections = {
  __typename?: 'LibraryCollections'
  collections: Array<LibraryItemCollection>
  filters: LibraryItemsFilter
}

export type LibraryGrammarPackages = {
  __typename?: 'LibraryGrammarPackages'
  filters: LibraryItemsFilter
  packages: Array<LibraryItemPackage>
}

export type LibraryItemCollection = {
  __typename?: 'LibraryItemCollection'
  id: Scalars['ID']
  image?: Maybe<ImageType>
  label?: Maybe<Scalars['String']>
  level: Array<CEFRLevel>
  name: Scalars['String']
  packages: Array<LibraryItemPackage>
  packagesCount: Scalars['Int']
  type: LibraryItemType
}

export type LibraryItemPackage = {
  __typename?: 'LibraryItemPackage'
  borderColor?: Maybe<Scalars['String']>
  createdBy?: Maybe<UserProfile>
  foxinoOwned: Scalars['Boolean']
  id: Scalars['ID']
  image?: Maybe<ImageType>
  label?: Maybe<Scalars['String']>
  learningFeatures: Array<LearningFeatureV2>
  learningFeaturesCount: Scalars['Int']
  level: Array<CEFRLevel>
  name: Scalars['String']
  origin: LibraryItemPackageOrigin
}

export type LibraryItemPackageInput = {
  borderColor?: InputMaybe<Scalars['String']>
  imageId?: InputMaybe<ImageIdInput>
  label?: InputMaybe<Scalars['String']>
  learningFeatures?: InputMaybe<Array<Scalars['ID']>>
  level?: InputMaybe<Array<CEFRLevel>>
  name: Scalars['String']
}

export enum LibraryItemPackageOrigin {
  BOOK = 'BOOK',
  PACKAGE = 'PACKAGE',
  USER_PACKAGE = 'USER_PACKAGE'
}

export enum LibraryItemType {
  COLLECTION = 'COLLECTION',
  PACKAGE = 'PACKAGE'
}

export type LibraryItemsFilter = {
  __typename?: 'LibraryItemsFilter'
  level?: Maybe<Array<Maybe<CEFRLevel>>>
  searchText?: Maybe<Scalars['String']>
  tags?: Maybe<Array<Scalars['String']>>
}

export type LibraryItemsFilterInput = {
  level?: InputMaybe<Array<InputMaybe<CEFRLevel>>>
  searchText?: InputMaybe<Scalars['String']>
  subject: Subject
  tags?: InputMaybe<Array<Scalars['String']>>
}

export type LibraryMyContent = {
  __typename?: 'LibraryMyContent'
  filters: LibraryItemsFilter
  myContent: Array<LibraryItemPackage>
}

export type LibraryPackages = {
  __typename?: 'LibraryPackages'
  filters: LibraryItemsFilter
  packages: Array<LibraryItemPackage>
}

export type LinkedListInput = {
  newPreviousId: Scalars['ID']
  oldPreviousId: Scalars['ID']
}

export type LipSync = {
  __typename?: 'LipSync'
  duration: Scalars['Float']
  mouthCues: Array<MouthCue>
}

export enum LoginStudentTeacherStatus {
  APPROVED = 'APPROVED',
  NOT_REQUESTED = 'NOT_REQUESTED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}

export type LoginStudentTeacherUserStatus = {
  __typename?: 'LoginStudentTeacherUserStatus'
  status: LoginStudentTeacherStatus
  student: Student
}

export type LoginToken = {
  __typename?: 'LoginToken'
  accessToken?: Maybe<Scalars['String']>
  classroomLoginCode?: Maybe<ClassroomLoginCode>
  refreshToken?: Maybe<Scalars['String']>
  studentId: Scalars['ID']
}

export type Mistake = {
  __typename?: 'Mistake'
  correctAnswer: Scalars['String']
  explanation?: Maybe<Scalars['String']>
  learningFeature?: Maybe<LearningFeatureV2>
  name: Scalars['String']
  textWithMistake: Scalars['String']
  wrongPart: Scalars['String']
}

export type MouthCue = {
  __typename?: 'MouthCue'
  end: Scalars['Float']
  start: Scalars['Float']
  value: Scalars['String']
}

export type Mutation = {
  __typename?: 'Mutation'
  addActivityToFavorites: Scalars['Boolean']
  addMeToClassroom: Scalars['Boolean']
  addUserLearningFeature: LearningFeatureTranslationV2
  addUserRole: Scalars['Boolean']
  answerQuizQuestion: Scalars['Boolean']
  avatarConversationChat: AvatarSendActionsResponse
  avatarNextScenarioActions: AvatarSendActionsResponse
  avatarRephrase: AvatarRephraseResponse
  avatarStartConversation: AvatarSendActionsResponse
  avatarStartScenario: AvatarSendActionsResponse
  avatarTranslate: AvatarTranslationResponse
  bugReport: Scalars['ID']
  confirmReleaseNotes: Scalars['Boolean']
  createClassroom: Classroom
  createLearningActivityV2: LearningActivity
  createLearningPlan: LearningPlan
  createLearningPlanPageCategory: LearningPlanPageCategory
  createLearningPlanPageFromLessons: LearningPlanPageV2
  createLearningPlanPageStream: LearningPlanPageStream
  createLearningPlanPageV2: LearningPlanPageV2
  createLearningPlanPagesFromLearnings: Scalars['Boolean']
  createLessonBlock: LessonBlock
  /**
   * Create package in My Content.
   *  - packageId == null -> just create it from the input
   *  - packageId != null -> snapshot the package but use the input for name, etc.
   */
  createLibraryItemPackage: LibraryItemPackage
  deleteClassroom: Scalars['Boolean']
  deleteLearningActivity: Scalars['Boolean']
  deleteLearningPlan: Scalars['Boolean']
  deleteLearningPlanPage: Scalars['Boolean']
  deleteLearningPlanPageCategory: Scalars['Boolean']
  deleteLearningPlanPageStream: Scalars['Boolean']
  deleteLessonBlock: Scalars['Boolean']
  /** It is allowed just My Content - error in case of deletion of Foxino content */
  deleteLibraryItem: Scalars['Boolean']
  deleteUserLearningFeature: Scalars['Boolean']
  duplicateLearningActivity: LearningActivity
  /**
   * pageId: page to copy
   * targetLearningPlanId: target learning plan where the page will be created.
   *   It will just copy page in the same classroom learning plan and category if `null` is passed.
   *
   * The new page will be created:
   *  - new uncategorized category will be created and page will be added there, if uncategorized exists
   *  - then the page will be added at the beginning of the category
   */
  duplicateLearningPlanPages: Array<Scalars['ID']>
  editClassroom: Classroom
  extendLearningPlanPageContent: Array<LearningFeatureV2>
  joinQuizGame: QuizGame
  leaveQuizGame: Scalars['Boolean']
  /**
   * Student platform calls this API to enable the feature allowing
   * teacher to confirm student login on his behalf.
   */
  loginStudentEnableTeacherVerification: Scalars['Boolean']
  /** Teacher platform sends verification that teacher confirmed the user. */
  loginStudentVerifyByTeacher: Scalars['Boolean']
  migrateClassroom?: Maybe<Classroom>
  nextQuizQuestion: Scalars['Boolean']
  processExecutionExit: Scalars['Boolean']
  processLearningExecutionStatistics: LearningExecutionStatistics
  processStudentInteraction: ResponseInteraction
  processStudentInteractionV2: ResponseInteractionV2
  removeActivityFromFavorites: Scalars['Boolean']
  removeStudentFromClass: Scalars['Boolean']
  /**
   * It will create a new learning execution as a clone of the ID provided.
   * The new execution ID is returned.
   * The new execution instance will start with a 0% progress.
   */
  repeatLearningExecution: Scalars['ID']
  reportBugInLearningFeature: Scalars['ID']
  saveImageVerification?: Maybe<Scalars['Boolean']>
  /** Unified mutation for saving game editor configurations. */
  saveQuizBasedGameConfiguration: Scalars['Boolean']
  startLearningActivity: LearningActivity
  startQuizGame: QuizGame
  startStudentLibrarySubPackage: Scalars['ID']
  stopLearningActivity: LearningActivity
  textComprehensionInteraction: TextComprehensionInteraction
  /**
   * exerciseId is a ID of the text comprehension definition
   * obtained eg. from textComprehensionExercises().
   * The returned ID is ID of the LearningExecution instance.
   */
  textComprehensionStart: Scalars['ID']
  updateFavoriteBooks: Array<Book>
  updateLearningActivity: LearningActivity
  updateLearningPlan: LearningPlan
  updateLearningPlanPageCategory: LearningPlanPageCategory
  updateLearningPlanPageStream: LearningPlanPageStream
  updateLearningPlanPageV2: LearningPlanPageV2
  updateLessonBlock: LessonBlock
  updateLibraryItemPackage: LibraryItemPackage
  updateStudentLibrarySubPackage: Scalars['Boolean']
  /** Performance */
  updateStudentPerformanceNote: Scalars['Boolean']
  updateStudentProfile: Student
  updateTutorialProgress: TutorialProgress
  updateUserLearningFeature: LearningFeatureTranslationV2
  updateUserProfile: UserProfile
  userBulkRegistration: UserBulkRegistrationEnvelopeResponse
  userBulkVerification: Array<UserBulkRegistrationResponse>
  verifyUserPin: Scalars['Int']
}

export type MutationAddActivityToFavoritesArgs = {
  learningActivityType: ActivityType
}

export type MutationAddMeToClassroomArgs = {
  classroomCode: Scalars['String']
  classroomId: Scalars['ID']
}

export type MutationAddUserLearningFeatureArgs = {
  userLearningFeature?: InputMaybe<UserLearningFeatureInput>
}

export type MutationAddUserRoleArgs = {
  userRole: UserRole
}

export type MutationAnswerQuizQuestionArgs = {
  answer: Scalars['Int']
  questionId: Scalars['ID']
  quizId: Scalars['ID']
  timestamp?: InputMaybe<Scalars['DateTime']>
}

export type MutationAvatarConversationChatArgs = {
  input: AvatarSubmitEventsInput
}

export type MutationAvatarNextScenarioActionsArgs = {
  input: AvatarSubmitEventsInput
}

export type MutationAvatarRephraseArgs = {
  input: AvatarRephraseInput
}

export type MutationAvatarStartConversationArgs = {
  input: AvatarStartConversationInput
}

export type MutationAvatarStartScenarioArgs = {
  input: AvatarStartScenarioInput
}

export type MutationAvatarTranslateArgs = {
  input: AvatarTranslationInput
}

export type MutationBugReportArgs = {
  message: BugReportMessageInput
}

export type MutationConfirmReleaseNotesArgs = {
  id: Scalars['ID']
}

export type MutationCreateClassroomArgs = {
  classroomInput: ClassroomInput
}

export type MutationCreateLearningActivityV2Args = {
  classroomId: Scalars['ID']
  learningActivityInput: LearningActivityInput
}

export type MutationCreateLearningPlanArgs = {
  classroomId: Scalars['ID']
  learningPlanInput: LearningPlanInput
}

export type MutationCreateLearningPlanPageCategoryArgs = {
  input: LearningPlanPageCategoryInput
  learningPlanId: Scalars['ID']
}

export type MutationCreateLearningPlanPageFromLessonsArgs = {
  categoryId: Scalars['ID']
  learningPlanId: Scalars['ID']
  pageIds: Array<Scalars['ID']>
}

export type MutationCreateLearningPlanPageStreamArgs = {
  learningPlanPageStreamInput: LearningPlanPageStreamInput
  pageId: Scalars['ID']
}

export type MutationCreateLearningPlanPageV2Args = {
  categoryId: Scalars['ID']
  learningPlanId: Scalars['ID']
  learningPlanPageInput: LearningPlanPageInputV2
}

export type MutationCreateLearningPlanPagesFromLearningsArgs = {
  learningIds: Array<Scalars['ID']>
  learningPlanId: Scalars['ID']
}

export type MutationCreateLessonBlockArgs = {
  blockInput: LessonBlockInput
  streamId: Scalars['ID']
}

export type MutationCreateLibraryItemPackageArgs = {
  libraryItemPackageInput: LibraryItemPackageInput
  packageId?: InputMaybe<Scalars['ID']>
  subject: Subject
}

export type MutationDeleteClassroomArgs = {
  classroomId: Scalars['ID']
}

export type MutationDeleteLearningActivityArgs = {
  learningActivityId: Scalars['ID']
}

export type MutationDeleteLearningPlanArgs = {
  learningPlanId: Scalars['ID']
}

export type MutationDeleteLearningPlanPageArgs = {
  pageId: Scalars['ID']
}

export type MutationDeleteLearningPlanPageCategoryArgs = {
  id: Scalars['ID']
}

export type MutationDeleteLearningPlanPageStreamArgs = {
  streamId: Scalars['ID']
}

export type MutationDeleteLessonBlockArgs = {
  blockId: Scalars['ID']
  streamId: Scalars['ID']
}

export type MutationDeleteLibraryItemArgs = {
  libraryItemId: Scalars['ID']
  libraryItemType: LibraryItemType
}

export type MutationDeleteUserLearningFeatureArgs = {
  learningFeatureId: Scalars['ID']
}

export type MutationDuplicateLearningActivityArgs = {
  classroomId: Scalars['ID']
  learningActivityId: Scalars['ID']
}

export type MutationDuplicateLearningPlanPagesArgs = {
  categoryId?: InputMaybe<Scalars['ID']>
  pageIds: Array<Scalars['ID']>
  targetLearningPlanId: Scalars['ID']
}

export type MutationEditClassroomArgs = {
  classroomId: Scalars['ID']
  classroomInput: ClassroomInput
}

export type MutationExtendLearningPlanPageContentArgs = {
  pageId: Scalars['ID']
}

export type MutationJoinQuizGameArgs = {
  code: Scalars['String']
}

export type MutationLeaveQuizGameArgs = {
  quizId: Scalars['ID']
}

export type MutationLoginStudentEnableTeacherVerificationArgs = {
  classroomId: Scalars['ID']
  userId: Scalars['ID']
}

export type MutationLoginStudentVerifyByTeacherArgs = {
  classroomId: Scalars['ID']
  status: LoginStudentTeacherStatus
  userId: Scalars['ID']
}

export type MutationMigrateClassroomArgs = {
  classroomId: Scalars['ID']
  shouldMigrate: Scalars['Boolean']
}

export type MutationNextQuizQuestionArgs = {
  quizId: Scalars['ID']
}

export type MutationProcessExecutionExitArgs = {
  exerciseExitInput: ExecutionExitInput
}

export type MutationProcessLearningExecutionStatisticsArgs = {
  learningExecutionStatisticsInput: LearningExecutionStatisticsInput
}

export type MutationProcessStudentInteractionArgs = {
  studentInteractionInput: StudentInteractionInput
}

export type MutationProcessStudentInteractionV2Args = {
  studentInteractionInput: StudentInteractionInputV2
}

export type MutationRemoveActivityFromFavoritesArgs = {
  learningActivityType: ActivityType
}

export type MutationRemoveStudentFromClassArgs = {
  classroomId: Scalars['ID']
  studentId: Scalars['ID']
}

export type MutationRepeatLearningExecutionArgs = {
  executionId: Scalars['ID']
}

export type MutationReportBugInLearningFeatureArgs = {
  appVersion: Scalars['String']
  bugDescription: Scalars['String']
  flashCardAssignmentType?: InputMaybe<FlashCardAssignmentType>
  flashCardFullScreenType?: InputMaybe<FullScreenFlashCardType>
  flashCardResponseType?: InputMaybe<FlashCardResponseType>
  learningFeatureId?: InputMaybe<Scalars['ID']>
  logMessage?: InputMaybe<Scalars['String']>
  os: Scalars['String']
  userId: Scalars['ID']
}

export type MutationSaveImageVerificationArgs = {
  input: ImageVerificationInput
}

export type MutationSaveQuizBasedGameConfigurationArgs = {
  input: QuizBasedGameConfigurationInput
}

export type MutationStartLearningActivityArgs = {
  learningActivityId: Scalars['ID']
}

export type MutationStartQuizGameArgs = {
  learningActivityId: Scalars['ID']
}

export type MutationStartStudentLibrarySubPackageArgs = {
  level: StudentLibraryRankLevel
  subPackageId: Scalars['ID']
}

export type MutationStopLearningActivityArgs = {
  learningActivityId: Scalars['ID']
}

export type MutationTextComprehensionInteractionArgs = {
  input: TextComprehensionInteractionInput
}

export type MutationTextComprehensionStartArgs = {
  exerciseId: Scalars['ID']
}

export type MutationUpdateFavoriteBooksArgs = {
  bookIds: Array<Scalars['ID']>
  classroomId: Scalars['ID']
  mainLearningId?: InputMaybe<Scalars['ID']>
  subject: Subject
}

export type MutationUpdateLearningActivityArgs = {
  learningActivityId: Scalars['ID']
  learningActivityInput: LearningActivityInput
}

export type MutationUpdateLearningPlanArgs = {
  learningPlanId: Scalars['ID']
  learningPlanInput: LearningPlanInput
}

export type MutationUpdateLearningPlanPageCategoryArgs = {
  id: Scalars['ID']
  input: LearningPlanPageCategoryInput
}

export type MutationUpdateLearningPlanPageStreamArgs = {
  learningPlanPageStreamInput: LearningPlanPageStreamInput
  streamId: Scalars['ID']
}

export type MutationUpdateLearningPlanPageV2Args = {
  categoryId?: InputMaybe<Scalars['ID']>
  generate: Scalars['Boolean']
  learningPlanPageInput: LearningPlanPageInputV2
  pageId: Scalars['ID']
}

export type MutationUpdateLessonBlockArgs = {
  blockId: Scalars['ID']
  blockInput: LessonBlockInput
}

export type MutationUpdateLibraryItemPackageArgs = {
  libraryItemPackageInput: LibraryItemPackageInput
  packageId: Scalars['ID']
}

export type MutationUpdateStudentLibrarySubPackageArgs = {
  input: StudentLibrarySubPackageInput
  subPackageId: Scalars['ID']
}

export type MutationUpdateStudentPerformanceNoteArgs = {
  classroomId: Scalars['ID']
  note: Scalars['String']
  studentId: Scalars['ID']
}

export type MutationUpdateStudentProfileArgs = {
  studentId: Scalars['ID']
  userProfile: UserProfileInput
}

export type MutationUpdateTutorialProgressArgs = {
  isSkipped: Scalars['Boolean']
  tutorialStepCompleted: Scalars['Int']
}

export type MutationUpdateUserLearningFeatureArgs = {
  learningFeatureId: Scalars['ID']
  userLearningFeature?: InputMaybe<UserLearningFeatureInput>
}

export type MutationUpdateUserProfileArgs = {
  userProfile?: InputMaybe<UserProfileInput>
}

export type MutationUserBulkRegistrationArgs = {
  classroomId: Scalars['ID']
  language: Language
  users: Array<UserBulkRegistration>
}

export type MutationUserBulkVerificationArgs = {
  classroomId: Scalars['ID']
  users: Array<UserBulkRegistration>
}

export type MutationVerifyUserPinArgs = {
  pin?: InputMaybe<Scalars['String']>
  userId: Scalars['ID']
}

export type NextFlashCardDevelopInputV2 = {
  requestedFeatureIds?: InputMaybe<Array<Scalars['ID']>>
  requestedTypes?: InputMaybe<Array<FlashCardTypeV2>>
}

export type NextFlashCardInput = {
  buffered?: InputMaybe<Scalars['Boolean']>
  interactionTypes: Array<InteractionType>
  learningExecutionId: Scalars['ID']
  supportedFlashCardAssignmentTypes: Array<FlashCardAssignmentType>
  supportedFlashCardLexicalTypes: Array<FlashCardLexicalType>
  supportedFlashCardResponseTypes: Array<FlashCardResponseType>
  supportedFullScreenFlashCardTypes: Array<FullScreenFlashCardType>
}

export type NextFlashCardInputV2 = {
  cannotSpeak: Scalars['Boolean']
  classroomId: Scalars['ID']
  develop?: InputMaybe<NextFlashCardDevelopInputV2>
}

export enum NumberingType {
  ALPHABETICAL = 'ALPHABETICAL',
  NUMERICAL = 'NUMERICAL',
  ROMAN_NUMERALS = 'ROMAN_NUMERALS'
}

export type PageableInput = {
  count: Scalars['Int']
  from: Scalars['Int']
}

export type Participant = Student | Team

export enum PinType {
  EMOJI = 'EMOJI',
  NUMERIC = 'NUMERIC'
}

export type PronunciationInput = {
  accuracyScore: Scalars['Float']
  completenessScore: Scalars['Float']
  fluencyScore: Scalars['Float']
  pronScore: Scalars['Float']
  prosodyScore: Scalars['Float']
}

export type Query = {
  __typename?: 'Query'
  avatarFetchScenarioConfig: AvatarScenarioConfig
  avatarFetchScenarios?: Maybe<Array<AvatarScenario>>
  bookDetail: Book
  books: Array<Book>
  bugReports: Array<BugReport>
  classroom: Classroom
  classroomLoginCode: ClassroomLoginCode
  classrooms: Array<Classroom>
  completedLearningExecution: CompletedLearningExecution
  favoriteActivities: Array<ActivityType>
  favoriteBooks: Array<Book>
  imageVerification: Array<ImageVerificationType>
  learningActivity: LearningActivity
  learningPlanCategories: Array<LearningPlanPageCategory>
  learningPlanPageStream: LearningPlanPageStream
  learningPlanPageV2: LearningPlanPageV2
  learningPlanPagesV2: Array<LearningPlanPageV2>
  learningPlans: Array<LearningPlan>
  lessonBlock: LessonBlock
  /** Library Items Queries */
  libraryBookItems: LibraryBooks
  libraryCollectionItems: LibraryCollections
  libraryGrammarPackageItems: LibraryGrammarPackages
  libraryItemCollectionDetail: LibraryItemCollection
  libraryItemPackageDetail: LibraryItemPackage
  libraryMyContentItems: LibraryMyContent
  libraryPackageItems: LibraryPackages
  loginStudent: LoginToken
  /** Student platform polls periodically for result of the request. */
  loginStudentIsVerifiedByTeacher: LoginStudentTeacherStatus
  /**
   * Teacher platform polls periodically for all students who
   * enabled verification by teacher.
   */
  loginStudentTeacherStatus: Array<LoginStudentTeacherUserStatus>
  nextFlashCard: FlashCard
  nextFlashCardV2: FlashCardV2
  /**
   * Unified query for game editor configuration by learningActivityId
   * See GameType enum.
   */
  quizBasedGameConfigurationByActivityId: QuizBasedGameConfiguration
  /**
   * Unified query for game editor configuration by configurationId
   * See GameType enum.
   */
  quizBasedGameConfigurationById: QuizBasedGameConfiguration
  quizGame: QuizGame
  relatedWrongAnswers: Array<WrongAnswer>
  releaseNotes: Array<ReleaseNotes>
  searchCoverImages: Array<ImageType>
  searchDictionaryLearningFeature: Array<LearningFeatureTranslationV2>
  searchLearningActivities: Array<LearningActivity>
  searchLearningFeature: Array<LearningFeatureV2>
  /** It returns current game editor configuration question content by search text. */
  searchQuizBasedGameConfigurationQuestionContent: Array<QuizBasedGameConfigurationQuestionContent>
  studentAppSupportedVersion: SupportedVersion
  studentInfo: StudentInfo
  studentLibraryDetail: StudentLibrarySubPackage
  studentLibraryOverview: StudentLibraryOverview
  studentRanks: Array<StudentRank>
  students: ClassroomLogin
  studentsInClassroom: Array<Student>
  subjects: Array<Subject>
  task: LearningExecution
  tasks: Array<LearningExecution>
  teacherAnalyticActivities: TeacherAnalyticsActivities
  teacherAnalyticNotableAchievers: Array<TeacherAnalyticNotableAchievements>
  /**
   * It's not called LanguageSkills because we will
   * have different skill types in different subjects
   * one day.
   */
  teacherAnalyticSkills: Array<TeacherAnalyticSkill>
  teacherAnalyticStudentAtRisk: Array<TeacherAnalyticStudentsAtRisk>
  teacherAnalyticStudentPerformanceDetail: TeacherAnalyticStudent
  teacherAnalyticStudentsPerformance: Array<TeacherAnalyticStudent>
  teacherAnalyticVocabularyLevel: TeacherAnalyticVocabularyLevel
  textComprehensionExercise: TextComprehension
  textComprehensionExercises: Array<TextComprehension>
  tutorialProgress: TutorialProgress
  userProfile: UserProfile
  validateAuthorizationCode: AuthorizationCodeValidationResult
  worksheetsAllowedTypes: Array<WorksheetAllowedType>
  worksheetsForActivity: Array<WorksheetPdf>
  worksheetsFromLibrary: Array<WorksheetPdf>
}

export type QueryAvatarFetchScenarioConfigArgs = {
  input: AvatarScenarioConfigInput
}

export type QueryAvatarFetchScenariosArgs = {
  subject: Subject
}

export type QueryBookDetailArgs = {
  bookId: Scalars['ID']
}

export type QueryBooksArgs = {
  subject: Subject
}

export type QueryBugReportsArgs = {
  page: PageableInput
}

export type QueryClassroomArgs = {
  classroomId: Scalars['ID']
}

export type QueryClassroomLoginCodeArgs = {
  classroomId: Scalars['ID']
}

export type QueryCompletedLearningExecutionArgs = {
  learningExecutionId: Scalars['ID']
}

export type QueryFavoriteBooksArgs = {
  classroomId: Scalars['ID']
  mainLearningId?: InputMaybe<Scalars['ID']>
  subject: Subject
}

export type QueryImageVerificationArgs = {
  batchSize: Scalars['Int']
}

export type QueryLearningActivityArgs = {
  learningActivityId: Scalars['ID']
}

export type QueryLearningPlanCategoriesArgs = {
  learningPlanId: Scalars['ID']
}

export type QueryLearningPlanPageStreamArgs = {
  streamId: Scalars['ID']
}

export type QueryLearningPlanPageV2Args = {
  pageId: Scalars['ID']
}

export type QueryLearningPlanPagesV2Args = {
  categoryId: Scalars['ID']
  learningPlanId: Scalars['ID']
}

export type QueryLearningPlansArgs = {
  classroomId: Scalars['ID']
}

export type QueryLessonBlockArgs = {
  blockId: Scalars['ID']
}

export type QueryLibraryBookItemsArgs = {
  filters: LibraryItemsFilterInput
  page: PageableInput
}

export type QueryLibraryCollectionItemsArgs = {
  filters: LibraryItemsFilterInput
  page: PageableInput
}

export type QueryLibraryGrammarPackageItemsArgs = {
  filters: LibraryItemsFilterInput
  page: PageableInput
}

export type QueryLibraryItemCollectionDetailArgs = {
  libraryItemId: Scalars['ID']
  textSearch?: InputMaybe<Scalars['String']>
}

export type QueryLibraryItemPackageDetailArgs = {
  libraryItemId: Scalars['ID']
}

export type QueryLibraryMyContentItemsArgs = {
  filters: LibraryItemsFilterInput
  page: PageableInput
}

export type QueryLibraryPackageItemsArgs = {
  filters: LibraryItemsFilterInput
  page: PageableInput
}

export type QueryLoginStudentArgs = {
  classroomLoginCode: Scalars['String']
  studentId: Scalars['ID']
}

export type QueryLoginStudentIsVerifiedByTeacherArgs = {
  classroomId: Scalars['ID']
  userId: Scalars['ID']
}

export type QueryLoginStudentTeacherStatusArgs = {
  classroomId: Scalars['ID']
}

export type QueryNextFlashCardArgs = {
  nextFlashCardInput: NextFlashCardInput
}

export type QueryNextFlashCardV2Args = {
  nextFlashCardInput: NextFlashCardInputV2
}

export type QueryQuizBasedGameConfigurationByActivityIdArgs = {
  gameType: QuizBasedGameType
  learningActivityId: Scalars['ID']
}

export type QueryQuizBasedGameConfigurationByIdArgs = {
  configurationId: Scalars['ID']
  gameType: QuizBasedGameType
}

export type QueryQuizGameArgs = {
  quizId: Scalars['ID']
}

export type QueryRelatedWrongAnswersArgs = {
  learningFeatureIds: Array<Scalars['ID']>
}

export type QueryReleaseNotesArgs = {
  input: ReleaseNotesInput
  page: PageableInput
}

export type QuerySearchCoverImagesArgs = {
  page: PageableInput
  search: Scalars['String']
  subject: Subject
}

export type QuerySearchDictionaryLearningFeatureArgs = {
  filter?: InputMaybe<SearchDictionaryFilterInput>
  page: PageableInput
  searchLearningFeatureInput: SearchDictionaryLearningFeatureInput
}

export type QuerySearchLearningActivitiesArgs = {
  page: PageableInput
  parameters: LearningActivitiesSearchInput
}

export type QuerySearchLearningFeatureArgs = {
  searchLearningFeatureInput: SearchLearningFeatureInput
}

export type QuerySearchQuizBasedGameConfigurationQuestionContentArgs = {
  searchLearningFeatureInput: SearchLearningFeatureInput
}

export type QueryStudentLibraryDetailArgs = {
  subPackageId: Scalars['ID']
}

export type QueryStudentLibraryOverviewArgs = {
  subject?: InputMaybe<Subject>
}

export type QueryStudentRanksArgs = {
  classroomId: Scalars['ID']
  timeView?: InputMaybe<TimeView>
}

export type QueryStudentsArgs = {
  classroomLoginCode: Scalars['String']
}

export type QueryStudentsInClassroomArgs = {
  classroomId: Scalars['ID']
}

export type QueryTaskArgs = {
  learningExecutionId: Scalars['ID']
}

export type QueryTasksArgs = {
  classroomId?: InputMaybe<Scalars['ID']>
  isActive: Scalars['Boolean']
  page?: InputMaybe<PageableInput>
}

export type QueryTeacherAnalyticActivitiesArgs = {
  classroomId: Scalars['ID']
  window: TeacherAnalyticWindow
}

export type QueryTeacherAnalyticNotableAchieversArgs = {
  classroomId: Scalars['ID']
  window: TeacherAnalyticWindow
}

export type QueryTeacherAnalyticSkillsArgs = {
  classroomId: Scalars['ID']
  window: TeacherAnalyticWindow
}

export type QueryTeacherAnalyticStudentAtRiskArgs = {
  classroomId: Scalars['ID']
  window: TeacherAnalyticWindow
}

export type QueryTeacherAnalyticStudentPerformanceDetailArgs = {
  classroomId: Scalars['ID']
  studentId: Scalars['ID']
  window: TeacherAnalyticWindow
}

export type QueryTeacherAnalyticStudentsPerformanceArgs = {
  classroomId: Scalars['ID']
  window: TeacherAnalyticWindow
}

export type QueryTeacherAnalyticVocabularyLevelArgs = {
  classroomId: Scalars['ID']
}

export type QueryTextComprehensionExerciseArgs = {
  id: Scalars['ID']
}

export type QueryTextComprehensionExercisesArgs = {
  learningId: Scalars['ID']
}

export type QueryValidateAuthorizationCodeArgs = {
  code: Scalars['String']
}

export type QueryWorksheetsForActivityArgs = {
  learningActivityId: Scalars['ID']
}

export type QueryWorksheetsFromLibraryArgs = {
  activityType: ActivityType
  learningFeaturesIds: Array<InputMaybe<Scalars['ID']>>
  lexicalType: GQLWorksheetLexicalType
  name: Scalars['String']
}

export enum QuizAssignmentType {
  IMAGE = 'IMAGE',
  SOUND = 'SOUND',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO'
}

export type QuizBasedGameConfiguration = {
  __typename?: 'QuizBasedGameConfiguration'
  gameType: QuizBasedGameType
  groups: Array<QuizBasedGameConfigurationGroup>
  id: Scalars['ID']
  label?: Maybe<Scalars['String']>
  learningActivityId?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  subject: Subject
}

/**
 * Custom settings for the group.
 * - showQuestionInClient: Quiz
 * - pointsMultiplier: Millionaire
 */
export type QuizBasedGameConfigurationCustomGroupSettings = {
  __typename?: 'QuizBasedGameConfigurationCustomGroupSettings'
  pointsMultiplier?: Maybe<Scalars['Float']>
  showQuestionInClient?: Maybe<Scalars['Boolean']>
}

export type QuizBasedGameConfigurationCustomGroupSettingsInput = {
  pointsMultiplier?: InputMaybe<Scalars['Float']>
  showQuestionInClient?: InputMaybe<Scalars['Boolean']>
}

export type QuizBasedGameConfigurationGroup = {
  __typename?: 'QuizBasedGameConfigurationGroup'
  customSettings?: Maybe<QuizBasedGameConfigurationCustomGroupSettings>
  id: Scalars['ID']
  name: Scalars['String']
  questions: Array<QuizBasedGameConfigurationQuestion>
  timeLimit: Scalars['Int']
}

export type QuizBasedGameConfigurationGroupInput = {
  customSettings?: InputMaybe<QuizBasedGameConfigurationCustomGroupSettingsInput>
  name: Scalars['String']
  questions: Array<QuizBasedGameConfigurationQuestionInput>
  timeLimit: Scalars['Int']
}

export type QuizBasedGameConfigurationInput = {
  gameType: QuizBasedGameType
  groups: Array<QuizBasedGameConfigurationGroupInput>
  id: Scalars['ID']
  label?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
}

/**
 * The media of the question.
 * - imageUrl: Quiz
 * - soundUrl: Quiz
 * - videoUrl: Quiz
 */
export type QuizBasedGameConfigurationMedia = {
  __typename?: 'QuizBasedGameConfigurationMedia'
  imageUrl?: Maybe<Scalars['String']>
  soundUrl?: Maybe<Scalars['String']>
  videoUrl?: Maybe<Scalars['String']>
}

export type QuizBasedGameConfigurationMediaInput = {
  imageUrl?: InputMaybe<Scalars['String']>
  soundUrl?: InputMaybe<Scalars['String']>
  videoUrl?: InputMaybe<Scalars['String']>
}

export type QuizBasedGameConfigurationOption = {
  __typename?: 'QuizBasedGameConfigurationOption'
  index: Scalars['Int']
  isCorrect: Scalars['Boolean']
  learningFeature?: Maybe<LearningFeatureTranslationV2>
  media?: Maybe<QuizBasedGameConfigurationMedia>
  text?: Maybe<Scalars['String']>
}

export type QuizBasedGameConfigurationOptionInput = {
  index: Scalars['Int']
  isCorrect: Scalars['Boolean']
  learningFeatureId?: InputMaybe<Scalars['ID']>
  media?: InputMaybe<QuizBasedGameConfigurationMediaInput>
  text?: InputMaybe<Scalars['String']>
}

export type QuizBasedGameConfigurationQuestion = {
  __typename?: 'QuizBasedGameConfigurationQuestion'
  groupId?: Maybe<Scalars['ID']>
  index: Scalars['Int']
  learningFeature?: Maybe<LearningFeatureTranslationV2>
  learningFeatureDirection?: Maybe<LearningFeatureDirection>
  lexicalType?: Maybe<QuizBasedGameQuestionLexicalType>
  media?: Maybe<QuizBasedGameConfigurationMedia>
  options: Array<QuizBasedGameConfigurationOption>
  originalLearningFeature?: Maybe<LearningFeatureTranslationV2>
  text?: Maybe<Scalars['String']>
  timeLimit: Scalars['Int']
  type: QuizBasedGameConfigurationQuestionType
}

export type QuizBasedGameConfigurationQuestionContent = {
  __typename?: 'QuizBasedGameConfigurationQuestionContent'
  definitions: Array<Scalars['String']>
  learningFeature: LearningFeatureTranslationV2
}

export type QuizBasedGameConfigurationQuestionInput = {
  groupId?: InputMaybe<Scalars['ID']>
  index: Scalars['Int']
  learningFeatureDirection?: InputMaybe<LearningFeatureDirection>
  learningFeatureId?: InputMaybe<Scalars['ID']>
  lexicalType?: InputMaybe<QuizBasedGameQuestionLexicalType>
  media?: InputMaybe<QuizBasedGameConfigurationMediaInput>
  options: Array<QuizBasedGameConfigurationOptionInput>
  originalLearningFeatureId?: InputMaybe<Scalars['ID']>
  text?: InputMaybe<Scalars['String']>
  timeLimit?: InputMaybe<Scalars['Int']>
  type?: InputMaybe<QuizBasedGameConfigurationQuestionType>
}

/**
 * The type of the question.
 * - MULTI_CHOICE: Quiz, Millionaire
 * - TRUE_FALSE: Quiz
 */
export enum QuizBasedGameConfigurationQuestionType {
  MULTI_CHOICE = 'MULTI_CHOICE',
  TRUE_FALSE = 'TRUE_FALSE'
}

/**
 * The lexical type of the question.
 * - TRANSLATION: Quiz, Millionaire
 * - DEFINITION: only Millionaire
 */
export enum QuizBasedGameQuestionLexicalType {
  DEFINITION = 'DEFINITION',
  TRANSLATION = 'TRANSLATION'
}

export enum QuizBasedGameType {
  MILLIONAIRE = 'MILLIONAIRE',
  QUIZ = 'QUIZ'
}

export type QuizGame = {
  __typename?: 'QuizGame'
  code: Scalars['String']
  connectedPlayers: Array<Maybe<QuizGamePlayer>>
  countdownInSeconds: Scalars['Int']
  currentQuestion?: Maybe<QuizGameQuestion>
  gameState: QuizGameState
  id: Scalars['ID']
  name: Scalars['String']
  numOfQuestions: Scalars['Int']
}

export type QuizGamePlayer = {
  __typename?: 'QuizGamePlayer'
  firstName: Scalars['String']
  id: Scalars['ID']
  lastName: Scalars['String']
  name: Scalars['String']
  newPoints: Scalars['Int']
  newPosition: Scalars['Int']
  oldPosition: Scalars['Int']
  pictureUrl?: Maybe<Scalars['String']>
  totalPoints: Scalars['Int']
}

export type QuizGameQuestion = {
  __typename?: 'QuizGameQuestion'
  assignment: QuizGameQuestionItem
  assignmentType: QuizAssignmentType
  hasNext: Scalars['Boolean']
  id: Scalars['ID']
  index: Scalars['Int']
  numOfAnswers: Scalars['Int']
  questionResult: QuizGameQuestionResult
  responses: Array<QuizGameQuestionItem>
  secondsPerQuestion: Scalars['Int']
  showQuestionInClient: Scalars['Boolean']
}

export type QuizGameQuestionItem = {
  __typename?: 'QuizGameQuestionItem'
  id: Scalars['ID']
  imageUrl?: Maybe<Scalars['String']>
  index: Scalars['Int']
  soundURL?: Maybe<Scalars['String']>
  text: Scalars['String']
  videoURL?: Maybe<Scalars['String']>
}

export type QuizGameQuestionResult = {
  __typename?: 'QuizGameQuestionResult'
  answerDistribution: Array<Scalars['Int']>
  correctResponseIndexes: Array<Scalars['Int']>
}

export enum QuizGameState {
  ASSIGNMENT_COUNT_DOWN = 'ASSIGNMENT_COUNT_DOWN',
  ASSIGNMENT_FINISHED = 'ASSIGNMENT_FINISHED',
  ASSIGNMENT_IN_PROGRESS = 'ASSIGNMENT_IN_PROGRESS',
  EXITED = 'EXITED',
  FINISHED = 'FINISHED',
  WAITING_FOR_PLAYERS = 'WAITING_FOR_PLAYERS'
}

export type ReleaseNotes = {
  __typename?: 'ReleaseNotes'
  id: Scalars['ID']
  url: Scalars['String']
}

export type ReleaseNotesInput = {
  language: Language
  userRole: UserRole
}

export type ResponseInput = {
  imageURLOfResponse?: InputMaybe<Scalars['String']>
  pronunciation?: InputMaybe<PronunciationInput>
  soundURLOfResponse?: InputMaybe<Scalars['String']>
  sourceLanguage: Language
  targetLanguage: Language
  textOfResponse: Scalars['String']
}

export type ResponseInteraction = {
  __typename?: 'ResponseInteraction'
  activityResult: ActivityResult
  assignedLearningFeatureId: Scalars['ID']
  correctResponse: LearningFeatureTranslationV2
  isSkipped: Scalars['Boolean']
  learningExecutionProgress: Scalars['Int']
  learningExecutionState: LearningExecutionState
  learningFeatureState: LearningFeatureState
  newPoints: Scalars['Int']
  reactionTime: Scalars['Int']
  successMeasure: Scalars['Int']
  totalPoints: Scalars['Int']
}

export type ResponseInteractionReactionTimeArgs = {
  unit?: InputMaybe<TimeUnits>
}

export type ResponseInteractionDetailV2 = {
  __typename?: 'ResponseInteractionDetailV2'
  activityResult: ActivityResult
  assignmentId: Scalars['ID']
  newPoints: Scalars['Int']
  successMeasure: Scalars['Int']
  totalPoints: Scalars['Int']
}

export type ResponseInteractionV2 = {
  __typename?: 'ResponseInteractionV2'
  activityResult: ActivityResult
  detail: Array<ResponseInteractionDetailV2>
  reactionTime: Scalars['Int']
}

export type ResponseInteractionV2ReactionTimeArgs = {
  unit?: InputMaybe<TimeUnits>
}

export type SearchDictionaryFilterInput = {
  expressionType?: InputMaybe<Array<LearningFeatureType>>
  isUserOwned?: InputMaybe<Scalars['Boolean']>
  level?: InputMaybe<Array<CEFRLevel>>
}

export type SearchDictionaryLearningFeatureInput = {
  sourceLanguage: Language
  targetLanguage: Language
  text: Scalars['String']
}

export type SearchLearningFeatureInput = {
  learningFeatureType?: InputMaybe<Array<LearningFeatureType>>
  size?: InputMaybe<Scalars['Int']>
  sourceLanguage: Language
  targetLanguage: Language
  text: Scalars['String']
}

export enum Skill {
  READING = 'READING',
  SPEAKING = 'SPEAKING',
  WRITING = 'WRITING'
}

export type Student = {
  __typename?: 'Student'
  classrooms: Array<Classroom>
  lastLoginCode?: Maybe<Scalars['String']>
  studentLastActivity?: Maybe<Scalars['DateTime']>
  studentLastLogin?: Maybe<Scalars['DateTime']>
  userProfile: UserProfile
}

export enum StudentAnalyticsStanding {
  ABOVE = 'ABOVE',
  AT_LEVEL = 'AT_LEVEL',
  BELOW = 'BELOW',
  UNKNOWN = 'UNKNOWN'
}

export type StudentInfo = {
  __typename?: 'StudentInfo'
  allLearning: Array<Book>
  selectedLearning?: Maybe<Book>
  student: Student
}

export type StudentInteractionInput = {
  assignedLearningFeatureId: Scalars['ID']
  flashCardAssignmentType?: InputMaybe<FlashCardAssignmentType>
  flashCardFullScreenType?: InputMaybe<FullScreenFlashCardType>
  flashCardId: Scalars['ID']
  flashCardLexicalType?: InputMaybe<FlashCardLexicalType>
  flashCardResponseType?: InputMaybe<FlashCardResponseType>
  isSkipped: Scalars['Boolean']
  learningExecutionId: Scalars['ID']
  reactionTimeMilliseconds: Scalars['Int']
  responseInput: ResponseInput
  totalTimeMilliseconds: Scalars['Int']
}

export type StudentInteractionInputV2 = {
  assignedLearningFeatureId: Scalars['ID']
  flashCardId: Scalars['ID']
  gapFill?: InputMaybe<Array<FlashCardGapFillResponse>>
  isSkipped: Scalars['Boolean']
  pair?: InputMaybe<Array<FlashCardPairResponse>>
  reactionTimeMilliseconds: Scalars['Int']
  simple?: InputMaybe<Array<FlashCardSimpleResponse>>
  speaking?: InputMaybe<Array<FlashCardSpeakingResponse>>
  totalTimeMilliseconds: Scalars['Int']
  transformation?: InputMaybe<Array<FlashCardTransformationResponse>>
}

export enum StudentLevelMastery {
  A0 = 'A0',
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2'
}

export enum StudentLibraryImageBackground {
  BEIGE = 'BEIGE',
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  LIGHT_BLUE = 'LIGHT_BLUE',
  MINT = 'MINT',
  ORANGE = 'ORANGE',
  PINK = 'PINK',
  PURPLE = 'PURPLE',
  SALMON = 'SALMON',
  YELLOW = 'YELLOW'
}

export type StudentLibraryOverview = {
  __typename?: 'StudentLibraryOverview'
  inProgress: Array<StudentLibrarySubPackageOverview>
  packages: Array<StudentLibraryPackageOverview>
}

export type StudentLibraryPackageOverview = {
  __typename?: 'StudentLibraryPackageOverview'
  id: Scalars['ID']
  name: Scalars['String']
  subPackages: Array<Maybe<StudentLibrarySubPackageOverview>>
}

export enum StudentLibraryRankLevel {
  LEGEND = 'LEGEND',
  PRO = 'PRO',
  ROOKIE = 'ROOKIE'
}

export type StudentLibrarySubPackage = {
  __typename?: 'StudentLibrarySubPackage'
  id: Scalars['ID']
  image: ImageType
  imageBackground: StudentLibraryImageBackground
  isFavorite: Scalars['Boolean']
  levels: Array<StudentLibrarySubPackageLevel>
  name: Scalars['String']
  packageId: Scalars['ID']
  packageName: Scalars['String']
}

export enum StudentLibrarySubPackageCategory {
  QUESTIONS = 'QUESTIONS',
  SENTENCES = 'SENTENCES',
  VOCABULARY = 'VOCABULARY'
}

export type StudentLibrarySubPackageInput = {
  isFavorite: Scalars['Boolean']
}

export type StudentLibrarySubPackageLevel = {
  __typename?: 'StudentLibrarySubPackageLevel'
  answers?: Maybe<Array<FlashCardAnswer>>
  category: Array<StudentLibrarySubPackageCategory>
  estimatedDurationSeconds: Scalars['Int']
  features: Array<LearningFeatureTranslationV2>
  finishedDurationSeconds?: Maybe<Scalars['Int']>
  isEnabled: Scalars['Boolean']
  isStarted: Scalars['Boolean']
  level: StudentLibraryRankLevel
  progress?: Maybe<Scalars['Int']>
  remainingDurationSeconds?: Maybe<Scalars['Int']>
  subcategory: Array<Scalars['String']>
  successMeasure?: Maybe<Scalars['Int']>
}

export type StudentLibrarySubPackageOverview = {
  __typename?: 'StudentLibrarySubPackageOverview'
  currentProgress?: Maybe<Scalars['Int']>
  currentSuccessMeasure?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  image: ImageType
  imageBackground: StudentLibraryImageBackground
  isEnabled: Scalars['Boolean']
  isFavorite: Scalars['Boolean']
  isStarted: Scalars['Boolean']
  name: Scalars['String']
}

export type StudentRank = {
  __typename?: 'StudentRank'
  currentStudent: Scalars['Boolean']
  id: Scalars['ID']
  points: Scalars['Int']
  student: Student
}

export enum Subject {
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  SPANISH = 'SPANISH'
}

export type Subscription = {
  __typename?: 'Subscription'
  ping: Scalars['String']
  quizGame: QuizGame
  quizGameClient: QuizGame
}

export type SubscriptionPingArgs = {
  payload: Scalars['String']
}

export type SubscriptionQuizGameArgs = {
  quizId: Scalars['ID']
}

export type SubscriptionQuizGameClientArgs = {
  qrCode: Scalars['String']
}

export type SupportedVersion = {
  __typename?: 'SupportedVersion'
  lastSupportedVersion?: Maybe<Version>
  recommendedVersion?: Maybe<Version>
}

export type TeacherAnalyticAccuracy = {
  __typename?: 'TeacherAnalyticAccuracy'
  accuracy: AccuracyScore
  almostCorrectExecutionCount: Scalars['Int']
  correctExecutionsCount: Scalars['Int']
  executionTotalCount: Scalars['Int']
  skills: Array<TeacherAnalyticSkill>
}

export type TeacherAnalyticAssignments = {
  __typename?: 'TeacherAnalyticAssignments'
  completedCount: Scalars['Int']
  inProgressCount: Scalars['Int']
  totalCount: Scalars['Int']
  type: AssignmentMode
}

export type TeacherAnalyticClassOverallPerformance = {
  __typename?: 'TeacherAnalyticClassOverallPerformance'
  atLevelPoints: Scalars['Int']
  percentile: Scalars['Int']
  studentPoints: Scalars['Int']
}

export enum TeacherAnalyticNotableAchievement {
  AVID_GAMERS = 'AVID_GAMERS',
  BOUNCE_BACKS = 'BOUNCE_BACKS',
  CLEVER_FOXES = 'CLEVER_FOXES',
  COLLECTORS = 'COLLECTORS',
  EXPLORERS = 'EXPLORERS',
  LEADERBOARD_FROGS = 'LEADERBOARD_FROGS',
  NOT_GIVING_UP = 'NOT_GIVING_UP',
  POWER_LEARNERS = 'POWER_LEARNERS',
  WEEKEND_WARRIORS = 'WEEKEND_WARRIORS'
}

export type TeacherAnalyticNotableAchievements = {
  __typename?: 'TeacherAnalyticNotableAchievements'
  achievement: TeacherAnalyticNotableAchievement
  students: Array<UserProfile>
}

export enum TeacherAnalyticRiskLevel {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type TeacherAnalyticSkill = {
  __typename?: 'TeacherAnalyticSkill'
  delta: Scalars['Int']
  histogram?: Maybe<TeacherAnalyticSkillHistogram>
  previousValue?: Maybe<Scalars['Int']>
  skill: Scalars['String']
  timeSeries?: Maybe<Array<TeacherAnalyticTimeSeries>>
  value: Scalars['Int']
}

export type TeacherAnalyticSkillHistogram = {
  __typename?: 'TeacherAnalyticSkillHistogram'
  counts: Array<Scalars['Int']>
  points: Array<Scalars['Int']>
}

export type TeacherAnalyticStudent = {
  __typename?: 'TeacherAnalyticStudent'
  assignments: Array<TeacherAnalyticAssignments>
  classVocabularyLevel: TeacherAnalyticVocabularyLevel
  commonMistakes: Array<CommonMistake>
  level: StudentLevelMastery
  note?: Maybe<Scalars['String']>
  overallAccuracy: TeacherAnalyticAccuracy
  overallPerformance: TeacherAnalyticClassOverallPerformance
  practiceAccuracy: TeacherAnalyticAccuracy
  practiceTime: Scalars['Int']
  standing: StudentAnalyticsStanding
  student: Student
  tags: Array<TeacherAnalyticStudentTags>
  testAccuracy: TeacherAnalyticAccuracy
  vocabularyMastery: TeacherAnalyticVocabularyMastery
}

export enum TeacherAnalyticStudentTags {
  FAST_LEARNER = 'FAST_LEARNER',
  HIGH_PERFORMER = 'HIGH_PERFORMER',
  HIGH_RISK = 'HIGH_RISK',
  NEW_STUDENT = 'NEW_STUDENT',
  SLOW_LEARNER = 'SLOW_LEARNER'
}

export type TeacherAnalyticStudentsAtRisk = {
  __typename?: 'TeacherAnalyticStudentsAtRisk'
  riskLevel: TeacherAnalyticRiskLevel
  students: Array<UserProfile>
}

export type TeacherAnalyticTimeSeries = {
  __typename?: 'TeacherAnalyticTimeSeries'
  timestamp: Scalars['DateTime']
  value: Scalars['Int']
}

export type TeacherAnalyticVocabularyComposition = {
  __typename?: 'TeacherAnalyticVocabularyComposition'
  level: CEFRLevel
  percent: Scalars['Int']
}

export type TeacherAnalyticVocabularyCurrentState = {
  __typename?: 'TeacherAnalyticVocabularyCurrentState'
  delta: Scalars['Int']
  points: Scalars['Int']
  state: VocabularyMasteryState
}

export type TeacherAnalyticVocabularyLevel = {
  __typename?: 'TeacherAnalyticVocabularyLevel'
  classroomAveragePercentage: Scalars['Int']
  classroomAveragePoints: Scalars['Int']
  classroomLevel: StudentLevelMastery
  studentsLevelPerformance: Array<TeacherAnalyticVocabularyLevelStudent>
}

export type TeacherAnalyticVocabularyLevelStudent = {
  __typename?: 'TeacherAnalyticVocabularyLevelStudent'
  level: StudentLevelMastery
  percentage: Scalars['Int']
  points: Scalars['Int']
  student: UserProfile
}

export type TeacherAnalyticVocabularyMastery = {
  __typename?: 'TeacherAnalyticVocabularyMastery'
  percentile: Scalars['Int']
  vocabularyComposition: Array<TeacherAnalyticVocabularyComposition>
  vocabularyCurrentState: Array<TeacherAnalyticVocabularyCurrentState>
}

export enum TeacherAnalyticWindow {
  CURRENT_YEAR = 'CURRENT_YEAR',
  DAYS_7 = 'DAYS_7',
  DAYS_14 = 'DAYS_14',
  DAYS_30 = 'DAYS_30'
}

export type TeacherAnalyticsActivities = {
  __typename?: 'TeacherAnalyticsActivities'
  activities: Array<TeacherAnalyticsActivity>
  homeworks: Array<TeacherAnalyticsActivity>
  tests: Array<TeacherAnalyticsActivity>
}

export type TeacherAnalyticsActivity = {
  __typename?: 'TeacherAnalyticsActivity'
  id: Scalars['ID']
  state: LearningActivityState
  type: AssignmentMode
}

export type Team = {
  __typename?: 'Team'
  imageURL: Scalars['String']
  name: Scalars['String']
}

export type TextComprehension = {
  __typename?: 'TextComprehension'
  audioTimestamps?: Maybe<Array<TextComprehensionAudioTimestamp>>
  audioUrl?: Maybe<Scalars['String']>
  id: Scalars['ID']
  image?: Maybe<ImageType>
  language: Language
  level: CEFRLevel
  questions: Array<TextComprehensionQuestion>
  text: Scalars['String']
  title: Scalars['String']
  world?: Maybe<Scalars['String']>
}

export type TextComprehensionAudioTimestamp = {
  __typename?: 'TextComprehensionAudioTimestamp'
  end: Scalars['String']
  start: Scalars['String']
  text: Scalars['String']
}

export type TextComprehensionInteraction = {
  __typename?: 'TextComprehensionInteraction'
  activityResult: ActivityResult
  correctResponseBoolean?: Maybe<Scalars['Boolean']>
  correctResponseFillIn?: Maybe<Array<TextComprehensionQuestionContentFillInItem>>
  correctResponseMatching?: Maybe<Array<TextComprehensionQuestionContentMatchingPair>>
  correctResponseText?: Maybe<Array<Scalars['String']>>
  learningExecutionState: LearningExecutionState
}

export type TextComprehensionInteractionInput = {
  alreadyCompletedQuestions: Scalars['Int']
  answerBoolean?: InputMaybe<Scalars['Boolean']>
  answerPairs?: InputMaybe<Array<TextComprehensionInteractionInputPairInput>>
  answerText?: InputMaybe<Array<Scalars['String']>>
  learningExecutionId: Scalars['ID']
  questionId: Scalars['ID']
  textComprehensionId: Scalars['ID']
}

export type TextComprehensionInteractionInputPairInput = {
  item1: Scalars['String']
  item2: Scalars['String']
}

export type TextComprehensionQuestion = {
  __typename?: 'TextComprehensionQuestion'
  content: TextComprehensionQuestionContent
  id: Scalars['ID']
  questionSemanticType: TextComprehensionQuestionSemanticType
  questionType: TextComprehensionQuestionType
}

export type TextComprehensionQuestionContent =
  | TextComprehensionQuestionContentBoolean
  | TextComprehensionQuestionContentFillIn
  | TextComprehensionQuestionContentMatching
  | TextComprehensionQuestionContentMultiChoice
  | TextComprehensionQuestionContentOrdering

export type TextComprehensionQuestionContentBoolean = {
  __typename?: 'TextComprehensionQuestionContentBoolean'
  question: Scalars['String']
}

export type TextComprehensionQuestionContentFillIn = {
  __typename?: 'TextComprehensionQuestionContentFillIn'
  items: Array<TextComprehensionQuestionContentFillInItem>
  question: Scalars['String']
}

export type TextComprehensionQuestionContentFillInItem = {
  __typename?: 'TextComprehensionQuestionContentFillInItem'
  index: Scalars['Int']
  options: Array<Scalars['String']>
}

export type TextComprehensionQuestionContentMatching = {
  __typename?: 'TextComprehensionQuestionContentMatching'
  category1: Scalars['String']
  category2: Scalars['String']
  pairs: Array<TextComprehensionQuestionContentMatchingPair>
  question: Scalars['String']
}

export type TextComprehensionQuestionContentMatchingPair = {
  __typename?: 'TextComprehensionQuestionContentMatchingPair'
  item1: Scalars['String']
  item2: Scalars['String']
}

export type TextComprehensionQuestionContentMultiChoice = {
  __typename?: 'TextComprehensionQuestionContentMultiChoice'
  charArray: Array<Maybe<Scalars['String']>>
  options: Array<Scalars['String']>
  question: Scalars['String']
}

export type TextComprehensionQuestionContentOrdering = {
  __typename?: 'TextComprehensionQuestionContentOrdering'
  options: Array<Scalars['String']>
  question: Scalars['String']
}

export enum TextComprehensionQuestionSemanticType {
  INFERENTIAL = 'INFERENTIAL',
  LITERAL = 'LITERAL'
}

export enum TextComprehensionQuestionType {
  BOOLEAN = 'BOOLEAN',
  FILL_IN = 'FILL_IN',
  FIND_SPEAKER = 'FIND_SPEAKER',
  FINISH_THE_SENTENCE = 'FINISH_THE_SENTENCE',
  MATCHING = 'MATCHING',
  MATCHING_DESCRIPTION = 'MATCHING_DESCRIPTION',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  ORDERING = 'ORDERING'
}

export enum TimeUnits {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MILLISECOND = 'MILLISECOND',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  /** Determining time period from the beginning of the recording history. */
  OVERALL = 'OVERALL',
  SECOND = 'SECOND',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export enum TimeView {
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type TutorialProgress = {
  __typename?: 'TutorialProgress'
  isSkipped: Scalars['Boolean']
  tutorialStepCompleted: Scalars['Int']
}

export type UserAnswer = {
  __typename?: 'UserAnswer'
  assignmentText: Scalars['String']
  correctAnswer: Scalars['String']
  result: ActivityResult
  userAnswer?: Maybe<Scalars['String']>
}

export type UserBulkRegistration = {
  email: Scalars['String']
  name: Scalars['String']
}

export type UserBulkRegistrationEnvelopeResponse = {
  __typename?: 'UserBulkRegistrationEnvelopeResponse'
  initialCredentialsBase64?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
  users: Array<UserBulkRegistrationResponse>
}

export type UserBulkRegistrationError = {
  __typename?: 'UserBulkRegistrationError'
  code: Scalars['String']
  description: Scalars['String']
  field: Scalars['String']
}

export type UserBulkRegistrationResponse = {
  __typename?: 'UserBulkRegistrationResponse'
  email: Scalars['String']
  errors: Array<UserBulkRegistrationError>
  firstName: Scalars['String']
  isAlreadyRegistered: Scalars['Boolean']
  isValid: Scalars['Boolean']
  lastName: Scalars['String']
  originalName: Scalars['String']
}

export type UserLearningFeatureInput = {
  level?: InputMaybe<CEFRLevel>
  sourceLanguage: Language
  sourceLanguageText: Scalars['String']
  targetLanguage: Language
  targetLanguageText: Scalars['String']
  type?: InputMaybe<LearningFeatureType>
}

export type UserProfile = {
  __typename?: 'UserProfile'
  appLanguage: Language
  email: Scalars['String']
  firstName: Scalars['String']
  hasPin: Scalars['Boolean']
  id: Scalars['ID']
  lastName: Scalars['String']
  pictureUrl?: Maybe<Scalars['String']>
  pinSymbolSet?: Maybe<Array<Scalars['String']>>
  pinType?: Maybe<PinType>
  username: Scalars['String']
}

export type UserProfileInput = {
  appLanguage?: InputMaybe<Language>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  pictureId?: InputMaybe<Scalars['ID']>
  pin?: InputMaybe<Scalars['String']>
}

export enum UserRole {
  STUDENT = 'STUDENT',
  TEACHER = 'TEACHER'
}

export enum UserStatisticsSkills {
  LISTENING = 'LISTENING',
  READING = 'READING',
  SPEAKING = 'SPEAKING',
  WRITING = 'WRITING'
}

export type Version = {
  __typename?: 'Version'
  lastSupportDate?: Maybe<Scalars['Date']>
  version: Scalars['String']
}

export type VideoType = {
  __typename?: 'VideoType'
  commonName: Scalars['String']
  firstFrameImage: ImageType
  large: Scalars['String']
  medium: Scalars['String']
  namespace: Scalars['String']
  small: Scalars['String']
}

export enum VocabularyMasteryState {
  KNOWN = 'KNOWN',
  LEARNING = 'LEARNING',
  MASTERED = 'MASTERED'
}

export enum WeekStart {
  MONDAY = 'MONDAY',
  SUNDAY = 'SUNDAY'
}

export enum WheelOfFortuneType {
  EXPLAIN = 'EXPLAIN',
  TRANSLATE = 'TRANSLATE',
  TRANSLATE_SOURCE = 'TRANSLATE_SOURCE',
  USE = 'USE'
}

export type WorksheetAllowedType = {
  __typename?: 'WorksheetAllowedType'
  allowedLexicalTypes: Array<GQLWorksheetLexicalType>
  worksheetType: GQLWorksheetType
}

export type WorksheetPdf = {
  __typename?: 'WorksheetPdf'
  contentBase64: Scalars['String']
  fileName: Scalars['String']
  worksheetLexicalType: GQLWorksheetLexicalType
  worksheetType: GQLWorksheetType
}

export type WrongAnswer = {
  __typename?: 'WrongAnswer'
  learningFeatureId: Scalars['ID']
  wrongLearningFeature?: Maybe<LearningFeatureTranslationV2>
  wrongText?: Maybe<Scalars['String']>
}

export type GetTeacherAnalyticActivitiesQueryVariables = Exact<{
  classroomId: Scalars['ID']
  window: TeacherAnalyticWindow
}>

export type GetTeacherAnalyticActivitiesQuery = {
  __typename?: 'Query'
  teacherAnalyticActivities: {
    __typename?: 'TeacherAnalyticsActivities'
    homeworks: Array<{
      __typename?: 'TeacherAnalyticsActivity'
      id: string
      type: AssignmentMode
      state: LearningActivityState
    }>
    tests: Array<{
      __typename?: 'TeacherAnalyticsActivity'
      id: string
      type: AssignmentMode
      state: LearningActivityState
    }>
    activities: Array<{
      __typename?: 'TeacherAnalyticsActivity'
      id: string
      type: AssignmentMode
      state: LearningActivityState
    }>
  }
}

export type GetTeacherAnalyticNotableAchieversQueryVariables = Exact<{
  classroomId: Scalars['ID']
  window?: TeacherAnalyticWindow
}>

export type GetTeacherAnalyticNotableAchieversQuery = {
  __typename?: 'Query'
  teacherAnalyticNotableAchievers: Array<{
    __typename?: 'TeacherAnalyticNotableAchievements'
    achievement: TeacherAnalyticNotableAchievement
    students: Array<{
      __typename?: 'UserProfile'
      id: string
      pictureUrl?: string | null
      firstName: string
      lastName: string
    }>
  }>
}

export type GetTeacherAnalyticSkillsQueryVariables = Exact<{
  classroomId: Scalars['ID']
  window?: TeacherAnalyticWindow
}>

export type GetTeacherAnalyticSkillsQuery = {
  __typename?: 'Query'
  teacherAnalyticSkills: Array<{
    __typename?: 'TeacherAnalyticSkill'
    skill: string
    delta: number
    value: number
    previousValue?: number | null
  }>
}

export type GetTeacherAnalyticStudentAtRiskQueryVariables = Exact<{
  classroomId: Scalars['ID']
  window?: TeacherAnalyticWindow
}>

export type GetTeacherAnalyticStudentAtRiskQuery = {
  __typename?: 'Query'
  teacherAnalyticStudentAtRisk: Array<{
    __typename?: 'TeacherAnalyticStudentsAtRisk'
    riskLevel: TeacherAnalyticRiskLevel
    students: Array<{
      __typename?: 'UserProfile'
      id: string
      email: string
      pictureUrl?: string | null
      firstName: string
      lastName: string
    }>
  }>
}

export type GetTeacherAnalyticStudentPerformanceDetailQueryVariables = Exact<{
  classroomId: Scalars['ID']
  studentId: Scalars['ID']
  window?: TeacherAnalyticWindow
}>

export type GetTeacherAnalyticStudentPerformanceDetailQuery = {
  __typename?: 'Query'
  teacherAnalyticStudentPerformanceDetail: {
    __typename?: 'TeacherAnalyticStudent'
    level: StudentLevelMastery
    note?: string | null
    practiceTime: number
    standing: StudentAnalyticsStanding
    tags: Array<TeacherAnalyticStudentTags>
    student: {
      __typename?: 'Student'
      studentLastActivity?: string | null
      userProfile: {
        __typename?: 'UserProfile'
        id: string
        email: string
        pictureUrl?: string | null
        firstName: string
        lastName: string
      }
    }
    overallPerformance: {
      __typename?: 'TeacherAnalyticClassOverallPerformance'
      percentile: number
      studentPoints: number
      atLevelPoints: number
    }
    commonMistakes: Array<{
      __typename?: 'CommonMistake'
      mistakeCount: number
      learningFeature: {
        __typename?: 'LearningFeatureTranslationV2'
        id: string
        type: LearningFeatureType
        origin: LearningFeatureOrigin
        sourceLanguage: Language
        targetLanguage: Language
        sourceLanguageText: string
        targetLanguageText: string
      }
    }>
    vocabularyMastery: {
      __typename?: 'TeacherAnalyticVocabularyMastery'
      percentile: number
      vocabularyCurrentState: Array<{
        __typename?: 'TeacherAnalyticVocabularyCurrentState'
        state: VocabularyMasteryState
        points: number
        delta: number
      }>
      vocabularyComposition: Array<{
        __typename?: 'TeacherAnalyticVocabularyComposition'
        level: CEFRLevel
        percent: number
      }>
    }
    assignments: Array<{
      __typename?: 'TeacherAnalyticAssignments'
      type: AssignmentMode
      totalCount: number
      inProgressCount: number
      completedCount: number
    }>
    practiceAccuracy: {
      __typename?: 'TeacherAnalyticAccuracy'
      executionTotalCount: number
      almostCorrectExecutionCount: number
      correctExecutionsCount: number
      accuracy: { __typename?: 'AccuracyScore'; points: number; delta: number }
      skills: Array<{
        __typename?: 'TeacherAnalyticSkill'
        skill: string
        delta: number
        value: number
        previousValue?: number | null
        histogram?: {
          __typename?: 'TeacherAnalyticSkillHistogram'
          points: Array<number>
          counts: Array<number>
        } | null
      }>
    }
    testAccuracy: {
      __typename?: 'TeacherAnalyticAccuracy'
      executionTotalCount: number
      almostCorrectExecutionCount: number
      correctExecutionsCount: number
      accuracy: { __typename?: 'AccuracyScore'; points: number; delta: number }
      skills: Array<{
        __typename?: 'TeacherAnalyticSkill'
        skill: string
        delta: number
        value: number
        previousValue?: number | null
        histogram?: {
          __typename?: 'TeacherAnalyticSkillHistogram'
          points: Array<number>
          counts: Array<number>
        } | null
      }>
    }
    overallAccuracy: {
      __typename?: 'TeacherAnalyticAccuracy'
      executionTotalCount: number
      almostCorrectExecutionCount: number
      correctExecutionsCount: number
      accuracy: { __typename?: 'AccuracyScore'; points: number; delta: number }
      skills: Array<{
        __typename?: 'TeacherAnalyticSkill'
        skill: string
        delta: number
        value: number
        previousValue?: number | null
        histogram?: {
          __typename?: 'TeacherAnalyticSkillHistogram'
          points: Array<number>
          counts: Array<number>
        } | null
      }>
    }
  }
}

export type TeacherAnalyticStudentAccuracyDetailFragment = {
  __typename?: 'TeacherAnalyticAccuracy'
  executionTotalCount: number
  almostCorrectExecutionCount: number
  correctExecutionsCount: number
  accuracy: { __typename?: 'AccuracyScore'; points: number; delta: number }
  skills: Array<{
    __typename?: 'TeacherAnalyticSkill'
    skill: string
    delta: number
    value: number
    previousValue?: number | null
    histogram?: { __typename?: 'TeacherAnalyticSkillHistogram'; points: Array<number>; counts: Array<number> } | null
  }>
}

export type GetTeacherAnalyticStudentsPerformanceQueryVariables = Exact<{
  classroomId: Scalars['ID']
  window?: TeacherAnalyticWindow
}>

export type GetTeacherAnalyticStudentsPerformanceQuery = {
  __typename?: 'Query'
  teacherAnalyticStudentsPerformance: Array<{
    __typename?: 'TeacherAnalyticStudent'
    level: StudentLevelMastery
    practiceTime: number
    standing: StudentAnalyticsStanding
    tags: Array<TeacherAnalyticStudentTags>
    student: {
      __typename?: 'Student'
      userProfile: {
        __typename?: 'UserProfile'
        id: string
        email: string
        pictureUrl?: string | null
        firstName: string
        lastName: string
      }
    }
    assignments: Array<{
      __typename?: 'TeacherAnalyticAssignments'
      type: AssignmentMode
      totalCount: number
      inProgressCount: number
      completedCount: number
    }>
    practiceAccuracy: {
      __typename?: 'TeacherAnalyticAccuracy'
      accuracy: { __typename?: 'AccuracyScore'; points: number; delta: number }
    }
    testAccuracy: {
      __typename?: 'TeacherAnalyticAccuracy'
      accuracy: { __typename?: 'AccuracyScore'; points: number; delta: number }
    }
    overallAccuracy: {
      __typename?: 'TeacherAnalyticAccuracy'
      accuracy: { __typename?: 'AccuracyScore'; points: number; delta: number }
    }
  }>
}

export type GetTeacherAnalyticVocabularyLevelQueryVariables = Exact<{
  classroomId: Scalars['ID']
}>

export type GetTeacherAnalyticVocabularyLevelQuery = {
  __typename?: 'Query'
  teacherAnalyticVocabularyLevel: {
    __typename?: 'TeacherAnalyticVocabularyLevel'
    classroomAveragePoints: number
    classroomAveragePercentage: number
    classroomLevel: StudentLevelMastery
    studentsLevelPerformance: Array<{
      __typename?: 'TeacherAnalyticVocabularyLevelStudent'
      points: number
      percentage: number
      level: StudentLevelMastery
      student: { __typename?: 'UserProfile'; id: string; firstName: string; lastName: string }
    }>
  }
}

export type SearchLearningActivitiesQueryVariables = Exact<{
  parameters: LearningActivitiesSearchInput
  withExecutions: Scalars['Boolean']
  page: PageableInput
}>

export type SearchLearningActivitiesQuery = {
  __typename?: 'Query'
  searchLearningActivities: Array<{
    __typename?: 'LearningActivity'
    id: string
    contentSourceLabel?: string | null
    state: LearningActivityState
    activityType: ActivityType
    assignmentMode: AssignmentMode
    subject: Subject
    learningFeatureCount: number
    progress?: { __typename?: 'LearningActivityProgress'; deadline?: string | null; progress?: number | null } | null
    executions?: Array<{
      __typename?: 'LearningExecution'
      id: string
      state: LearningExecutionState
      name: string
      successMeasure: number
      progress: number
      student: {
        __typename?: 'Student'
        userProfile: {
          __typename?: 'UserProfile'
          id: string
          pictureUrl?: string | null
          firstName: string
          lastName: string
        }
      }
    }> | null
  }>
}

export type UpdateStudentPerformanceNoteMutationVariables = Exact<{
  studentId: Scalars['ID']
  classroomId: Scalars['ID']
  note: Scalars['String']
}>

export type UpdateStudentPerformanceNoteMutation = { __typename?: 'Mutation'; updateStudentPerformanceNote: boolean }

export type BugReportMutationVariables = Exact<{
  message: BugReportMessageInput
}>

export type BugReportMutation = { __typename?: 'Mutation'; bugReport: string }

export type CreateClassroomMutationVariables = Exact<{
  classroomInput: ClassroomInput
}>

export type CreateClassroomMutation = {
  __typename?: 'Mutation'
  createClassroom: {
    __typename?: 'Classroom'
    id: string
    name: string
    identificator: string
    showSubjectIcon: boolean
    subject: Subject
    color?: string | null
    isSetupComplete: boolean
    isReadyToMigrate: boolean
    weekStart: WeekStart
    timeZone: string
    startOfYear: string
    endOfYear: string
    enforcePinLogin: boolean
  }
}

export type DeleteClassroomMutationVariables = Exact<{
  classroomId: Scalars['ID']
}>

export type DeleteClassroomMutation = { __typename?: 'Mutation'; deleteClassroom: boolean }

export type EditClassroomMutationVariables = Exact<{
  classroomId: Scalars['ID']
  classroomInput: ClassroomInput
}>

export type EditClassroomMutation = {
  __typename?: 'Mutation'
  editClassroom: {
    __typename?: 'Classroom'
    id: string
    name: string
    isSetupComplete: boolean
    isReadyToMigrate: boolean
    identificator: string
    showSubjectIcon: boolean
    subject: Subject
    color?: string | null
    enforcePinLogin: boolean
    weekStart: WeekStart
    timeZone: string
    startOfYear: string
    endOfYear: string
  }
}

export type GetBooksQueryVariables = Exact<{
  subject: Subject
}>

export type GetBooksQuery = {
  __typename?: 'Query'
  books: Array<{
    __typename?: 'Book'
    id: string
    name: string
    sourceLanguage: Language
    level: Array<CEFRLevel>
    subject: Subject
    image?: { __typename?: 'ImageType'; default: string; small?: string | null; medium?: string | null } | null
  }>
}

export type GetClassroomDetailQueryVariables = Exact<{
  classroomId: Scalars['ID']
}>

export type GetClassroomDetailQuery = {
  __typename?: 'Query'
  classroom: {
    __typename: 'Classroom'
    id: string
    name: string
    subject: Subject
    identificator: string
    showSubjectIcon: boolean
    color?: string | null
    enforcePinLogin: boolean
    isSetupComplete: boolean
    isReadyToMigrate: boolean
    weekStart: WeekStart
    timeZone: string
    startOfYear: string
    endOfYear: string
  }
}

export type GetClassroomLoginCodeQueryVariables = Exact<{
  classroomId: Scalars['ID']
}>

export type GetClassroomLoginCodeQuery = {
  __typename?: 'Query'
  classroomLoginCode: { __typename?: 'ClassroomLoginCode'; classroomLoginCode: string; expirationTime: string }
}

export type LoginStudentTeacherStatusQueryVariables = Exact<{
  classroomId: Scalars['ID']
}>

export type LoginStudentTeacherStatusQuery = {
  __typename?: 'Query'
  loginStudentTeacherStatus: Array<{
    __typename?: 'LoginStudentTeacherUserStatus'
    status: LoginStudentTeacherStatus
    student: {
      __typename?: 'Student'
      studentLastActivity?: string | null
      studentLastLogin?: string | null
      lastLoginCode?: string | null
      userProfile: {
        __typename?: 'UserProfile'
        id: string
        pictureUrl?: string | null
        firstName: string
        lastName: string
        email: string
        hasPin: boolean
      }
    }
  }>
}

export type LoginStudentVerifyByTeacherMutationVariables = Exact<{
  userId: Scalars['ID']
  classroomId: Scalars['ID']
  status: LoginStudentTeacherStatus
}>

export type LoginStudentVerifyByTeacherMutation = { __typename?: 'Mutation'; loginStudentVerifyByTeacher: boolean }

export type MigrateClassroomMutationVariables = Exact<{
  classroomId: Scalars['ID']
  shouldMigrate: Scalars['Boolean']
}>

export type MigrateClassroomMutation = {
  __typename?: 'Mutation'
  migrateClassroom?: {
    __typename?: 'Classroom'
    id: string
    name: string
    identificator: string
    showSubjectIcon: boolean
    subject: Subject
    color?: string | null
    isSetupComplete: boolean
    isReadyToMigrate: boolean
    weekStart: WeekStart
    timeZone: string
    startOfYear: string
    endOfYear: string
  } | null
}

export type RemoveStudentFromClassMutationVariables = Exact<{
  studentId: Scalars['ID']
  classroomId: Scalars['ID']
}>

export type RemoveStudentFromClassMutation = { __typename?: 'Mutation'; removeStudentFromClass: boolean }

export type UpdateStudentProfileMutationVariables = Exact<{
  studentId: Scalars['ID']
  userProfile: UserProfileInput
}>

export type UpdateStudentProfileMutation = {
  __typename?: 'Mutation'
  updateStudentProfile: {
    __typename?: 'Student'
    userProfile: {
      __typename?: 'UserProfile'
      id: string
      firstName: string
      lastName: string
      pictureUrl?: string | null
    }
  }
}

export type UserBulkRegistrationMutationVariables = Exact<{
  classroomId: Scalars['ID']
  users: Array<UserBulkRegistration> | UserBulkRegistration
  language: Language
}>

export type UserBulkRegistrationMutation = {
  __typename?: 'Mutation'
  userBulkRegistration: {
    __typename?: 'UserBulkRegistrationEnvelopeResponse'
    success: boolean
    initialCredentialsBase64?: string | null
    users: Array<{
      __typename?: 'UserBulkRegistrationResponse'
      originalName: string
      firstName: string
      lastName: string
      email: string
      isValid: boolean
      isAlreadyRegistered: boolean
      errors: Array<{ __typename?: 'UserBulkRegistrationError'; field: string; description: string; code: string }>
    }>
  }
}

export type UserBulkVerificationMutationVariables = Exact<{
  classroomId: Scalars['ID']
  users: Array<UserBulkRegistration> | UserBulkRegistration
}>

export type UserBulkVerificationMutation = {
  __typename?: 'Mutation'
  userBulkVerification: Array<{
    __typename?: 'UserBulkRegistrationResponse'
    originalName: string
    firstName: string
    lastName: string
    email: string
    isValid: boolean
    isAlreadyRegistered: boolean
    errors: Array<{ __typename?: 'UserBulkRegistrationError'; field: string; description: string; code: string }>
  }>
}

export type AddActivityToFavoritesMutationVariables = Exact<{
  learningActivityType: ActivityType
}>

export type AddActivityToFavoritesMutation = { __typename?: 'Mutation'; addActivityToFavorites: boolean }

export type GetClassroomsQueryVariables = Exact<{ [key: string]: never }>

export type GetClassroomsQuery = {
  __typename?: 'Query'
  classrooms: Array<{
    __typename?: 'Classroom'
    id: string
    name: string
    identificator: string
    showSubjectIcon: boolean
    color?: string | null
    subject: Subject
    isSetupComplete: boolean
    isReadyToMigrate: boolean
  }>
}

export type GetFavoriteActivitiesQueryVariables = Exact<{ [key: string]: never }>

export type GetFavoriteActivitiesQuery = { __typename?: 'Query'; favoriteActivities: Array<ActivityType> }

export type GetLibraryGrammarPackageItemsQueryVariables = Exact<{
  filters: LibraryItemsFilterInput
  page: PageableInput
}>

export type GetLibraryGrammarPackageItemsQuery = {
  __typename?: 'Query'
  libraryGrammarPackageItems: {
    __typename?: 'LibraryGrammarPackages'
    filters: { __typename?: 'LibraryItemsFilter'; level?: Array<CEFRLevel | null> | null; tags?: Array<string> | null }
    packages: Array<{
      __typename?: 'LibraryItemPackage'
      id: string
      name: string
      label?: string | null
      borderColor?: string | null
      level: Array<CEFRLevel>
      learningFeaturesCount: number
      image?: { __typename?: 'ImageType'; small?: string | null; medium?: string | null; default: string } | null
      learningFeatures: Array<
        | {
            __typename: 'LearningFeatureGrammarV2'
            id: string
            type: LearningFeatureType
            origin: LearningFeatureOrigin
            name: string
            subtitle: string
            level: CEFRLevel
            example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
          }
        | {
            __typename: 'LearningFeatureTranslationV2'
            id: string
            type: LearningFeatureType
            origin: LearningFeatureOrigin
            sourceLanguage: Language
            sourceLanguageText: string
            targetLanguage: Language
            targetLanguageText: string
            hasDefinitions: boolean
            images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
          }
      >
    }>
  }
}

export type GetLibraryItemPackageDetailQueryVariables = Exact<{
  libraryItemId: Scalars['ID']
  withLearningFeatures?: InputMaybe<Scalars['Boolean']>
}>

export type GetLibraryItemPackageDetailQuery = {
  __typename?: 'Query'
  libraryItemPackageDetail: {
    __typename: 'LibraryItemPackage'
    id: string
    name: string
    label?: string | null
    level: Array<CEFRLevel>
    borderColor?: string | null
    foxinoOwned: boolean
    image?: {
      __typename?: 'ImageType'
      medium?: string | null
      default: string
      imageId?: { __typename?: 'ImageIdType'; namespace: string; commonName: string } | null
    } | null
    createdBy?: { __typename?: 'UserProfile'; firstName: string; lastName: string; email: string } | null
    learningFeatures?: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | {
          __typename: 'LearningFeatureTranslationV2'
          sourceLanguage: Language
          sourceLanguageText: string
          targetLanguage: Language
          targetLanguageText: string
          origin: LearningFeatureOrigin
          hasDefinitions: boolean
          id: string
          type: LearningFeatureType
          images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
        }
    >
  }
}

export type GetLibraryPackageItemsQueryVariables = Exact<{
  filters: LibraryItemsFilterInput
  page: PageableInput
}>

export type GetLibraryPackageItemsQuery = {
  __typename?: 'Query'
  libraryPackageItems: {
    __typename?: 'LibraryPackages'
    filters: { __typename?: 'LibraryItemsFilter'; level?: Array<CEFRLevel | null> | null; tags?: Array<string> | null }
    packages: Array<{
      __typename?: 'LibraryItemPackage'
      id: string
      name: string
      label?: string | null
      borderColor?: string | null
      level: Array<CEFRLevel>
      learningFeaturesCount: number
      image?: { __typename?: 'ImageType'; small?: string | null; medium?: string | null; default: string } | null
    }>
  }
}

type LearningFeatureActivityFragment_LearningFeatureGrammarV2_Fragment = {
  __typename: 'LearningFeatureGrammarV2'
  name: string
  subtitle: string
  level: CEFRLevel
  id: string
  type: LearningFeatureType
  origin: LearningFeatureOrigin
  example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
}

type LearningFeatureActivityFragment_LearningFeatureTranslationV2_Fragment = {
  __typename: 'LearningFeatureTranslationV2'
  sourceLanguage: Language
  sourceLanguageText: string
  sourceSoundUrls: Array<string>
  sourceVideoUrls: Array<string>
  targetLanguage: Language
  targetLanguageText: string
  targetSoundUrls: Array<string>
  targetVideoUrls: Array<string>
  origin: LearningFeatureOrigin
  hasSynonyms: boolean
  hasAntonyms: boolean
  hasDefinitions: boolean
  id: string
  type: LearningFeatureType
  images: Array<{ __typename?: 'ImageType'; small?: string | null; medium?: string | null; default: string }>
}

export type LearningFeatureActivityFragmentFragment =
  | LearningFeatureActivityFragment_LearningFeatureGrammarV2_Fragment
  | LearningFeatureActivityFragment_LearningFeatureTranslationV2_Fragment

type LearningFeatureShortDetail_LearningFeatureGrammarV2_Fragment = {
  __typename: 'LearningFeatureGrammarV2'
  name: string
  subtitle: string
  level: CEFRLevel
  id: string
  type: LearningFeatureType
  origin: LearningFeatureOrigin
  example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
}

type LearningFeatureShortDetail_LearningFeatureTranslationV2_Fragment = {
  __typename: 'LearningFeatureTranslationV2'
  sourceLanguage: Language
  sourceLanguageText: string
  targetLanguage: Language
  targetLanguageText: string
  origin: LearningFeatureOrigin
  hasDefinitions: boolean
  id: string
  type: LearningFeatureType
  images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
}

export type LearningFeatureShortDetailFragment =
  | LearningFeatureShortDetail_LearningFeatureGrammarV2_Fragment
  | LearningFeatureShortDetail_LearningFeatureTranslationV2_Fragment

type LessonBlockShortFragment_LessonBlockActivity_Fragment = {
  __typename: 'LessonBlockActivity'
  id: string
  type: LessonBlockType
  name: string
  streamId: string
  isPresentable: boolean
  activity: {
    __typename?: 'LearningActivity'
    state: LearningActivityState
    activityType: ActivityType
    assignmentMode: AssignmentMode
    estimatedTimeInSeconds: number
    timeLimitSeconds?: number | null
    learningFeatureCount: number
    skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
    progress?: {
      __typename?: 'LearningActivityProgress'
      deadline?: string | null
      progress?: number | null
      total?: number | null
      type?: LearningActivityProgressType | null
    } | null
    gameProperties?: {
      __typename?: 'GameProperties'
      questionCount?: number | null
      coverStyle?: string | null
      isSoundEnabled?: boolean | null
      wheelOfFortuneType?: WheelOfFortuneType | null
      worksheetLexicalType?: string | null
      huntwordsAllDirections?: boolean | null
    } | null
  }
}

type LessonBlockShortFragment_LessonBlockBookOrientation_Fragment = {
  __typename: 'LessonBlockBookOrientation'
  pageFrom: number
  pageTo: number
  id: string
  type: LessonBlockType
  name: string
  streamId: string
  isPresentable: boolean
  book?: {
    __typename?: 'Book'
    id: string
    name: string
    level: Array<CEFRLevel>
    subject: Subject
    image?: { __typename?: 'ImageType'; medium?: string | null } | null
  } | null
}

type LessonBlockShortFragment_LessonBlockContent_Fragment = {
  __typename: 'LessonBlockContent'
  id: string
  type: LessonBlockType
  name: string
  streamId: string
  isPresentable: boolean
}

type LessonBlockShortFragment_LessonBlockFreeText_Fragment = {
  __typename: 'LessonBlockFreeText'
  content: string
  id: string
  type: LessonBlockType
  name: string
  streamId: string
  isPresentable: boolean
}

type LessonBlockShortFragment_LessonBlockImages_Fragment = {
  __typename: 'LessonBlockImages'
  description: string
  id: string
  type: LessonBlockType
  name: string
  streamId: string
  isPresentable: boolean
  images?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
}

type LessonBlockShortFragment_LessonBlockMistakes_Fragment = {
  __typename: 'LessonBlockMistakes'
  mistakeCount: number
  id: string
  type: LessonBlockType
  name: string
  streamId: string
  isPresentable: boolean
  mistakes: Array<{
    __typename?: 'Mistake'
    name: string
    textWithMistake: string
    wrongPart: string
    correctAnswer: string
    explanation?: string | null
    learningFeature?:
      | { __typename?: 'LearningFeatureGrammarV2'; id: string; type: LearningFeatureType }
      | { __typename?: 'LearningFeatureTranslationV2'; id: string; type: LearningFeatureType }
      | null
  }>
}

type LessonBlockShortFragment_LessonBlockVideos_Fragment = {
  __typename: 'LessonBlockVideos'
  description: string
  id: string
  type: LessonBlockType
  name: string
  streamId: string
  isPresentable: boolean
  videos?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
}

export type LessonBlockShortFragmentFragment =
  | LessonBlockShortFragment_LessonBlockActivity_Fragment
  | LessonBlockShortFragment_LessonBlockBookOrientation_Fragment
  | LessonBlockShortFragment_LessonBlockContent_Fragment
  | LessonBlockShortFragment_LessonBlockFreeText_Fragment
  | LessonBlockShortFragment_LessonBlockImages_Fragment
  | LessonBlockShortFragment_LessonBlockMistakes_Fragment
  | LessonBlockShortFragment_LessonBlockVideos_Fragment

export type RemoveActivityFromFavoritesMutationVariables = Exact<{
  learningActivityType: ActivityType
}>

export type RemoveActivityFromFavoritesMutation = { __typename?: 'Mutation'; removeActivityFromFavorites: boolean }

export type SearchLearningFeatureQueryVariables = Exact<{
  searchLearningFeatureInput: SearchLearningFeatureInput
}>

export type SearchLearningFeatureQuery = {
  __typename?: 'Query'
  searchLearningFeature: Array<
    | {
        __typename: 'LearningFeatureGrammarV2'
        name: string
        subtitle: string
        level: CEFRLevel
        id: string
        type: LearningFeatureType
        origin: LearningFeatureOrigin
        example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
      }
    | {
        __typename: 'LearningFeatureTranslationV2'
        sourceLanguage: Language
        sourceLanguageText: string
        targetLanguage: Language
        targetLanguageText: string
        origin: LearningFeatureOrigin
        hasDefinitions: boolean
        id: string
        type: LearningFeatureType
        images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
      }
  >
}

export type GetTutorialProgressQueryVariables = Exact<{ [key: string]: never }>

export type GetTutorialProgressQuery = {
  __typename?: 'Query'
  tutorialProgress: { __typename?: 'TutorialProgress'; tutorialStepCompleted: number; isSkipped: boolean }
}

export type UpdateTutorialProgressMutationVariables = Exact<{
  tutorialStepCompleted: Scalars['Int']
  isSkipped: Scalars['Boolean']
}>

export type UpdateTutorialProgressMutation = {
  __typename?: 'Mutation'
  updateTutorialProgress: { __typename?: 'TutorialProgress'; isSkipped: boolean; tutorialStepCompleted: number }
}

export type GetQuizGameQueryVariables = Exact<{
  quizId: Scalars['ID']
}>

export type GetQuizGameQuery = {
  __typename?: 'Query'
  quizGame: {
    __typename?: 'QuizGame'
    id: string
    name: string
    code: string
    gameState: QuizGameState
    numOfQuestions: number
    countdownInSeconds: number
    currentQuestion?: {
      __typename?: 'QuizGameQuestion'
      id: string
      index: number
      secondsPerQuestion: number
      showQuestionInClient: boolean
      assignmentType: QuizAssignmentType
      numOfAnswers: number
      hasNext: boolean
      assignment: {
        __typename: 'QuizGameQuestionItem'
        id: string
        imageUrl?: string | null
        soundURL?: string | null
        videoURL?: string | null
        text: string
      }
      responses: Array<{ __typename: 'QuizGameQuestionItem'; id: string; text: string }>
      questionResult: {
        __typename?: 'QuizGameQuestionResult'
        correctResponseIndexes: Array<number>
        answerDistribution: Array<number>
      }
    } | null
    connectedPlayers: Array<{
      __typename?: 'QuizGamePlayer'
      id: string
      lastName: string
      firstName: string
      pictureUrl?: string | null
      newPosition: number
      oldPosition: number
      totalPoints: number
      newPoints: number
    } | null>
  }
}

export type NextQuizQuestionMutationVariables = Exact<{
  quizId: Scalars['ID']
}>

export type NextQuizQuestionMutation = { __typename?: 'Mutation'; nextQuizQuestion: boolean }

export type QuizBasedGameConfigurationByActivityIdQueryVariables = Exact<{
  learningActivityId: Scalars['ID']
  gameType: QuizBasedGameType
}>

export type QuizBasedGameConfigurationByActivityIdQuery = {
  __typename?: 'Query'
  quizBasedGameConfigurationByActivityId: {
    __typename?: 'QuizBasedGameConfiguration'
    id: string
    subject: Subject
    name?: string | null
    label?: string | null
    learningActivityId?: string | null
    gameType: QuizBasedGameType
    groups: Array<{
      __typename?: 'QuizBasedGameConfigurationGroup'
      id: string
      name: string
      timeLimit: number
      customSettings?: {
        __typename?: 'QuizBasedGameConfigurationCustomGroupSettings'
        showQuestionInClient?: boolean | null
        pointsMultiplier?: number | null
      } | null
      questions: Array<{
        __typename?: 'QuizBasedGameConfigurationQuestion'
        index: number
        timeLimit: number
        learningFeatureDirection?: LearningFeatureDirection | null
        text?: string | null
        lexicalType?: QuizBasedGameQuestionLexicalType | null
        groupId?: string | null
        type: QuizBasedGameConfigurationQuestionType
        learningFeature?: {
          __typename?: 'LearningFeatureTranslationV2'
          id: string
          type: LearningFeatureType
          sourceLanguage: Language
          sourceLanguageText: string
          targetLanguage: Language
          targetLanguageText: string
          images: Array<{ __typename?: 'ImageType'; default: string }>
        } | null
        originalLearningFeature?: {
          __typename?: 'LearningFeatureTranslationV2'
          id: string
          type: LearningFeatureType
          sourceLanguage: Language
          sourceLanguageText: string
          targetLanguage: Language
          targetLanguageText: string
          images: Array<{ __typename?: 'ImageType'; default: string }>
        } | null
        options: Array<{
          __typename?: 'QuizBasedGameConfigurationOption'
          index: number
          isCorrect: boolean
          text?: string | null
          learningFeature?: {
            __typename?: 'LearningFeatureTranslationV2'
            id: string
            type: LearningFeatureType
            sourceLanguage: Language
            sourceLanguageText: string
            targetLanguage: Language
            targetLanguageText: string
            images: Array<{ __typename?: 'ImageType'; default: string }>
          } | null
          media?: {
            __typename?: 'QuizBasedGameConfigurationMedia'
            imageUrl?: string | null
            soundUrl?: string | null
            videoUrl?: string | null
          } | null
        }>
        media?: {
          __typename?: 'QuizBasedGameConfigurationMedia'
          imageUrl?: string | null
          soundUrl?: string | null
          videoUrl?: string | null
        } | null
      }>
    }>
  }
}

export type QuizBasedGameConfigurationByIdQueryVariables = Exact<{
  configurationId: Scalars['ID']
  gameType: QuizBasedGameType
}>

export type QuizBasedGameConfigurationByIdQuery = {
  __typename?: 'Query'
  quizBasedGameConfigurationById: {
    __typename?: 'QuizBasedGameConfiguration'
    id: string
    subject: Subject
    name?: string | null
    label?: string | null
    learningActivityId?: string | null
    gameType: QuizBasedGameType
    groups: Array<{
      __typename?: 'QuizBasedGameConfigurationGroup'
      id: string
      name: string
      timeLimit: number
      customSettings?: {
        __typename?: 'QuizBasedGameConfigurationCustomGroupSettings'
        showQuestionInClient?: boolean | null
        pointsMultiplier?: number | null
      } | null
      questions: Array<{
        __typename?: 'QuizBasedGameConfigurationQuestion'
        index: number
        timeLimit: number
        learningFeatureDirection?: LearningFeatureDirection | null
        text?: string | null
        lexicalType?: QuizBasedGameQuestionLexicalType | null
        groupId?: string | null
        type: QuizBasedGameConfigurationQuestionType
        learningFeature?: {
          __typename?: 'LearningFeatureTranslationV2'
          id: string
          type: LearningFeatureType
          sourceLanguage: Language
          sourceLanguageText: string
          targetLanguage: Language
          targetLanguageText: string
          images: Array<{ __typename?: 'ImageType'; default: string }>
        } | null
        originalLearningFeature?: {
          __typename?: 'LearningFeatureTranslationV2'
          id: string
          type: LearningFeatureType
          sourceLanguage: Language
          sourceLanguageText: string
          targetLanguage: Language
          targetLanguageText: string
          images: Array<{ __typename?: 'ImageType'; default: string }>
        } | null
        options: Array<{
          __typename?: 'QuizBasedGameConfigurationOption'
          index: number
          isCorrect: boolean
          text?: string | null
          learningFeature?: {
            __typename?: 'LearningFeatureTranslationV2'
            id: string
            type: LearningFeatureType
            sourceLanguage: Language
            sourceLanguageText: string
            targetLanguage: Language
            targetLanguageText: string
            images: Array<{ __typename?: 'ImageType'; default: string }>
          } | null
          media?: {
            __typename?: 'QuizBasedGameConfigurationMedia'
            imageUrl?: string | null
            soundUrl?: string | null
            videoUrl?: string | null
          } | null
        }>
        media?: {
          __typename?: 'QuizBasedGameConfigurationMedia'
          imageUrl?: string | null
          soundUrl?: string | null
          videoUrl?: string | null
        } | null
      }>
    }>
  }
}

export type RelatedWrongAnswersQueryVariables = Exact<{
  learningFeatureIds: Array<Scalars['ID']> | Scalars['ID']
}>

export type RelatedWrongAnswersQuery = {
  __typename?: 'Query'
  relatedWrongAnswers: Array<{
    __typename?: 'WrongAnswer'
    wrongText?: string | null
    wrongLearningFeature?: {
      __typename?: 'LearningFeatureTranslationV2'
      id: string
      sourceLanguage: Language
      sourceLanguageText: string
      targetLanguage: Language
      targetLanguageText: string
    } | null
  }>
}

export type SaveQuizBasedGameConfigurationMutationVariables = Exact<{
  input: QuizBasedGameConfigurationInput
}>

export type SaveQuizBasedGameConfigurationMutation = {
  __typename?: 'Mutation'
  saveQuizBasedGameConfiguration: boolean
}

export type SearchQuizBasedGameConfigurationQuestionContentQueryVariables = Exact<{
  searchLearningFeatureInput: SearchLearningFeatureInput
}>

export type SearchQuizBasedGameConfigurationQuestionContentQuery = {
  __typename?: 'Query'
  searchQuizBasedGameConfigurationQuestionContent: Array<{
    __typename?: 'QuizBasedGameConfigurationQuestionContent'
    definitions: Array<string>
    learningFeature: {
      __typename?: 'LearningFeatureTranslationV2'
      id: string
      sourceLanguage: Language
      sourceLanguageText: string
      targetLanguage: Language
      targetLanguageText: string
      targetSoundUrls: Array<string>
      sourceSoundUrls: Array<string>
      targetVideoUrls: Array<string>
      images: Array<{ __typename?: 'ImageType'; default: string }>
    }
  }>
}

export type StartQuizGameMutationVariables = Exact<{
  learningActivityId: Scalars['ID']
}>

export type StartQuizGameMutation = {
  __typename?: 'Mutation'
  startQuizGame: { __typename?: 'QuizGame'; id: string; code: string }
}

export type AddUserLearningFeatureMutationVariables = Exact<{
  userLearningFeature: UserLearningFeatureInput
}>

export type AddUserLearningFeatureMutation = {
  __typename?: 'Mutation'
  addUserLearningFeature: {
    __typename?: 'LearningFeatureTranslationV2'
    id: string
    targetLanguageText: string
    origin: LearningFeatureOrigin
  }
}

export type CreateLearningActivityV2MutationVariables = Exact<{
  classroomId: Scalars['ID']
  learningActivityInput: LearningActivityInput
}>

export type CreateLearningActivityV2Mutation = {
  __typename?: 'Mutation'
  createLearningActivityV2: {
    __typename?: 'LearningActivity'
    id: string
    state: LearningActivityState
    activityType: ActivityType
    assignmentMode: AssignmentMode
    estimatedTimeInSeconds: number
    timeLimitSeconds?: number | null
    learningFeatureCount: number
    skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
    progress?: {
      __typename?: 'LearningActivityProgress'
      deadline?: string | null
      progress?: number | null
      total?: number | null
      type?: LearningActivityProgressType | null
    } | null
    gameProperties?: {
      __typename?: 'GameProperties'
      questionCount?: number | null
      coverStyle?: string | null
      isSoundEnabled?: boolean | null
      wheelOfFortuneType?: WheelOfFortuneType | null
      worksheetLexicalType?: string | null
      huntwordsAllDirections?: boolean | null
    } | null
  }
}

export type CreateLearningPlanMutationVariables = Exact<{
  classroomId: Scalars['ID']
  learningPlanInput: LearningPlanInput
}>

export type CreateLearningPlanMutation = {
  __typename?: 'Mutation'
  createLearningPlan: {
    __typename?: 'LearningPlan'
    id: string
    title: string
    color?: string | null
    unitNaming: string
    unitNumbering: NumberingType
    isActive: boolean
    isArchived: boolean
    extendLessons: boolean
    book?: {
      __typename?: 'Book'
      id: string
      name: string
      image?: { __typename?: 'ImageType'; default: string; small?: string | null } | null
    } | null
  }
}

export type CreateLearningPlanPageCategoryMutationVariables = Exact<{
  learningPlanId: Scalars['ID']
  input: LearningPlanPageCategoryInput
}>

export type CreateLearningPlanPageCategoryMutation = {
  __typename?: 'Mutation'
  createLearningPlanPageCategory: {
    __typename?: 'LearningPlanPageCategory'
    id: string
    name: string
    pageCount: number
    finishedPageCount: number
    archivedPageCount: number
    isArchived: boolean
    categoryType: LearningPlanPageCategoryType
  }
}

export type CreateLearningPlanPageFromLessonsMutationVariables = Exact<{
  learningPlanId: Scalars['ID']
  categoryId: Scalars['ID']
  pageIds: Array<Scalars['ID']> | Scalars['ID']
}>

export type CreateLearningPlanPageFromLessonsMutation = {
  __typename?: 'Mutation'
  createLearningPlanPageFromLessons: {
    __typename?: 'LearningPlanPageV2'
    id: string
    learningPlanId: string
    title: string
    isFinished: boolean
    isArchived: boolean
    isGenerated: boolean
    learningFeatureCount: number
    learningFeatures: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | {
          __typename: 'LearningFeatureTranslationV2'
          targetLanguageText: string
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
        }
    >
    category: {
      __typename?: 'LearningPlanPageCategory'
      id: string
      name: string
      pageCount: number
      archivedPageCount: number
    }
  }
}

export type CreateLearningPlanPageStreamMutationVariables = Exact<{
  pageId: Scalars['ID']
  learningPlanPageStreamInput: LearningPlanPageStreamInput
}>

export type CreateLearningPlanPageStreamMutation = {
  __typename?: 'Mutation'
  createLearningPlanPageStream: {
    __typename?: 'LearningPlanPageStream'
    id: string
    name: string
    blocks: Array<
      | {
          __typename: 'LessonBlockActivity'
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          activity: {
            __typename?: 'LearningActivity'
            state: LearningActivityState
            activityType: ActivityType
            assignmentMode: AssignmentMode
            estimatedTimeInSeconds: number
            timeLimitSeconds?: number | null
            learningFeatureCount: number
            skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
            progress?: {
              __typename?: 'LearningActivityProgress'
              deadline?: string | null
              progress?: number | null
              total?: number | null
              type?: LearningActivityProgressType | null
            } | null
            gameProperties?: {
              __typename?: 'GameProperties'
              questionCount?: number | null
              coverStyle?: string | null
              isSoundEnabled?: boolean | null
              wheelOfFortuneType?: WheelOfFortuneType | null
              worksheetLexicalType?: string | null
              huntwordsAllDirections?: boolean | null
            } | null
          }
        }
      | {
          __typename: 'LessonBlockBookOrientation'
          pageFrom: number
          pageTo: number
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          book?: {
            __typename?: 'Book'
            id: string
            name: string
            level: Array<CEFRLevel>
            subject: Subject
            image?: { __typename?: 'ImageType'; medium?: string | null } | null
          } | null
        }
      | {
          __typename: 'LessonBlockContent'
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
        }
      | {
          __typename: 'LessonBlockFreeText'
          content: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
        }
      | {
          __typename: 'LessonBlockImages'
          description: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          images?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
        }
      | {
          __typename: 'LessonBlockMistakes'
          mistakeCount: number
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          mistakes: Array<{
            __typename?: 'Mistake'
            name: string
            textWithMistake: string
            wrongPart: string
            correctAnswer: string
            explanation?: string | null
            learningFeature?:
              | { __typename?: 'LearningFeatureGrammarV2'; id: string; type: LearningFeatureType }
              | { __typename?: 'LearningFeatureTranslationV2'; id: string; type: LearningFeatureType }
              | null
          }>
        }
      | {
          __typename: 'LessonBlockVideos'
          description: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          videos?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
        }
    >
  }
}

export type CreateLearningPlanPageV2MutationVariables = Exact<{
  learningPlanId: Scalars['ID']
  categoryId: Scalars['ID']
  learningPlanPageInput: LearningPlanPageInputV2
}>

export type CreateLearningPlanPageV2Mutation = {
  __typename?: 'Mutation'
  createLearningPlanPageV2: {
    __typename?: 'LearningPlanPageV2'
    id: string
    learningPlanId: string
    title: string
    isFinished: boolean
    isArchived: boolean
    isGenerated: boolean
    learningFeatureCount: number
    learningFeatures: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | {
          __typename: 'LearningFeatureTranslationV2'
          targetLanguageText: string
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
        }
    >
    category: {
      __typename?: 'LearningPlanPageCategory'
      id: string
      name: string
      pageCount: number
      archivedPageCount: number
    }
  }
}

export type CreateLearningPlanPagesFromLearningsMutationVariables = Exact<{
  learningPlanId: Scalars['ID']
  learningIds: Array<Scalars['ID']> | Scalars['ID']
}>

export type CreateLearningPlanPagesFromLearningsMutation = {
  __typename?: 'Mutation'
  createLearningPlanPagesFromLearnings: boolean
}

export type CreateLessonBlockMutationVariables = Exact<{
  streamId: Scalars['ID']
  blockInput: LessonBlockInput
}>

export type CreateLessonBlockMutation = {
  __typename?: 'Mutation'
  createLessonBlock:
    | {
        __typename: 'LessonBlockActivity'
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        activity: {
          __typename?: 'LearningActivity'
          state: LearningActivityState
          activityType: ActivityType
          assignmentMode: AssignmentMode
          estimatedTimeInSeconds: number
          timeLimitSeconds?: number | null
          learningFeatureCount: number
          skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
          progress?: {
            __typename?: 'LearningActivityProgress'
            deadline?: string | null
            progress?: number | null
            total?: number | null
            type?: LearningActivityProgressType | null
          } | null
          gameProperties?: {
            __typename?: 'GameProperties'
            questionCount?: number | null
            coverStyle?: string | null
            isSoundEnabled?: boolean | null
            wheelOfFortuneType?: WheelOfFortuneType | null
            worksheetLexicalType?: string | null
            huntwordsAllDirections?: boolean | null
          } | null
        }
      }
    | {
        __typename: 'LessonBlockBookOrientation'
        pageFrom: number
        pageTo: number
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        book?: {
          __typename?: 'Book'
          id: string
          name: string
          level: Array<CEFRLevel>
          subject: Subject
          image?: { __typename?: 'ImageType'; medium?: string | null } | null
        } | null
      }
    | {
        __typename: 'LessonBlockContent'
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
      }
    | {
        __typename: 'LessonBlockFreeText'
        content: string
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
      }
    | {
        __typename: 'LessonBlockImages'
        description: string
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        images?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
      }
    | {
        __typename: 'LessonBlockMistakes'
        mistakeCount: number
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        mistakes: Array<{
          __typename?: 'Mistake'
          name: string
          textWithMistake: string
          wrongPart: string
          correctAnswer: string
          explanation?: string | null
          learningFeature?:
            | { __typename?: 'LearningFeatureGrammarV2'; id: string; type: LearningFeatureType }
            | { __typename?: 'LearningFeatureTranslationV2'; id: string; type: LearningFeatureType }
            | null
        }>
      }
    | {
        __typename: 'LessonBlockVideos'
        description: string
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        videos?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
      }
}

export type DeleteLearningActivityMutationVariables = Exact<{
  learningActivityId: Scalars['ID']
}>

export type DeleteLearningActivityMutation = { __typename?: 'Mutation'; deleteLearningActivity: boolean }

export type DeleteLearningPlanMutationVariables = Exact<{
  learningPlanId: Scalars['ID']
}>

export type DeleteLearningPlanMutation = { __typename?: 'Mutation'; deleteLearningPlan: boolean }

export type DeleteLearningPlanPageMutationVariables = Exact<{
  pageId: Scalars['ID']
}>

export type DeleteLearningPlanPageMutation = { __typename?: 'Mutation'; deleteLearningPlanPage: boolean }

export type DeleteLearningPlanPageCategoryMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type DeleteLearningPlanPageCategoryMutation = {
  __typename?: 'Mutation'
  deleteLearningPlanPageCategory: boolean
}

export type DeleteLearningPlanPageStreamMutationVariables = Exact<{
  streamId: Scalars['ID']
}>

export type DeleteLearningPlanPageStreamMutation = { __typename?: 'Mutation'; deleteLearningPlanPageStream: boolean }

export type DeleteLessonBlockMutationVariables = Exact<{
  streamId: Scalars['ID']
  blockId: Scalars['ID']
}>

export type DeleteLessonBlockMutation = { __typename?: 'Mutation'; deleteLessonBlock: boolean }

export type DeleteUserLearningFeatureMutationVariables = Exact<{
  learningFeatureId: Scalars['ID']
}>

export type DeleteUserLearningFeatureMutation = { __typename?: 'Mutation'; deleteUserLearningFeature: boolean }

export type DuplicateLearningActivityMutationVariables = Exact<{
  classroomId: Scalars['ID']
  learningActivityId: Scalars['ID']
}>

export type DuplicateLearningActivityMutation = {
  __typename?: 'Mutation'
  duplicateLearningActivity: {
    __typename?: 'LearningActivity'
    id: string
    state: LearningActivityState
    activityType: ActivityType
    assignmentMode: AssignmentMode
    estimatedTimeInSeconds: number
    timeLimitSeconds?: number | null
    learningFeatureCount: number
    skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
    progress?: {
      __typename?: 'LearningActivityProgress'
      deadline?: string | null
      progress?: number | null
      total?: number | null
      type?: LearningActivityProgressType | null
    } | null
    gameProperties?: {
      __typename?: 'GameProperties'
      questionCount?: number | null
      coverStyle?: string | null
      isSoundEnabled?: boolean | null
      wheelOfFortuneType?: WheelOfFortuneType | null
      worksheetLexicalType?: string | null
      huntwordsAllDirections?: boolean | null
    } | null
  }
}

export type DuplicateLearningPlanPagesMutationVariables = Exact<{
  pageIds: Array<Scalars['ID']> | Scalars['ID']
  targetLearningPlanId: Scalars['ID']
  categoryId?: InputMaybe<Scalars['ID']>
}>

export type DuplicateLearningPlanPagesMutation = { __typename?: 'Mutation'; duplicateLearningPlanPages: Array<string> }

export type ExtendLearningPlanPageContentMutationVariables = Exact<{
  pageId: Scalars['ID']
}>

export type ExtendLearningPlanPageContentMutation = {
  __typename?: 'Mutation'
  extendLearningPlanPageContent: Array<
    | {
        __typename: 'LearningFeatureGrammarV2'
        name: string
        subtitle: string
        level: CEFRLevel
        id: string
        type: LearningFeatureType
        origin: LearningFeatureOrigin
        example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
      }
    | {
        __typename: 'LearningFeatureTranslationV2'
        sourceLanguage: Language
        sourceLanguageText: string
        targetLanguage: Language
        targetLanguageText: string
        origin: LearningFeatureOrigin
        hasDefinitions: boolean
        id: string
        type: LearningFeatureType
        images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
      }
  >
}

export type GetFavoriteBooksQueryVariables = Exact<{
  subject: Subject
  classroomId: Scalars['ID']
  mainLearningId?: InputMaybe<Scalars['ID']>
}>

export type GetFavoriteBooksQuery = {
  __typename?: 'Query'
  favoriteBooks: Array<{
    __typename?: 'Book'
    id: string
    name: string
    image?: { __typename?: 'ImageType'; default: string; small?: string | null } | null
  }>
}

export type GetLearningActivityQueryVariables = Exact<{
  learningActivityId: Scalars['ID']
}>

export type GetLearningActivityQuery = {
  __typename?: 'Query'
  learningActivity: {
    __typename?: 'LearningActivity'
    id: string
    learningActivityExecutionId?: string | null
    contentSourceLabel?: string | null
    state: LearningActivityState
    activityType: ActivityType
    assignmentMode: AssignmentMode
    estimatedTimeInSeconds: number
    timeLimitSeconds?: number | null
    learningFeatureCount: number
    skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
    progress?: {
      __typename?: 'LearningActivityProgress'
      deadline?: string | null
      progress?: number | null
      total?: number | null
      type?: LearningActivityProgressType | null
    } | null
    learningFeatures: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | {
          __typename: 'LearningFeatureTranslationV2'
          sourceLanguage: Language
          sourceLanguageText: string
          sourceSoundUrls: Array<string>
          sourceVideoUrls: Array<string>
          targetLanguage: Language
          targetLanguageText: string
          targetSoundUrls: Array<string>
          targetVideoUrls: Array<string>
          origin: LearningFeatureOrigin
          hasSynonyms: boolean
          hasAntonyms: boolean
          hasDefinitions: boolean
          id: string
          type: LearningFeatureType
          images: Array<{ __typename?: 'ImageType'; small?: string | null; medium?: string | null; default: string }>
        }
    >
    gameProperties?: {
      __typename?: 'GameProperties'
      questionCount?: number | null
      coverStyle?: string | null
      isSoundEnabled?: boolean | null
      wheelOfFortuneType?: WheelOfFortuneType | null
      worksheetLexicalType?: string | null
      huntwordsAllDirections?: boolean | null
    } | null
  }
}

export type GetLearningPlanCategoriesQueryVariables = Exact<{
  learningPlanId: Scalars['ID']
}>

export type GetLearningPlanCategoriesQuery = {
  __typename?: 'Query'
  learningPlanCategories: Array<{
    __typename?: 'LearningPlanPageCategory'
    id: string
    name: string
    pageCount: number
    finishedPageCount: number
    archivedPageCount: number
    isArchived: boolean
    categoryType: LearningPlanPageCategoryType
    image?: { __typename?: 'ImageType'; medium?: string | null; default: string } | null
  }>
}

export type GetLearningPlanPageStreamQueryVariables = Exact<{
  streamId: Scalars['ID']
}>

export type GetLearningPlanPageStreamQuery = {
  __typename?: 'Query'
  learningPlanPageStream: {
    __typename?: 'LearningPlanPageStream'
    id: string
    name: string
    blocks: Array<
      | {
          __typename: 'LessonBlockActivity'
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          activity: {
            __typename?: 'LearningActivity'
            state: LearningActivityState
            activityType: ActivityType
            assignmentMode: AssignmentMode
            estimatedTimeInSeconds: number
            timeLimitSeconds?: number | null
            learningFeatureCount: number
            skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
            progress?: {
              __typename?: 'LearningActivityProgress'
              deadline?: string | null
              progress?: number | null
              total?: number | null
              type?: LearningActivityProgressType | null
            } | null
            gameProperties?: {
              __typename?: 'GameProperties'
              questionCount?: number | null
              coverStyle?: string | null
              isSoundEnabled?: boolean | null
              wheelOfFortuneType?: WheelOfFortuneType | null
              worksheetLexicalType?: string | null
              huntwordsAllDirections?: boolean | null
            } | null
          }
        }
      | {
          __typename: 'LessonBlockBookOrientation'
          pageFrom: number
          pageTo: number
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          book?: {
            __typename?: 'Book'
            id: string
            name: string
            level: Array<CEFRLevel>
            subject: Subject
            image?: { __typename?: 'ImageType'; medium?: string | null } | null
          } | null
        }
      | {
          __typename: 'LessonBlockContent'
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
        }
      | {
          __typename: 'LessonBlockFreeText'
          content: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
        }
      | {
          __typename: 'LessonBlockImages'
          description: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          images?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
        }
      | {
          __typename: 'LessonBlockMistakes'
          mistakeCount: number
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          mistakes: Array<{
            __typename?: 'Mistake'
            name: string
            textWithMistake: string
            wrongPart: string
            correctAnswer: string
            explanation?: string | null
            learningFeature?:
              | { __typename?: 'LearningFeatureGrammarV2'; id: string; type: LearningFeatureType }
              | { __typename?: 'LearningFeatureTranslationV2'; id: string; type: LearningFeatureType }
              | null
          }>
        }
      | {
          __typename: 'LessonBlockVideos'
          description: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          videos?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
        }
    >
  }
}

export type GetLearningPlanPageV2QueryVariables = Exact<{
  pageId: Scalars['ID']
}>

export type GetLearningPlanPageV2Query = {
  __typename?: 'Query'
  learningPlanPageV2: {
    __typename?: 'LearningPlanPageV2'
    id: string
    learningPlanId: string
    title: string
    isFinished: boolean
    isArchived: boolean
    isGenerated: boolean
    learningFeatureCount: number
    nextPageId?: string | null
    previousPageId?: string | null
    canBeExtended: boolean
    disabledLearningFeatures: Array<string>
    learningFeatures: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | {
          __typename: 'LearningFeatureTranslationV2'
          sourceLanguage: Language
          sourceLanguageText: string
          targetLanguage: Language
          targetLanguageText: string
          origin: LearningFeatureOrigin
          hasDefinitions: boolean
          id: string
          type: LearningFeatureType
          images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
        }
    >
    streams: Array<{ __typename?: 'LearningPlanPageStream'; id: string; name: string }>
    category: {
      __typename?: 'LearningPlanPageCategory'
      id: string
      name: string
      pageCount: number
      archivedPageCount: number
    }
  }
}

export type GetLearningPlanPagesV2QueryVariables = Exact<{
  learningPlanId: Scalars['ID']
  categoryId: Scalars['ID']
}>

export type GetLearningPlanPagesV2Query = {
  __typename?: 'Query'
  learningPlanPagesV2: Array<{
    __typename?: 'LearningPlanPageV2'
    id: string
    learningPlanId: string
    title: string
    isFinished: boolean
    isArchived: boolean
    isGenerated: boolean
    learningFeatureCount: number
    learningFeatures: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | { __typename: 'LearningFeatureTranslationV2'; targetLanguageText: string; id: string }
    >
  }>
}

export type GetLearningPlansQueryVariables = Exact<{
  classroomId: Scalars['ID']
}>

export type GetLearningPlansQuery = {
  __typename?: 'Query'
  learningPlans: Array<{
    __typename?: 'LearningPlan'
    id: string
    title: string
    color?: string | null
    unitNaming: string
    unitNumbering: NumberingType
    isActive: boolean
    isArchived: boolean
    extendLessons: boolean
    book?: {
      __typename?: 'Book'
      id: string
      name: string
      image?: { __typename?: 'ImageType'; default: string; small?: string | null } | null
    } | null
  }>
}

export type GetLessonBlockQueryVariables = Exact<{
  blockId: Scalars['ID']
}>

export type GetLessonBlockQuery = {
  __typename?: 'Query'
  lessonBlock:
    | {
        __typename: 'LessonBlockActivity'
        id: string
        name: string
        type: LessonBlockType
        streamId: string
        isPresentable: boolean
        activity: {
          __typename?: 'LearningActivity'
          id: string
          state: LearningActivityState
          activityType: ActivityType
          assignmentMode: AssignmentMode
          estimatedTimeInSeconds: number
          timeLimitSeconds?: number | null
          contentSourceLabel?: string | null
          learningFeatureCount: number
          skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
          progress?: {
            __typename?: 'LearningActivityProgress'
            deadline?: string | null
            progress?: number | null
            total?: number | null
            type?: LearningActivityProgressType | null
          } | null
          learningFeatures: Array<
            | {
                __typename: 'LearningFeatureGrammarV2'
                name: string
                subtitle: string
                level: CEFRLevel
                id: string
                type: LearningFeatureType
                origin: LearningFeatureOrigin
                example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
              }
            | {
                __typename: 'LearningFeatureTranslationV2'
                sourceLanguage: Language
                sourceLanguageText: string
                sourceSoundUrls: Array<string>
                sourceVideoUrls: Array<string>
                targetLanguage: Language
                targetLanguageText: string
                targetSoundUrls: Array<string>
                targetVideoUrls: Array<string>
                origin: LearningFeatureOrigin
                hasSynonyms: boolean
                hasAntonyms: boolean
                hasDefinitions: boolean
                id: string
                type: LearningFeatureType
                images: Array<{
                  __typename?: 'ImageType'
                  small?: string | null
                  medium?: string | null
                  default: string
                }>
              }
          >
          gameProperties?: {
            __typename?: 'GameProperties'
            questionCount?: number | null
            coverStyle?: string | null
            isSoundEnabled?: boolean | null
            wheelOfFortuneType?: WheelOfFortuneType | null
            worksheetLexicalType?: string | null
            huntwordsAllDirections?: boolean | null
          } | null
        }
      }
    | {
        __typename: 'LessonBlockBookOrientation'
        pageFrom: number
        pageTo: number
        id: string
        name: string
        type: LessonBlockType
        streamId: string
        isPresentable: boolean
        book?: {
          __typename?: 'Book'
          id: string
          name: string
          level: Array<CEFRLevel>
          subject: Subject
          image?: { __typename?: 'ImageType'; medium?: string | null } | null
        } | null
      }
    | {
        __typename: 'LessonBlockContent'
        id: string
        name: string
        type: LessonBlockType
        streamId: string
        isPresentable: boolean
      }
    | {
        __typename: 'LessonBlockFreeText'
        content: string
        id: string
        name: string
        type: LessonBlockType
        streamId: string
        isPresentable: boolean
      }
    | {
        __typename: 'LessonBlockImages'
        description: string
        id: string
        name: string
        type: LessonBlockType
        streamId: string
        isPresentable: boolean
        images?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
      }
    | {
        __typename: 'LessonBlockMistakes'
        mistakeCount: number
        id: string
        name: string
        type: LessonBlockType
        streamId: string
        isPresentable: boolean
        mistakes: Array<{
          __typename?: 'Mistake'
          name: string
          textWithMistake: string
          wrongPart: string
          correctAnswer: string
          explanation?: string | null
          learningFeature?:
            | { __typename?: 'LearningFeatureGrammarV2'; id: string; type: LearningFeatureType }
            | { __typename?: 'LearningFeatureTranslationV2'; id: string; type: LearningFeatureType }
            | null
        }>
      }
    | {
        __typename: 'LessonBlockVideos'
        description: string
        id: string
        name: string
        type: LessonBlockType
        streamId: string
        isPresentable: boolean
        videos?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
      }
}

export type GetSubjectsQueryVariables = Exact<{ [key: string]: never }>

export type GetSubjectsQuery = { __typename?: 'Query'; subjects: Array<Subject> }

export type GetWorksheetsAllowedTypesQueryVariables = Exact<{ [key: string]: never }>

export type GetWorksheetsAllowedTypesQuery = {
  __typename?: 'Query'
  worksheetsAllowedTypes: Array<{
    __typename?: 'WorksheetAllowedType'
    worksheetType: GQLWorksheetType
    allowedLexicalTypes: Array<GQLWorksheetLexicalType>
  }>
}

export type QuizBasedGameConfigurationPreviewQueryVariables = Exact<{
  learningActivityId: Scalars['ID']
  gameType: QuizBasedGameType
}>

export type QuizBasedGameConfigurationPreviewQuery = {
  __typename?: 'Query'
  quizBasedGameConfigurationByActivityId: {
    __typename?: 'QuizBasedGameConfiguration'
    id: string
    gameType: QuizBasedGameType
    groups: Array<{
      __typename?: 'QuizBasedGameConfigurationGroup'
      id: string
      name: string
      questions: Array<{
        __typename?: 'QuizBasedGameConfigurationQuestion'
        index: number
        text?: string | null
        lexicalType?: QuizBasedGameQuestionLexicalType | null
        learningFeatureDirection?: LearningFeatureDirection | null
        learningFeature?: {
          __typename?: 'LearningFeatureTranslationV2'
          id: string
          type: LearningFeatureType
          sourceLanguageText: string
          targetLanguageText: string
        } | null
        options: Array<{
          __typename?: 'QuizBasedGameConfigurationOption'
          index: number
          isCorrect: boolean
          text?: string | null
          learningFeature?: {
            __typename?: 'LearningFeatureTranslationV2'
            id: string
            sourceLanguageText: string
            targetLanguageText: string
          } | null
        }>
        media?: { __typename?: 'QuizBasedGameConfigurationMedia'; imageUrl?: string | null } | null
      }>
    }>
  }
}

export type SearchLearningPlanPagesQueryVariables = Exact<{
  learningPlanId: Scalars['ID']
  categoryId: Scalars['ID']
}>

export type SearchLearningPlanPagesQuery = {
  __typename?: 'Query'
  learningPlanPagesV2: Array<{ __typename?: 'LearningPlanPageV2'; id: string; title: string }>
}

export type StartLearningActivityMutationVariables = Exact<{
  learningActivityId: Scalars['ID']
}>

export type StartLearningActivityMutation = {
  __typename?: 'Mutation'
  startLearningActivity: {
    __typename?: 'LearningActivity'
    id: string
    state: LearningActivityState
    estimatedTimeInSeconds: number
    activityType: ActivityType
    assignmentMode: AssignmentMode
    contentSourceLabel?: string | null
    subject: Subject
    learningActivityExecutionId?: string | null
    learningFeatureCount: number
    progress?: {
      __typename?: 'LearningActivityProgress'
      deadline?: string | null
      progress?: number | null
      total?: number | null
      type?: LearningActivityProgressType | null
    } | null
    learningFeatures: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | {
          __typename: 'LearningFeatureTranslationV2'
          sourceLanguage: Language
          sourceLanguageText: string
          sourceSoundUrls: Array<string>
          sourceVideoUrls: Array<string>
          targetLanguage: Language
          targetLanguageText: string
          targetSoundUrls: Array<string>
          targetVideoUrls: Array<string>
          origin: LearningFeatureOrigin
          hasSynonyms: boolean
          hasAntonyms: boolean
          hasDefinitions: boolean
          id: string
          type: LearningFeatureType
          images: Array<{ __typename?: 'ImageType'; small?: string | null; medium?: string | null; default: string }>
        }
    >
    gameProperties?: {
      __typename?: 'GameProperties'
      questionCount?: number | null
      coverStyle?: string | null
      isSoundEnabled?: boolean | null
      wheelOfFortuneType?: WheelOfFortuneType | null
      worksheetLexicalType?: string | null
      huntwordsAllDirections?: boolean | null
    } | null
  }
}

export type StopLearningActivityMutationVariables = Exact<{
  learningActivityId: Scalars['ID']
}>

export type StopLearningActivityMutation = {
  __typename?: 'Mutation'
  stopLearningActivity: {
    __typename?: 'LearningActivity'
    id: string
    state: LearningActivityState
    learningActivityExecutionId?: string | null
    progress?: {
      __typename?: 'LearningActivityProgress'
      deadline?: string | null
      progress?: number | null
      total?: number | null
      type?: LearningActivityProgressType | null
    } | null
  }
}

export type UpdateFavoriteBooksMutationVariables = Exact<{
  subject: Subject
  classroomId: Scalars['ID']
  mainLearningId?: InputMaybe<Scalars['ID']>
  bookIds: Array<Scalars['ID']> | Scalars['ID']
}>

export type UpdateFavoriteBooksMutation = {
  __typename?: 'Mutation'
  updateFavoriteBooks: Array<{
    __typename?: 'Book'
    id: string
    name: string
    level: Array<CEFRLevel>
    image?: { __typename?: 'ImageType'; default: string; small?: string | null } | null
  }>
}

export type UpdateLearningActivityMutationVariables = Exact<{
  learningActivityId: Scalars['ID']
  learningActivityInput: LearningActivityInput
}>

export type UpdateLearningActivityMutation = {
  __typename?: 'Mutation'
  updateLearningActivity: {
    __typename?: 'LearningActivity'
    id: string
    state: LearningActivityState
    activityType: ActivityType
    assignmentMode: AssignmentMode
    estimatedTimeInSeconds: number
    timeLimitSeconds?: number | null
    learningFeatureCount: number
    skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
    progress?: {
      __typename?: 'LearningActivityProgress'
      deadline?: string | null
      progress?: number | null
      total?: number | null
      type?: LearningActivityProgressType | null
    } | null
    gameProperties?: {
      __typename?: 'GameProperties'
      questionCount?: number | null
      coverStyle?: string | null
      isSoundEnabled?: boolean | null
      wheelOfFortuneType?: WheelOfFortuneType | null
      worksheetLexicalType?: string | null
      huntwordsAllDirections?: boolean | null
    } | null
  }
}

export type UpdateLearningPlanMutationVariables = Exact<{
  learningPlanId: Scalars['ID']
  learningPlanInput: LearningPlanInput
}>

export type UpdateLearningPlanMutation = {
  __typename?: 'Mutation'
  updateLearningPlan: {
    __typename?: 'LearningPlan'
    id: string
    title: string
    color?: string | null
    unitNaming: string
    unitNumbering: NumberingType
    isActive: boolean
    isArchived: boolean
    extendLessons: boolean
    book?: {
      __typename?: 'Book'
      id: string
      name: string
      image?: { __typename?: 'ImageType'; default: string; small?: string | null } | null
    } | null
  }
}

export type UpdateLearningPlanPageCategoryMutationVariables = Exact<{
  id: Scalars['ID']
  input: LearningPlanPageCategoryInput
}>

export type UpdateLearningPlanPageCategoryMutation = {
  __typename?: 'Mutation'
  updateLearningPlanPageCategory: {
    __typename?: 'LearningPlanPageCategory'
    id: string
    name: string
    pageCount: number
    finishedPageCount: number
    archivedPageCount: number
    isArchived: boolean
    categoryType: LearningPlanPageCategoryType
  }
}

export type UpdateLearningPlanPageStreamMutationVariables = Exact<{
  streamId: Scalars['ID']
  learningPlanPageStreamInput: LearningPlanPageStreamInput
}>

export type UpdateLearningPlanPageStreamMutation = {
  __typename?: 'Mutation'
  updateLearningPlanPageStream: {
    __typename?: 'LearningPlanPageStream'
    id: string
    name: string
    blocks: Array<
      | {
          __typename: 'LessonBlockActivity'
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          activity: {
            __typename?: 'LearningActivity'
            state: LearningActivityState
            activityType: ActivityType
            assignmentMode: AssignmentMode
            estimatedTimeInSeconds: number
            timeLimitSeconds?: number | null
            learningFeatureCount: number
            skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
            progress?: {
              __typename?: 'LearningActivityProgress'
              deadline?: string | null
              progress?: number | null
              total?: number | null
              type?: LearningActivityProgressType | null
            } | null
            gameProperties?: {
              __typename?: 'GameProperties'
              questionCount?: number | null
              coverStyle?: string | null
              isSoundEnabled?: boolean | null
              wheelOfFortuneType?: WheelOfFortuneType | null
              worksheetLexicalType?: string | null
              huntwordsAllDirections?: boolean | null
            } | null
          }
        }
      | {
          __typename: 'LessonBlockBookOrientation'
          pageFrom: number
          pageTo: number
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          book?: {
            __typename?: 'Book'
            id: string
            name: string
            level: Array<CEFRLevel>
            subject: Subject
            image?: { __typename?: 'ImageType'; medium?: string | null } | null
          } | null
        }
      | {
          __typename: 'LessonBlockContent'
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
        }
      | {
          __typename: 'LessonBlockFreeText'
          content: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
        }
      | {
          __typename: 'LessonBlockImages'
          description: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          images?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
        }
      | {
          __typename: 'LessonBlockMistakes'
          mistakeCount: number
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          mistakes: Array<{
            __typename?: 'Mistake'
            name: string
            textWithMistake: string
            wrongPart: string
            correctAnswer: string
            explanation?: string | null
            learningFeature?:
              | { __typename?: 'LearningFeatureGrammarV2'; id: string; type: LearningFeatureType }
              | { __typename?: 'LearningFeatureTranslationV2'; id: string; type: LearningFeatureType }
              | null
          }>
        }
      | {
          __typename: 'LessonBlockVideos'
          description: string
          id: string
          type: LessonBlockType
          name: string
          streamId: string
          isPresentable: boolean
          videos?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
        }
    >
  }
}

export type UpdateLearningPlanPageV2MutationVariables = Exact<{
  pageId: Scalars['ID']
  learningPlanPageInput: LearningPlanPageInputV2
  generate: Scalars['Boolean']
  categoryId?: InputMaybe<Scalars['ID']>
}>

export type UpdateLearningPlanPageV2Mutation = {
  __typename?: 'Mutation'
  updateLearningPlanPageV2: {
    __typename?: 'LearningPlanPageV2'
    id: string
    learningPlanId: string
    title: string
    isFinished: boolean
    isArchived: boolean
    isGenerated: boolean
    learningFeatureCount: number
    canBeExtended: boolean
    disabledLearningFeatures: Array<string>
    learningFeatures: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | {
          __typename: 'LearningFeatureTranslationV2'
          sourceLanguage: Language
          sourceLanguageText: string
          targetLanguage: Language
          targetLanguageText: string
          origin: LearningFeatureOrigin
          hasDefinitions: boolean
          id: string
          type: LearningFeatureType
          images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
        }
    >
    category: {
      __typename?: 'LearningPlanPageCategory'
      id: string
      name: string
      pageCount: number
      archivedPageCount: number
    }
    streams: Array<{ __typename?: 'LearningPlanPageStream'; id: string; name: string }>
  }
}

export type UpdateLessonBlockMutationVariables = Exact<{
  blockId: Scalars['ID']
  blockInput: LessonBlockInput
}>

export type UpdateLessonBlockMutation = {
  __typename?: 'Mutation'
  updateLessonBlock:
    | {
        __typename: 'LessonBlockActivity'
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        activity: {
          __typename?: 'LearningActivity'
          state: LearningActivityState
          activityType: ActivityType
          assignmentMode: AssignmentMode
          estimatedTimeInSeconds: number
          timeLimitSeconds?: number | null
          learningFeatureCount: number
          skills: Array<{ __typename?: 'LearningActivitySkill'; skill: Skill; isActive: boolean }>
          progress?: {
            __typename?: 'LearningActivityProgress'
            deadline?: string | null
            progress?: number | null
            total?: number | null
            type?: LearningActivityProgressType | null
          } | null
          gameProperties?: {
            __typename?: 'GameProperties'
            questionCount?: number | null
            coverStyle?: string | null
            isSoundEnabled?: boolean | null
            wheelOfFortuneType?: WheelOfFortuneType | null
            worksheetLexicalType?: string | null
            huntwordsAllDirections?: boolean | null
          } | null
        }
      }
    | {
        __typename: 'LessonBlockBookOrientation'
        pageFrom: number
        pageTo: number
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        book?: {
          __typename?: 'Book'
          id: string
          name: string
          level: Array<CEFRLevel>
          subject: Subject
          image?: { __typename?: 'ImageType'; medium?: string | null } | null
        } | null
      }
    | {
        __typename: 'LessonBlockContent'
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
      }
    | {
        __typename: 'LessonBlockFreeText'
        content: string
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
      }
    | {
        __typename: 'LessonBlockImages'
        description: string
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        images?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
      }
    | {
        __typename: 'LessonBlockMistakes'
        mistakeCount: number
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        mistakes: Array<{
          __typename?: 'Mistake'
          name: string
          textWithMistake: string
          wrongPart: string
          correctAnswer: string
          explanation?: string | null
          learningFeature?:
            | { __typename?: 'LearningFeatureGrammarV2'; id: string; type: LearningFeatureType }
            | { __typename?: 'LearningFeatureTranslationV2'; id: string; type: LearningFeatureType }
            | null
        }>
      }
    | {
        __typename: 'LessonBlockVideos'
        description: string
        id: string
        type: LessonBlockType
        name: string
        streamId: string
        isPresentable: boolean
        videos?: Array<{ __typename?: 'BlockAsset'; name: string; url: string }> | null
      }
}

export type UpdateUserLearningFeatureMutationVariables = Exact<{
  learningFeatureId: Scalars['ID']
  userLearningFeature: UserLearningFeatureInput
}>

export type UpdateUserLearningFeatureMutation = {
  __typename?: 'Mutation'
  updateUserLearningFeature: {
    __typename: 'LearningFeatureTranslationV2'
    id: string
    sourceLanguage: Language
    sourceLanguageText: string
    targetLanguage: Language
    targetLanguageText: string
    level?: CEFRLevel | null
    type: LearningFeatureType
    origin: LearningFeatureOrigin
  }
}

export type GetWorksheetsForActivityQueryVariables = Exact<{
  learningActivityId: Scalars['ID']
}>

export type GetWorksheetsForActivityQuery = {
  __typename?: 'Query'
  worksheetsForActivity: Array<{
    __typename?: 'WorksheetPdf'
    fileName: string
    worksheetType: GQLWorksheetType
    worksheetLexicalType: GQLWorksheetLexicalType
    contentBase64: string
  }>
}

export type CreateLibraryItemPackageMutationVariables = Exact<{
  subject: Subject
  libraryItemPackageInput: LibraryItemPackageInput
  packageId?: InputMaybe<Scalars['ID']>
}>

export type CreateLibraryItemPackageMutation = {
  __typename?: 'Mutation'
  createLibraryItemPackage: {
    __typename: 'LibraryItemPackage'
    id: string
    name: string
    label?: string | null
    level: Array<CEFRLevel>
    learningFeaturesCount: number
    image?: { __typename?: 'ImageType'; medium?: string | null; default: string } | null
  }
}

export type DeleteLibraryItemMutationVariables = Exact<{
  libraryItemId: Scalars['ID']
  libraryItemType: LibraryItemType
}>

export type DeleteLibraryItemMutation = { __typename?: 'Mutation'; deleteLibraryItem: boolean }

export type GetBookDetailQueryVariables = Exact<{
  bookId: Scalars['ID']
  withPackages: Scalars['Boolean']
}>

export type GetBookDetailQuery = {
  __typename?: 'Query'
  bookDetail: {
    __typename?: 'Book'
    id: string
    name: string
    sourceLanguage: Language
    learningFeatureCount: number
    level: Array<CEFRLevel>
    subject: Subject
    image?: { __typename?: 'ImageType'; default: string; small?: string | null; medium?: string | null } | null
    units: Array<{
      __typename?: 'LibraryItemCollection'
      id: string
      name: string
      label?: string | null
      packagesCount: number
      packages?: Array<{
        __typename?: 'LibraryItemPackage'
        id: string
        name: string
        label?: string | null
        level: Array<CEFRLevel>
        learningFeaturesCount: number
        foxinoOwned: boolean
        image?: { __typename?: 'ImageType'; default: string; medium?: string | null } | null
      }>
    }>
  }
}

export type GetLibraryBookItemsQueryVariables = Exact<{
  filters: LibraryItemsFilterInput
  page: PageableInput
}>

export type GetLibraryBookItemsQuery = {
  __typename?: 'Query'
  libraryBookItems: {
    __typename?: 'LibraryBooks'
    filters: { __typename?: 'LibraryItemsFilter'; level?: Array<CEFRLevel | null> | null; tags?: Array<string> | null }
    books: Array<{
      __typename: 'Book'
      id: string
      name: string
      level: Array<CEFRLevel>
      image?: {
        __typename?: 'ImageType'
        medium?: string | null
        default: string
        imageId?: { __typename?: 'ImageIdType'; namespace: string; commonName: string } | null
      } | null
    }>
  }
}

export type GetLibraryCollectionItemsQueryVariables = Exact<{
  filters: LibraryItemsFilterInput
  page: PageableInput
}>

export type GetLibraryCollectionItemsQuery = {
  __typename?: 'Query'
  libraryCollectionItems: {
    __typename?: 'LibraryCollections'
    filters: { __typename?: 'LibraryItemsFilter'; level?: Array<CEFRLevel | null> | null; tags?: Array<string> | null }
    collections: Array<{
      __typename?: 'LibraryItemCollection'
      id: string
      name: string
      label?: string | null
      level: Array<CEFRLevel>
      packagesCount: number
      image?: {
        __typename?: 'ImageType'
        medium?: string | null
        default: string
        imageId?: { __typename?: 'ImageIdType'; namespace: string; commonName: string } | null
      } | null
    }>
  }
}

export type GetLibraryItemCollectionDetailQueryVariables = Exact<{
  libraryItemId: Scalars['ID']
  textSearch: Scalars['String']
  withLearningFeatures: Scalars['Boolean']
}>

export type GetLibraryItemCollectionDetailQuery = {
  __typename?: 'Query'
  libraryItemCollectionDetail: {
    __typename: 'LibraryItemCollection'
    id: string
    name: string
    label?: string | null
    type: LibraryItemType
    level: Array<CEFRLevel>
    image?: {
      __typename?: 'ImageType'
      medium?: string | null
      default: string
      imageId?: { __typename?: 'ImageIdType'; namespace: string; commonName: string } | null
    } | null
    packages: Array<{
      __typename?: 'LibraryItemPackage'
      id: string
      name: string
      learningFeaturesCount: number
      foxinoOwned: boolean
      level: Array<CEFRLevel>
      createdBy?: { __typename?: 'UserProfile'; firstName: string; lastName: string; email: string } | null
      learningFeatures?: Array<
        | {
            __typename: 'LearningFeatureGrammarV2'
            name: string
            subtitle: string
            level: CEFRLevel
            id: string
            type: LearningFeatureType
            origin: LearningFeatureOrigin
            example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
          }
        | {
            __typename: 'LearningFeatureTranslationV2'
            sourceLanguage: Language
            sourceLanguageText: string
            targetLanguage: Language
            targetLanguageText: string
            origin: LearningFeatureOrigin
            hasDefinitions: boolean
            id: string
            type: LearningFeatureType
            images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
          }
      >
      image?: { __typename?: 'ImageType'; medium?: string | null; default: string } | null
    }>
  }
}

export type GetLibraryMyPackageItemsQueryVariables = Exact<{
  filters: LibraryItemsFilterInput
  page: PageableInput
}>

export type GetLibraryMyPackageItemsQuery = {
  __typename?: 'Query'
  libraryMyContentItems: {
    __typename?: 'LibraryMyContent'
    filters: { __typename?: 'LibraryItemsFilter'; level?: Array<CEFRLevel | null> | null; tags?: Array<string> | null }
    myContent: Array<{
      __typename?: 'LibraryItemPackage'
      id: string
      name: string
      label?: string | null
      borderColor?: string | null
      level: Array<CEFRLevel>
      learningFeaturesCount: number
      image?: { __typename?: 'ImageType'; small?: string | null; medium?: string | null; default: string } | null
    }>
  }
}

export type GetWorksheetsFromLibraryQueryVariables = Exact<{
  activityType: ActivityType
  lexicalType: GQLWorksheetLexicalType
  name: Scalars['String']
  learningFeaturesIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>
}>

export type GetWorksheetsFromLibraryQuery = {
  __typename?: 'Query'
  worksheetsFromLibrary: Array<{
    __typename?: 'WorksheetPdf'
    fileName: string
    contentBase64: string
    worksheetType: GQLWorksheetType
    worksheetLexicalType: GQLWorksheetLexicalType
  }>
}

export type SearchCoverImagesQueryVariables = Exact<{
  search: Scalars['String']
  subject: Subject
  page: PageableInput
}>

export type SearchCoverImagesQuery = {
  __typename?: 'Query'
  searchCoverImages: Array<{
    __typename?: 'ImageType'
    small?: string | null
    default: string
    imageId?: { __typename?: 'ImageIdType'; namespace: string; commonName: string } | null
  }>
}

export type SearchDictionaryLearningFeatureQueryVariables = Exact<{
  searchLearningFeatureInput: SearchDictionaryLearningFeatureInput
  page: PageableInput
  filter?: InputMaybe<SearchDictionaryFilterInput>
}>

export type SearchDictionaryLearningFeatureQuery = {
  __typename?: 'Query'
  searchDictionaryLearningFeature: Array<{
    __typename: 'LearningFeatureTranslationV2'
    id: string
    origin: LearningFeatureOrigin
    type: LearningFeatureType
    sourceLanguage: Language
    targetLanguage: Language
    sourceLanguageText: string
    targetLanguageText: string
    level?: CEFRLevel | null
  }>
}

export type UpdateLibraryItemPackageMutationVariables = Exact<{
  packageId: Scalars['ID']
  libraryItemPackageInput: LibraryItemPackageInput
}>

export type UpdateLibraryItemPackageMutation = {
  __typename?: 'Mutation'
  updateLibraryItemPackage: {
    __typename?: 'LibraryItemPackage'
    id: string
    name: string
    label?: string | null
    borderColor?: string | null
    learningFeaturesCount: number
    image?: { __typename?: 'ImageType'; medium?: string | null; default: string } | null
    createdBy?: { __typename?: 'UserProfile'; firstName: string; lastName: string; email: string } | null
    learningFeatures: Array<
      | {
          __typename: 'LearningFeatureGrammarV2'
          name: string
          subtitle: string
          level: CEFRLevel
          id: string
          type: LearningFeatureType
          origin: LearningFeatureOrigin
          example: { __typename?: 'LearningFeatureGrammarExample'; fullText: string; template: string }
        }
      | {
          __typename: 'LearningFeatureTranslationV2'
          sourceLanguage: Language
          sourceLanguageText: string
          targetLanguage: Language
          targetLanguageText: string
          origin: LearningFeatureOrigin
          hasDefinitions: boolean
          id: string
          type: LearningFeatureType
          images: Array<{ __typename?: 'ImageType'; small?: string | null; default: string }>
        }
    >
  }
}

export type AddUserRoleMutationVariables = Exact<{
  userRole: UserRole
}>

export type AddUserRoleMutation = { __typename?: 'Mutation'; addUserRole: boolean }

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never }>

export type GetUserProfileQuery = {
  __typename?: 'Query'
  userProfile: {
    __typename?: 'UserProfile'
    id: string
    pictureUrl?: string | null
    firstName: string
    lastName: string
    username: string
    email: string
    hasPin: boolean
    pinType?: PinType | null
  }
}

export type UpdateUserProfileMutationVariables = Exact<{
  userProfile?: InputMaybe<UserProfileInput>
}>

export type UpdateUserProfileMutation = {
  __typename?: 'Mutation'
  updateUserProfile: {
    __typename?: 'UserProfile'
    id: string
    firstName: string
    lastName: string
    pictureUrl?: string | null
    appLanguage: Language
  }
}

export const TeacherAnalyticStudentAccuracyDetailFragmentDoc = gql`
  fragment TeacherAnalyticStudentAccuracyDetail on TeacherAnalyticAccuracy {
    accuracy {
      points
      delta
    }
    skills {
      skill
      delta
      value
      previousValue
      histogram {
        points
        counts
      }
    }
    executionTotalCount
    almostCorrectExecutionCount
    correctExecutionsCount
  }
`
export const LearningFeatureActivityFragmentFragmentDoc = gql`
  fragment LearningFeatureActivityFragment on LearningFeatureV2 {
    __typename
    id
    type
    origin
    ... on LearningFeatureTranslationV2 {
      sourceLanguage
      sourceLanguageText
      sourceSoundUrls
      sourceVideoUrls
      targetLanguage
      targetLanguageText
      targetSoundUrls
      targetVideoUrls
      origin
      hasSynonyms
      hasAntonyms
      hasDefinitions
      images {
        small
        medium
        default
      }
    }
    ... on LearningFeatureGrammarV2 {
      name
      subtitle
      level
      level
      example {
        fullText
        template
      }
    }
  }
`
export const LearningFeatureShortDetailFragmentDoc = gql`
  fragment LearningFeatureShortDetail on LearningFeatureV2 {
    __typename
    id
    type
    origin
    ... on LearningFeatureTranslationV2 {
      sourceLanguage
      sourceLanguageText
      targetLanguage
      targetLanguageText
      origin
      hasDefinitions
      images {
        small
        default
      }
    }
    ... on LearningFeatureGrammarV2 {
      name
      subtitle
      level
      level
      example {
        fullText
        template
      }
    }
  }
`
export const LessonBlockShortFragmentFragmentDoc = gql`
  fragment LessonBlockShortFragment on LessonBlock {
    __typename
    id
    type
    name
    streamId
    isPresentable
    ... on LessonBlockActivity {
      activity {
        state
        activityType
        assignmentMode
        estimatedTimeInSeconds
        timeLimitSeconds
        skills {
          skill
          isActive
        }
        progress {
          deadline
          progress
          total
          type
        }
        learningFeatureCount
        gameProperties {
          questionCount
          coverStyle
          isSoundEnabled
          wheelOfFortuneType
          worksheetLexicalType
          huntwordsAllDirections
        }
      }
    }
    ... on LessonBlockBookOrientation {
      book {
        id
        name
        level
        subject
        image {
          medium
        }
      }
      pageFrom
      pageTo
    }
    ... on LessonBlockFreeText {
      content
    }
    ... on LessonBlockMistakes {
      mistakeCount
      mistakes {
        name
        textWithMistake
        wrongPart
        correctAnswer
        explanation
        learningFeature {
          id
          type
        }
      }
    }
    ... on LessonBlockImages {
      description
      images {
        name
        url
      }
    }
    ... on LessonBlockVideos {
      description
      videos {
        name
        url
      }
    }
  }
`
export const GetTeacherAnalyticActivitiesDocument = gql`
  query getTeacherAnalyticActivities($classroomId: ID!, $window: TeacherAnalyticWindow!) {
    teacherAnalyticActivities(classroomId: $classroomId, window: $window) {
      homeworks {
        id
        type
        state
      }
      tests {
        id
        type
        state
      }
      activities {
        id
        type
        state
      }
    }
  }
`

/**
 * __useGetTeacherAnalyticActivitiesQuery__
 *
 * To run a query within a React component, call `useGetTeacherAnalyticActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherAnalyticActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherAnalyticActivitiesQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetTeacherAnalyticActivitiesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTeacherAnalyticActivitiesQuery,
    GetTeacherAnalyticActivitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetTeacherAnalyticActivitiesQuery, GetTeacherAnalyticActivitiesQueryVariables>(
    GetTeacherAnalyticActivitiesDocument,
    options
  )
}
export function useGetTeacherAnalyticActivitiesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTeacherAnalyticActivitiesQuery,
    GetTeacherAnalyticActivitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetTeacherAnalyticActivitiesQuery, GetTeacherAnalyticActivitiesQueryVariables>(
    GetTeacherAnalyticActivitiesDocument,
    options
  )
}
export type GetTeacherAnalyticActivitiesQueryHookResult = ReturnType<typeof useGetTeacherAnalyticActivitiesQuery>
export type GetTeacherAnalyticActivitiesLazyQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticActivitiesLazyQuery
>
export type GetTeacherAnalyticActivitiesQueryResult = Apollo.QueryResult<
  GetTeacherAnalyticActivitiesQuery,
  GetTeacherAnalyticActivitiesQueryVariables
>
export const GetTeacherAnalyticNotableAchieversDocument = gql`
  query getTeacherAnalyticNotableAchievers($classroomId: ID!, $window: TeacherAnalyticWindow! = DAYS_30) {
    teacherAnalyticNotableAchievers(classroomId: $classroomId, window: $window) {
      achievement
      students {
        id
        pictureUrl
        firstName
        lastName
      }
    }
  }
`

/**
 * __useGetTeacherAnalyticNotableAchieversQuery__
 *
 * To run a query within a React component, call `useGetTeacherAnalyticNotableAchieversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherAnalyticNotableAchieversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherAnalyticNotableAchieversQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetTeacherAnalyticNotableAchieversQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTeacherAnalyticNotableAchieversQuery,
    GetTeacherAnalyticNotableAchieversQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetTeacherAnalyticNotableAchieversQuery,
    GetTeacherAnalyticNotableAchieversQueryVariables
  >(GetTeacherAnalyticNotableAchieversDocument, options)
}
export function useGetTeacherAnalyticNotableAchieversLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTeacherAnalyticNotableAchieversQuery,
    GetTeacherAnalyticNotableAchieversQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetTeacherAnalyticNotableAchieversQuery,
    GetTeacherAnalyticNotableAchieversQueryVariables
  >(GetTeacherAnalyticNotableAchieversDocument, options)
}
export type GetTeacherAnalyticNotableAchieversQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticNotableAchieversQuery
>
export type GetTeacherAnalyticNotableAchieversLazyQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticNotableAchieversLazyQuery
>
export type GetTeacherAnalyticNotableAchieversQueryResult = Apollo.QueryResult<
  GetTeacherAnalyticNotableAchieversQuery,
  GetTeacherAnalyticNotableAchieversQueryVariables
>
export const GetTeacherAnalyticSkillsDocument = gql`
  query getTeacherAnalyticSkills($classroomId: ID!, $window: TeacherAnalyticWindow! = DAYS_30) {
    teacherAnalyticSkills(classroomId: $classroomId, window: $window) {
      skill
      delta
      value
      previousValue
    }
  }
`

/**
 * __useGetTeacherAnalyticSkillsQuery__
 *
 * To run a query within a React component, call `useGetTeacherAnalyticSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherAnalyticSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherAnalyticSkillsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetTeacherAnalyticSkillsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetTeacherAnalyticSkillsQuery, GetTeacherAnalyticSkillsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetTeacherAnalyticSkillsQuery, GetTeacherAnalyticSkillsQueryVariables>(
    GetTeacherAnalyticSkillsDocument,
    options
  )
}
export function useGetTeacherAnalyticSkillsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTeacherAnalyticSkillsQuery,
    GetTeacherAnalyticSkillsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetTeacherAnalyticSkillsQuery, GetTeacherAnalyticSkillsQueryVariables>(
    GetTeacherAnalyticSkillsDocument,
    options
  )
}
export type GetTeacherAnalyticSkillsQueryHookResult = ReturnType<typeof useGetTeacherAnalyticSkillsQuery>
export type GetTeacherAnalyticSkillsLazyQueryHookResult = ReturnType<typeof useGetTeacherAnalyticSkillsLazyQuery>
export type GetTeacherAnalyticSkillsQueryResult = Apollo.QueryResult<
  GetTeacherAnalyticSkillsQuery,
  GetTeacherAnalyticSkillsQueryVariables
>
export const GetTeacherAnalyticStudentAtRiskDocument = gql`
  query getTeacherAnalyticStudentAtRisk($classroomId: ID!, $window: TeacherAnalyticWindow! = DAYS_30) {
    teacherAnalyticStudentAtRisk(classroomId: $classroomId, window: $window) {
      riskLevel
      students {
        id
        email
        pictureUrl
        firstName
        lastName
      }
    }
  }
`

/**
 * __useGetTeacherAnalyticStudentAtRiskQuery__
 *
 * To run a query within a React component, call `useGetTeacherAnalyticStudentAtRiskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherAnalyticStudentAtRiskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherAnalyticStudentAtRiskQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetTeacherAnalyticStudentAtRiskQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTeacherAnalyticStudentAtRiskQuery,
    GetTeacherAnalyticStudentAtRiskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetTeacherAnalyticStudentAtRiskQuery, GetTeacherAnalyticStudentAtRiskQueryVariables>(
    GetTeacherAnalyticStudentAtRiskDocument,
    options
  )
}
export function useGetTeacherAnalyticStudentAtRiskLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTeacherAnalyticStudentAtRiskQuery,
    GetTeacherAnalyticStudentAtRiskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetTeacherAnalyticStudentAtRiskQuery,
    GetTeacherAnalyticStudentAtRiskQueryVariables
  >(GetTeacherAnalyticStudentAtRiskDocument, options)
}
export type GetTeacherAnalyticStudentAtRiskQueryHookResult = ReturnType<typeof useGetTeacherAnalyticStudentAtRiskQuery>
export type GetTeacherAnalyticStudentAtRiskLazyQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticStudentAtRiskLazyQuery
>
export type GetTeacherAnalyticStudentAtRiskQueryResult = Apollo.QueryResult<
  GetTeacherAnalyticStudentAtRiskQuery,
  GetTeacherAnalyticStudentAtRiskQueryVariables
>
export const GetTeacherAnalyticStudentPerformanceDetailDocument = gql`
  query getTeacherAnalyticStudentPerformanceDetail(
    $classroomId: ID!
    $studentId: ID!
    $window: TeacherAnalyticWindow! = DAYS_30
  ) {
    teacherAnalyticStudentPerformanceDetail(classroomId: $classroomId, studentId: $studentId, window: $window) {
      level
      student {
        userProfile {
          id
          email
          pictureUrl
          firstName
          lastName
        }
        studentLastActivity
      }
      overallPerformance {
        percentile
        studentPoints
        atLevelPoints
      }
      commonMistakes {
        learningFeature {
          id
          type
          origin
          sourceLanguage
          targetLanguage
          sourceLanguageText
          targetLanguageText
        }
        mistakeCount
      }
      vocabularyMastery {
        percentile
        vocabularyCurrentState {
          state
          points
          delta
        }
        vocabularyComposition {
          level
          percent
        }
      }
      note
      practiceTime
      standing
      tags
      assignments {
        type
        totalCount
        inProgressCount
        completedCount
      }
      practiceAccuracy {
        ...TeacherAnalyticStudentAccuracyDetail
      }
      testAccuracy {
        ...TeacherAnalyticStudentAccuracyDetail
      }
      overallAccuracy {
        ...TeacherAnalyticStudentAccuracyDetail
      }
    }
  }
  ${TeacherAnalyticStudentAccuracyDetailFragmentDoc}
`

/**
 * __useGetTeacherAnalyticStudentPerformanceDetailQuery__
 *
 * To run a query within a React component, call `useGetTeacherAnalyticStudentPerformanceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherAnalyticStudentPerformanceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherAnalyticStudentPerformanceDetailQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      studentId: // value for 'studentId'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetTeacherAnalyticStudentPerformanceDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTeacherAnalyticStudentPerformanceDetailQuery,
    GetTeacherAnalyticStudentPerformanceDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetTeacherAnalyticStudentPerformanceDetailQuery,
    GetTeacherAnalyticStudentPerformanceDetailQueryVariables
  >(GetTeacherAnalyticStudentPerformanceDetailDocument, options)
}
export function useGetTeacherAnalyticStudentPerformanceDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTeacherAnalyticStudentPerformanceDetailQuery,
    GetTeacherAnalyticStudentPerformanceDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetTeacherAnalyticStudentPerformanceDetailQuery,
    GetTeacherAnalyticStudentPerformanceDetailQueryVariables
  >(GetTeacherAnalyticStudentPerformanceDetailDocument, options)
}
export type GetTeacherAnalyticStudentPerformanceDetailQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticStudentPerformanceDetailQuery
>
export type GetTeacherAnalyticStudentPerformanceDetailLazyQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticStudentPerformanceDetailLazyQuery
>
export type GetTeacherAnalyticStudentPerformanceDetailQueryResult = Apollo.QueryResult<
  GetTeacherAnalyticStudentPerformanceDetailQuery,
  GetTeacherAnalyticStudentPerformanceDetailQueryVariables
>
export const GetTeacherAnalyticStudentsPerformanceDocument = gql`
  query getTeacherAnalyticStudentsPerformance($classroomId: ID!, $window: TeacherAnalyticWindow! = DAYS_30) {
    teacherAnalyticStudentsPerformance(classroomId: $classroomId, window: $window) {
      level
      student {
        userProfile {
          id
          email
          pictureUrl
          firstName
          lastName
        }
      }
      practiceTime
      standing
      tags
      assignments {
        type
        totalCount
        inProgressCount
        completedCount
      }
      practiceAccuracy {
        accuracy {
          points
          delta
        }
      }
      testAccuracy {
        accuracy {
          points
          delta
        }
      }
      overallAccuracy {
        accuracy {
          points
          delta
        }
      }
    }
  }
`

/**
 * __useGetTeacherAnalyticStudentsPerformanceQuery__
 *
 * To run a query within a React component, call `useGetTeacherAnalyticStudentsPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherAnalyticStudentsPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherAnalyticStudentsPerformanceQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetTeacherAnalyticStudentsPerformanceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTeacherAnalyticStudentsPerformanceQuery,
    GetTeacherAnalyticStudentsPerformanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetTeacherAnalyticStudentsPerformanceQuery,
    GetTeacherAnalyticStudentsPerformanceQueryVariables
  >(GetTeacherAnalyticStudentsPerformanceDocument, options)
}
export function useGetTeacherAnalyticStudentsPerformanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTeacherAnalyticStudentsPerformanceQuery,
    GetTeacherAnalyticStudentsPerformanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetTeacherAnalyticStudentsPerformanceQuery,
    GetTeacherAnalyticStudentsPerformanceQueryVariables
  >(GetTeacherAnalyticStudentsPerformanceDocument, options)
}
export type GetTeacherAnalyticStudentsPerformanceQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticStudentsPerformanceQuery
>
export type GetTeacherAnalyticStudentsPerformanceLazyQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticStudentsPerformanceLazyQuery
>
export type GetTeacherAnalyticStudentsPerformanceQueryResult = Apollo.QueryResult<
  GetTeacherAnalyticStudentsPerformanceQuery,
  GetTeacherAnalyticStudentsPerformanceQueryVariables
>
export const GetTeacherAnalyticVocabularyLevelDocument = gql`
  query getTeacherAnalyticVocabularyLevel($classroomId: ID!) {
    teacherAnalyticVocabularyLevel(classroomId: $classroomId) {
      studentsLevelPerformance {
        student {
          id
          firstName
          lastName
        }
        points
        percentage
        level
      }
      classroomAveragePoints
      classroomAveragePercentage
      classroomLevel
    }
  }
`

/**
 * __useGetTeacherAnalyticVocabularyLevelQuery__
 *
 * To run a query within a React component, call `useGetTeacherAnalyticVocabularyLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherAnalyticVocabularyLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherAnalyticVocabularyLevelQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useGetTeacherAnalyticVocabularyLevelQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTeacherAnalyticVocabularyLevelQuery,
    GetTeacherAnalyticVocabularyLevelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetTeacherAnalyticVocabularyLevelQuery,
    GetTeacherAnalyticVocabularyLevelQueryVariables
  >(GetTeacherAnalyticVocabularyLevelDocument, options)
}
export function useGetTeacherAnalyticVocabularyLevelLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTeacherAnalyticVocabularyLevelQuery,
    GetTeacherAnalyticVocabularyLevelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetTeacherAnalyticVocabularyLevelQuery,
    GetTeacherAnalyticVocabularyLevelQueryVariables
  >(GetTeacherAnalyticVocabularyLevelDocument, options)
}
export type GetTeacherAnalyticVocabularyLevelQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticVocabularyLevelQuery
>
export type GetTeacherAnalyticVocabularyLevelLazyQueryHookResult = ReturnType<
  typeof useGetTeacherAnalyticVocabularyLevelLazyQuery
>
export type GetTeacherAnalyticVocabularyLevelQueryResult = Apollo.QueryResult<
  GetTeacherAnalyticVocabularyLevelQuery,
  GetTeacherAnalyticVocabularyLevelQueryVariables
>
export const SearchLearningActivitiesDocument = gql`
  query searchLearningActivities(
    $parameters: LearningActivitiesSearchInput!
    $withExecutions: Boolean!
    $page: PageableInput!
  ) {
    searchLearningActivities(parameters: $parameters, page: $page) {
      id
      contentSourceLabel
      state
      activityType
      assignmentMode
      subject
      learningFeatureCount
      progress @include(if: $withExecutions) {
        deadline
        progress
      }
      executions @include(if: $withExecutions) {
        id
        state
        name
        successMeasure
        progress
        student {
          userProfile {
            id
            pictureUrl
            firstName
            lastName
          }
        }
      }
    }
  }
`

/**
 * __useSearchLearningActivitiesQuery__
 *
 * To run a query within a React component, call `useSearchLearningActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLearningActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLearningActivitiesQuery({
 *   variables: {
 *      parameters: // value for 'parameters'
 *      withExecutions: // value for 'withExecutions'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchLearningActivitiesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<SearchLearningActivitiesQuery, SearchLearningActivitiesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SearchLearningActivitiesQuery, SearchLearningActivitiesQueryVariables>(
    SearchLearningActivitiesDocument,
    options
  )
}
export function useSearchLearningActivitiesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchLearningActivitiesQuery,
    SearchLearningActivitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SearchLearningActivitiesQuery, SearchLearningActivitiesQueryVariables>(
    SearchLearningActivitiesDocument,
    options
  )
}
export type SearchLearningActivitiesQueryHookResult = ReturnType<typeof useSearchLearningActivitiesQuery>
export type SearchLearningActivitiesLazyQueryHookResult = ReturnType<typeof useSearchLearningActivitiesLazyQuery>
export type SearchLearningActivitiesQueryResult = Apollo.QueryResult<
  SearchLearningActivitiesQuery,
  SearchLearningActivitiesQueryVariables
>
export const UpdateStudentPerformanceNoteDocument = gql`
  mutation updateStudentPerformanceNote($studentId: ID!, $classroomId: ID!, $note: String!) {
    updateStudentPerformanceNote(studentId: $studentId, classroomId: $classroomId, note: $note)
  }
`
export type UpdateStudentPerformanceNoteMutationFn = Apollo.MutationFunction<
  UpdateStudentPerformanceNoteMutation,
  UpdateStudentPerformanceNoteMutationVariables
>

/**
 * __useUpdateStudentPerformanceNoteMutation__
 *
 * To run a mutation, you first call `useUpdateStudentPerformanceNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentPerformanceNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentPerformanceNoteMutation, { data, loading, error }] = useUpdateStudentPerformanceNoteMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      classroomId: // value for 'classroomId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateStudentPerformanceNoteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateStudentPerformanceNoteMutation,
    UpdateStudentPerformanceNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateStudentPerformanceNoteMutation,
    UpdateStudentPerformanceNoteMutationVariables
  >(UpdateStudentPerformanceNoteDocument, options)
}
export type UpdateStudentPerformanceNoteMutationHookResult = ReturnType<typeof useUpdateStudentPerformanceNoteMutation>
export type UpdateStudentPerformanceNoteMutationResult = Apollo.MutationResult<UpdateStudentPerformanceNoteMutation>
export type UpdateStudentPerformanceNoteMutationOptions = Apollo.BaseMutationOptions<
  UpdateStudentPerformanceNoteMutation,
  UpdateStudentPerformanceNoteMutationVariables
>
export const BugReportDocument = gql`
  mutation bugReport($message: BugReportMessageInput!) {
    bugReport(message: $message)
  }
`
export type BugReportMutationFn = Apollo.MutationFunction<BugReportMutation, BugReportMutationVariables>

/**
 * __useBugReportMutation__
 *
 * To run a mutation, you first call `useBugReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBugReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bugReportMutation, { data, loading, error }] = useBugReportMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useBugReportMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<BugReportMutation, BugReportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<BugReportMutation, BugReportMutationVariables>(BugReportDocument, options)
}
export type BugReportMutationHookResult = ReturnType<typeof useBugReportMutation>
export type BugReportMutationResult = Apollo.MutationResult<BugReportMutation>
export type BugReportMutationOptions = Apollo.BaseMutationOptions<BugReportMutation, BugReportMutationVariables>
export const CreateClassroomDocument = gql`
  mutation createClassroom($classroomInput: ClassroomInput!) {
    createClassroom(classroomInput: $classroomInput) {
      id
      name
      identificator
      showSubjectIcon
      subject
      color
      isSetupComplete
      isReadyToMigrate
      weekStart
      timeZone
      startOfYear
      endOfYear
      enforcePinLogin
    }
  }
`
export type CreateClassroomMutationFn = Apollo.MutationFunction<
  CreateClassroomMutation,
  CreateClassroomMutationVariables
>

/**
 * __useCreateClassroomMutation__
 *
 * To run a mutation, you first call `useCreateClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassroomMutation, { data, loading, error }] = useCreateClassroomMutation({
 *   variables: {
 *      classroomInput: // value for 'classroomInput'
 *   },
 * });
 */
export function useCreateClassroomMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateClassroomMutation, CreateClassroomMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateClassroomMutation, CreateClassroomMutationVariables>(
    CreateClassroomDocument,
    options
  )
}
export type CreateClassroomMutationHookResult = ReturnType<typeof useCreateClassroomMutation>
export type CreateClassroomMutationResult = Apollo.MutationResult<CreateClassroomMutation>
export type CreateClassroomMutationOptions = Apollo.BaseMutationOptions<
  CreateClassroomMutation,
  CreateClassroomMutationVariables
>
export const DeleteClassroomDocument = gql`
  mutation deleteClassroom($classroomId: ID!) {
    deleteClassroom(classroomId: $classroomId)
  }
`
export type DeleteClassroomMutationFn = Apollo.MutationFunction<
  DeleteClassroomMutation,
  DeleteClassroomMutationVariables
>

/**
 * __useDeleteClassroomMutation__
 *
 * To run a mutation, you first call `useDeleteClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassroomMutation, { data, loading, error }] = useDeleteClassroomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useDeleteClassroomMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteClassroomMutation, DeleteClassroomMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteClassroomMutation, DeleteClassroomMutationVariables>(
    DeleteClassroomDocument,
    options
  )
}
export type DeleteClassroomMutationHookResult = ReturnType<typeof useDeleteClassroomMutation>
export type DeleteClassroomMutationResult = Apollo.MutationResult<DeleteClassroomMutation>
export type DeleteClassroomMutationOptions = Apollo.BaseMutationOptions<
  DeleteClassroomMutation,
  DeleteClassroomMutationVariables
>
export const EditClassroomDocument = gql`
  mutation editClassroom($classroomId: ID!, $classroomInput: ClassroomInput!) {
    editClassroom(classroomId: $classroomId, classroomInput: $classroomInput) {
      id
      name
      isSetupComplete
      isReadyToMigrate
      identificator
      showSubjectIcon
      subject
      color
      enforcePinLogin
      weekStart
      timeZone
      startOfYear
      endOfYear
    }
  }
`
export type EditClassroomMutationFn = Apollo.MutationFunction<EditClassroomMutation, EditClassroomMutationVariables>

/**
 * __useEditClassroomMutation__
 *
 * To run a mutation, you first call `useEditClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClassroomMutation, { data, loading, error }] = useEditClassroomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      classroomInput: // value for 'classroomInput'
 *   },
 * });
 */
export function useEditClassroomMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<EditClassroomMutation, EditClassroomMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<EditClassroomMutation, EditClassroomMutationVariables>(
    EditClassroomDocument,
    options
  )
}
export type EditClassroomMutationHookResult = ReturnType<typeof useEditClassroomMutation>
export type EditClassroomMutationResult = Apollo.MutationResult<EditClassroomMutation>
export type EditClassroomMutationOptions = Apollo.BaseMutationOptions<
  EditClassroomMutation,
  EditClassroomMutationVariables
>
export const GetBooksDocument = gql`
  query getBooks($subject: Subject!) {
    books(subject: $subject) {
      id
      name
      sourceLanguage
      level
      subject
      image {
        default
        small
        medium
      }
    }
  }
`

/**
 * __useGetBooksQuery__
 *
 * To run a query within a React component, call `useGetBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBooksQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useGetBooksQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetBooksQuery, GetBooksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetBooksQuery, GetBooksQueryVariables>(GetBooksDocument, options)
}
export function useGetBooksLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBooksQuery, GetBooksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetBooksQuery, GetBooksQueryVariables>(GetBooksDocument, options)
}
export type GetBooksQueryHookResult = ReturnType<typeof useGetBooksQuery>
export type GetBooksLazyQueryHookResult = ReturnType<typeof useGetBooksLazyQuery>
export type GetBooksQueryResult = Apollo.QueryResult<GetBooksQuery, GetBooksQueryVariables>
export const GetClassroomDetailDocument = gql`
  query getClassroomDetail($classroomId: ID!) {
    classroom(classroomId: $classroomId) {
      __typename
      id
      name
      subject
      identificator
      showSubjectIcon
      color
      enforcePinLogin
      isSetupComplete
      isReadyToMigrate
      weekStart
      timeZone
      startOfYear
      endOfYear
    }
  }
`

/**
 * __useGetClassroomDetailQuery__
 *
 * To run a query within a React component, call `useGetClassroomDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassroomDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassroomDetailQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useGetClassroomDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetClassroomDetailQuery, GetClassroomDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetClassroomDetailQuery, GetClassroomDetailQueryVariables>(
    GetClassroomDetailDocument,
    options
  )
}
export function useGetClassroomDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClassroomDetailQuery, GetClassroomDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetClassroomDetailQuery, GetClassroomDetailQueryVariables>(
    GetClassroomDetailDocument,
    options
  )
}
export type GetClassroomDetailQueryHookResult = ReturnType<typeof useGetClassroomDetailQuery>
export type GetClassroomDetailLazyQueryHookResult = ReturnType<typeof useGetClassroomDetailLazyQuery>
export type GetClassroomDetailQueryResult = Apollo.QueryResult<
  GetClassroomDetailQuery,
  GetClassroomDetailQueryVariables
>
export const GetClassroomLoginCodeDocument = gql`
  query getClassroomLoginCode($classroomId: ID!) {
    classroomLoginCode(classroomId: $classroomId) {
      classroomLoginCode
      expirationTime
    }
  }
`

/**
 * __useGetClassroomLoginCodeQuery__
 *
 * To run a query within a React component, call `useGetClassroomLoginCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassroomLoginCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassroomLoginCodeQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useGetClassroomLoginCodeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetClassroomLoginCodeQuery, GetClassroomLoginCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetClassroomLoginCodeQuery, GetClassroomLoginCodeQueryVariables>(
    GetClassroomLoginCodeDocument,
    options
  )
}
export function useGetClassroomLoginCodeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClassroomLoginCodeQuery, GetClassroomLoginCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetClassroomLoginCodeQuery, GetClassroomLoginCodeQueryVariables>(
    GetClassroomLoginCodeDocument,
    options
  )
}
export type GetClassroomLoginCodeQueryHookResult = ReturnType<typeof useGetClassroomLoginCodeQuery>
export type GetClassroomLoginCodeLazyQueryHookResult = ReturnType<typeof useGetClassroomLoginCodeLazyQuery>
export type GetClassroomLoginCodeQueryResult = Apollo.QueryResult<
  GetClassroomLoginCodeQuery,
  GetClassroomLoginCodeQueryVariables
>
export const LoginStudentTeacherStatusDocument = gql`
  query loginStudentTeacherStatus($classroomId: ID!) {
    loginStudentTeacherStatus(classroomId: $classroomId) {
      student {
        userProfile {
          id
          pictureUrl
          firstName
          lastName
          email
          hasPin
        }
        studentLastActivity
        studentLastLogin
        lastLoginCode
      }
      status
    }
  }
`

/**
 * __useLoginStudentTeacherStatusQuery__
 *
 * To run a query within a React component, call `useLoginStudentTeacherStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginStudentTeacherStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginStudentTeacherStatusQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useLoginStudentTeacherStatusQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LoginStudentTeacherStatusQuery,
    LoginStudentTeacherStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<LoginStudentTeacherStatusQuery, LoginStudentTeacherStatusQueryVariables>(
    LoginStudentTeacherStatusDocument,
    options
  )
}
export function useLoginStudentTeacherStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LoginStudentTeacherStatusQuery,
    LoginStudentTeacherStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<LoginStudentTeacherStatusQuery, LoginStudentTeacherStatusQueryVariables>(
    LoginStudentTeacherStatusDocument,
    options
  )
}
export type LoginStudentTeacherStatusQueryHookResult = ReturnType<typeof useLoginStudentTeacherStatusQuery>
export type LoginStudentTeacherStatusLazyQueryHookResult = ReturnType<typeof useLoginStudentTeacherStatusLazyQuery>
export type LoginStudentTeacherStatusQueryResult = Apollo.QueryResult<
  LoginStudentTeacherStatusQuery,
  LoginStudentTeacherStatusQueryVariables
>
export const LoginStudentVerifyByTeacherDocument = gql`
  mutation loginStudentVerifyByTeacher($userId: ID!, $classroomId: ID!, $status: LoginStudentTeacherStatus!) {
    loginStudentVerifyByTeacher(userId: $userId, classroomId: $classroomId, status: $status)
  }
`
export type LoginStudentVerifyByTeacherMutationFn = Apollo.MutationFunction<
  LoginStudentVerifyByTeacherMutation,
  LoginStudentVerifyByTeacherMutationVariables
>

/**
 * __useLoginStudentVerifyByTeacherMutation__
 *
 * To run a mutation, you first call `useLoginStudentVerifyByTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginStudentVerifyByTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginStudentVerifyByTeacherMutation, { data, loading, error }] = useLoginStudentVerifyByTeacherMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      classroomId: // value for 'classroomId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useLoginStudentVerifyByTeacherMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LoginStudentVerifyByTeacherMutation,
    LoginStudentVerifyByTeacherMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    LoginStudentVerifyByTeacherMutation,
    LoginStudentVerifyByTeacherMutationVariables
  >(LoginStudentVerifyByTeacherDocument, options)
}
export type LoginStudentVerifyByTeacherMutationHookResult = ReturnType<typeof useLoginStudentVerifyByTeacherMutation>
export type LoginStudentVerifyByTeacherMutationResult = Apollo.MutationResult<LoginStudentVerifyByTeacherMutation>
export type LoginStudentVerifyByTeacherMutationOptions = Apollo.BaseMutationOptions<
  LoginStudentVerifyByTeacherMutation,
  LoginStudentVerifyByTeacherMutationVariables
>
export const MigrateClassroomDocument = gql`
  mutation migrateClassroom($classroomId: ID!, $shouldMigrate: Boolean!) {
    migrateClassroom(classroomId: $classroomId, shouldMigrate: $shouldMigrate) {
      id
      name
      identificator
      showSubjectIcon
      subject
      color
      isSetupComplete
      isReadyToMigrate
      weekStart
      timeZone
      startOfYear
      endOfYear
    }
  }
`
export type MigrateClassroomMutationFn = Apollo.MutationFunction<
  MigrateClassroomMutation,
  MigrateClassroomMutationVariables
>

/**
 * __useMigrateClassroomMutation__
 *
 * To run a mutation, you first call `useMigrateClassroomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateClassroomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateClassroomMutation, { data, loading, error }] = useMigrateClassroomMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      shouldMigrate: // value for 'shouldMigrate'
 *   },
 * });
 */
export function useMigrateClassroomMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<MigrateClassroomMutation, MigrateClassroomMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<MigrateClassroomMutation, MigrateClassroomMutationVariables>(
    MigrateClassroomDocument,
    options
  )
}
export type MigrateClassroomMutationHookResult = ReturnType<typeof useMigrateClassroomMutation>
export type MigrateClassroomMutationResult = Apollo.MutationResult<MigrateClassroomMutation>
export type MigrateClassroomMutationOptions = Apollo.BaseMutationOptions<
  MigrateClassroomMutation,
  MigrateClassroomMutationVariables
>
export const RemoveStudentFromClassDocument = gql`
  mutation removeStudentFromClass($studentId: ID!, $classroomId: ID!) {
    removeStudentFromClass(studentId: $studentId, classroomId: $classroomId)
  }
`
export type RemoveStudentFromClassMutationFn = Apollo.MutationFunction<
  RemoveStudentFromClassMutation,
  RemoveStudentFromClassMutationVariables
>

/**
 * __useRemoveStudentFromClassMutation__
 *
 * To run a mutation, you first call `useRemoveStudentFromClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStudentFromClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStudentFromClassMutation, { data, loading, error }] = useRemoveStudentFromClassMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useRemoveStudentFromClassMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveStudentFromClassMutation,
    RemoveStudentFromClassMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RemoveStudentFromClassMutation, RemoveStudentFromClassMutationVariables>(
    RemoveStudentFromClassDocument,
    options
  )
}
export type RemoveStudentFromClassMutationHookResult = ReturnType<typeof useRemoveStudentFromClassMutation>
export type RemoveStudentFromClassMutationResult = Apollo.MutationResult<RemoveStudentFromClassMutation>
export type RemoveStudentFromClassMutationOptions = Apollo.BaseMutationOptions<
  RemoveStudentFromClassMutation,
  RemoveStudentFromClassMutationVariables
>
export const UpdateStudentProfileDocument = gql`
  mutation updateStudentProfile($studentId: ID!, $userProfile: UserProfileInput!) {
    updateStudentProfile(studentId: $studentId, userProfile: $userProfile) {
      userProfile {
        id
        firstName
        lastName
        pictureUrl
      }
    }
  }
`
export type UpdateStudentProfileMutationFn = Apollo.MutationFunction<
  UpdateStudentProfileMutation,
  UpdateStudentProfileMutationVariables
>

/**
 * __useUpdateStudentProfileMutation__
 *
 * To run a mutation, you first call `useUpdateStudentProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentProfileMutation, { data, loading, error }] = useUpdateStudentProfileMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      userProfile: // value for 'userProfile'
 *   },
 * });
 */
export function useUpdateStudentProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateStudentProfileMutation,
    UpdateStudentProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateStudentProfileMutation, UpdateStudentProfileMutationVariables>(
    UpdateStudentProfileDocument,
    options
  )
}
export type UpdateStudentProfileMutationHookResult = ReturnType<typeof useUpdateStudentProfileMutation>
export type UpdateStudentProfileMutationResult = Apollo.MutationResult<UpdateStudentProfileMutation>
export type UpdateStudentProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateStudentProfileMutation,
  UpdateStudentProfileMutationVariables
>
export const UserBulkRegistrationDocument = gql`
  mutation userBulkRegistration($classroomId: ID!, $users: [UserBulkRegistration!]!, $language: Language!) {
    userBulkRegistration(classroomId: $classroomId, users: $users, language: $language) {
      success
      users {
        originalName
        firstName
        lastName
        email
        isValid
        errors {
          field
          description
          code
        }
        isAlreadyRegistered
      }
      initialCredentialsBase64
    }
  }
`
export type UserBulkRegistrationMutationFn = Apollo.MutationFunction<
  UserBulkRegistrationMutation,
  UserBulkRegistrationMutationVariables
>

/**
 * __useUserBulkRegistrationMutation__
 *
 * To run a mutation, you first call `useUserBulkRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBulkRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBulkRegistrationMutation, { data, loading, error }] = useUserBulkRegistrationMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      users: // value for 'users'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUserBulkRegistrationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UserBulkRegistrationMutation,
    UserBulkRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UserBulkRegistrationMutation, UserBulkRegistrationMutationVariables>(
    UserBulkRegistrationDocument,
    options
  )
}
export type UserBulkRegistrationMutationHookResult = ReturnType<typeof useUserBulkRegistrationMutation>
export type UserBulkRegistrationMutationResult = Apollo.MutationResult<UserBulkRegistrationMutation>
export type UserBulkRegistrationMutationOptions = Apollo.BaseMutationOptions<
  UserBulkRegistrationMutation,
  UserBulkRegistrationMutationVariables
>
export const UserBulkVerificationDocument = gql`
  mutation userBulkVerification($classroomId: ID!, $users: [UserBulkRegistration!]!) {
    userBulkVerification(classroomId: $classroomId, users: $users) {
      originalName
      firstName
      lastName
      email
      isValid
      errors {
        field
        description
        code
      }
      isAlreadyRegistered
    }
  }
`
export type UserBulkVerificationMutationFn = Apollo.MutationFunction<
  UserBulkVerificationMutation,
  UserBulkVerificationMutationVariables
>

/**
 * __useUserBulkVerificationMutation__
 *
 * To run a mutation, you first call `useUserBulkVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBulkVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBulkVerificationMutation, { data, loading, error }] = useUserBulkVerificationMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      users: // value for 'users'
 *   },
 * });
 */
export function useUserBulkVerificationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UserBulkVerificationMutation,
    UserBulkVerificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UserBulkVerificationMutation, UserBulkVerificationMutationVariables>(
    UserBulkVerificationDocument,
    options
  )
}
export type UserBulkVerificationMutationHookResult = ReturnType<typeof useUserBulkVerificationMutation>
export type UserBulkVerificationMutationResult = Apollo.MutationResult<UserBulkVerificationMutation>
export type UserBulkVerificationMutationOptions = Apollo.BaseMutationOptions<
  UserBulkVerificationMutation,
  UserBulkVerificationMutationVariables
>
export const AddActivityToFavoritesDocument = gql`
  mutation addActivityToFavorites($learningActivityType: ActivityType!) {
    addActivityToFavorites(learningActivityType: $learningActivityType)
  }
`
export type AddActivityToFavoritesMutationFn = Apollo.MutationFunction<
  AddActivityToFavoritesMutation,
  AddActivityToFavoritesMutationVariables
>

/**
 * __useAddActivityToFavoritesMutation__
 *
 * To run a mutation, you first call `useAddActivityToFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityToFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityToFavoritesMutation, { data, loading, error }] = useAddActivityToFavoritesMutation({
 *   variables: {
 *      learningActivityType: // value for 'learningActivityType'
 *   },
 * });
 */
export function useAddActivityToFavoritesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddActivityToFavoritesMutation,
    AddActivityToFavoritesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddActivityToFavoritesMutation, AddActivityToFavoritesMutationVariables>(
    AddActivityToFavoritesDocument,
    options
  )
}
export type AddActivityToFavoritesMutationHookResult = ReturnType<typeof useAddActivityToFavoritesMutation>
export type AddActivityToFavoritesMutationResult = Apollo.MutationResult<AddActivityToFavoritesMutation>
export type AddActivityToFavoritesMutationOptions = Apollo.BaseMutationOptions<
  AddActivityToFavoritesMutation,
  AddActivityToFavoritesMutationVariables
>
export const GetClassroomsDocument = gql`
  query getClassrooms {
    classrooms {
      id
      name
      identificator
      showSubjectIcon
      color
      subject
      isSetupComplete
      isReadyToMigrate
    }
  }
`

/**
 * __useGetClassroomsQuery__
 *
 * To run a query within a React component, call `useGetClassroomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassroomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassroomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClassroomsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetClassroomsQuery, GetClassroomsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetClassroomsQuery, GetClassroomsQueryVariables>(GetClassroomsDocument, options)
}
export function useGetClassroomsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClassroomsQuery, GetClassroomsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetClassroomsQuery, GetClassroomsQueryVariables>(GetClassroomsDocument, options)
}
export type GetClassroomsQueryHookResult = ReturnType<typeof useGetClassroomsQuery>
export type GetClassroomsLazyQueryHookResult = ReturnType<typeof useGetClassroomsLazyQuery>
export type GetClassroomsQueryResult = Apollo.QueryResult<GetClassroomsQuery, GetClassroomsQueryVariables>
export const GetFavoriteActivitiesDocument = gql`
  query getFavoriteActivities {
    favoriteActivities
  }
`

/**
 * __useGetFavoriteActivitiesQuery__
 *
 * To run a query within a React component, call `useGetFavoriteActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavoriteActivitiesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetFavoriteActivitiesQuery, GetFavoriteActivitiesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetFavoriteActivitiesQuery, GetFavoriteActivitiesQueryVariables>(
    GetFavoriteActivitiesDocument,
    options
  )
}
export function useGetFavoriteActivitiesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFavoriteActivitiesQuery, GetFavoriteActivitiesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetFavoriteActivitiesQuery, GetFavoriteActivitiesQueryVariables>(
    GetFavoriteActivitiesDocument,
    options
  )
}
export type GetFavoriteActivitiesQueryHookResult = ReturnType<typeof useGetFavoriteActivitiesQuery>
export type GetFavoriteActivitiesLazyQueryHookResult = ReturnType<typeof useGetFavoriteActivitiesLazyQuery>
export type GetFavoriteActivitiesQueryResult = Apollo.QueryResult<
  GetFavoriteActivitiesQuery,
  GetFavoriteActivitiesQueryVariables
>
export const GetLibraryGrammarPackageItemsDocument = gql`
  query getLibraryGrammarPackageItems($filters: LibraryItemsFilterInput!, $page: PageableInput!) {
    libraryGrammarPackageItems(filters: $filters, page: $page) {
      filters {
        level
        tags
      }
      packages {
        id
        name
        label
        borderColor
        image {
          small
          medium
          default
        }
        level
        learningFeaturesCount
        learningFeatures {
          id
          type
          origin
          ...LearningFeatureShortDetail
        }
      }
    }
  }
  ${LearningFeatureShortDetailFragmentDoc}
`

/**
 * __useGetLibraryGrammarPackageItemsQuery__
 *
 * To run a query within a React component, call `useGetLibraryGrammarPackageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryGrammarPackageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryGrammarPackageItemsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetLibraryGrammarPackageItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetLibraryGrammarPackageItemsQuery,
    GetLibraryGrammarPackageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLibraryGrammarPackageItemsQuery, GetLibraryGrammarPackageItemsQueryVariables>(
    GetLibraryGrammarPackageItemsDocument,
    options
  )
}
export function useGetLibraryGrammarPackageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLibraryGrammarPackageItemsQuery,
    GetLibraryGrammarPackageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLibraryGrammarPackageItemsQuery, GetLibraryGrammarPackageItemsQueryVariables>(
    GetLibraryGrammarPackageItemsDocument,
    options
  )
}
export type GetLibraryGrammarPackageItemsQueryHookResult = ReturnType<typeof useGetLibraryGrammarPackageItemsQuery>
export type GetLibraryGrammarPackageItemsLazyQueryHookResult = ReturnType<
  typeof useGetLibraryGrammarPackageItemsLazyQuery
>
export type GetLibraryGrammarPackageItemsQueryResult = Apollo.QueryResult<
  GetLibraryGrammarPackageItemsQuery,
  GetLibraryGrammarPackageItemsQueryVariables
>
export const GetLibraryItemPackageDetailDocument = gql`
  query getLibraryItemPackageDetail($libraryItemId: ID!, $withLearningFeatures: Boolean = true) {
    libraryItemPackageDetail(libraryItemId: $libraryItemId) {
      __typename
      id
      image {
        imageId {
          namespace
          commonName
        }
        medium
        default
      }
      name
      label
      level
      borderColor
      foxinoOwned
      borderColor
      createdBy {
        firstName
        lastName
        email
      }
      learningFeatures @include(if: $withLearningFeatures) {
        ...LearningFeatureShortDetail
      }
    }
  }
  ${LearningFeatureShortDetailFragmentDoc}
`

/**
 * __useGetLibraryItemPackageDetailQuery__
 *
 * To run a query within a React component, call `useGetLibraryItemPackageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryItemPackageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryItemPackageDetailQuery({
 *   variables: {
 *      libraryItemId: // value for 'libraryItemId'
 *      withLearningFeatures: // value for 'withLearningFeatures'
 *   },
 * });
 */
export function useGetLibraryItemPackageDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetLibraryItemPackageDetailQuery,
    GetLibraryItemPackageDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLibraryItemPackageDetailQuery, GetLibraryItemPackageDetailQueryVariables>(
    GetLibraryItemPackageDetailDocument,
    options
  )
}
export function useGetLibraryItemPackageDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLibraryItemPackageDetailQuery,
    GetLibraryItemPackageDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLibraryItemPackageDetailQuery, GetLibraryItemPackageDetailQueryVariables>(
    GetLibraryItemPackageDetailDocument,
    options
  )
}
export type GetLibraryItemPackageDetailQueryHookResult = ReturnType<typeof useGetLibraryItemPackageDetailQuery>
export type GetLibraryItemPackageDetailLazyQueryHookResult = ReturnType<typeof useGetLibraryItemPackageDetailLazyQuery>
export type GetLibraryItemPackageDetailQueryResult = Apollo.QueryResult<
  GetLibraryItemPackageDetailQuery,
  GetLibraryItemPackageDetailQueryVariables
>
export const GetLibraryPackageItemsDocument = gql`
  query getLibraryPackageItems($filters: LibraryItemsFilterInput!, $page: PageableInput!) {
    libraryPackageItems(filters: $filters, page: $page) {
      filters {
        level
        tags
      }
      packages {
        id
        name
        label
        borderColor
        image {
          small
          medium
          default
        }
        level
        learningFeaturesCount
      }
    }
  }
`

/**
 * __useGetLibraryPackageItemsQuery__
 *
 * To run a query within a React component, call `useGetLibraryPackageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryPackageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryPackageItemsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetLibraryPackageItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetLibraryPackageItemsQuery, GetLibraryPackageItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLibraryPackageItemsQuery, GetLibraryPackageItemsQueryVariables>(
    GetLibraryPackageItemsDocument,
    options
  )
}
export function useGetLibraryPackageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLibraryPackageItemsQuery, GetLibraryPackageItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLibraryPackageItemsQuery, GetLibraryPackageItemsQueryVariables>(
    GetLibraryPackageItemsDocument,
    options
  )
}
export type GetLibraryPackageItemsQueryHookResult = ReturnType<typeof useGetLibraryPackageItemsQuery>
export type GetLibraryPackageItemsLazyQueryHookResult = ReturnType<typeof useGetLibraryPackageItemsLazyQuery>
export type GetLibraryPackageItemsQueryResult = Apollo.QueryResult<
  GetLibraryPackageItemsQuery,
  GetLibraryPackageItemsQueryVariables
>
export const RemoveActivityFromFavoritesDocument = gql`
  mutation removeActivityFromFavorites($learningActivityType: ActivityType!) {
    removeActivityFromFavorites(learningActivityType: $learningActivityType)
  }
`
export type RemoveActivityFromFavoritesMutationFn = Apollo.MutationFunction<
  RemoveActivityFromFavoritesMutation,
  RemoveActivityFromFavoritesMutationVariables
>

/**
 * __useRemoveActivityFromFavoritesMutation__
 *
 * To run a mutation, you first call `useRemoveActivityFromFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveActivityFromFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeActivityFromFavoritesMutation, { data, loading, error }] = useRemoveActivityFromFavoritesMutation({
 *   variables: {
 *      learningActivityType: // value for 'learningActivityType'
 *   },
 * });
 */
export function useRemoveActivityFromFavoritesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveActivityFromFavoritesMutation,
    RemoveActivityFromFavoritesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RemoveActivityFromFavoritesMutation,
    RemoveActivityFromFavoritesMutationVariables
  >(RemoveActivityFromFavoritesDocument, options)
}
export type RemoveActivityFromFavoritesMutationHookResult = ReturnType<typeof useRemoveActivityFromFavoritesMutation>
export type RemoveActivityFromFavoritesMutationResult = Apollo.MutationResult<RemoveActivityFromFavoritesMutation>
export type RemoveActivityFromFavoritesMutationOptions = Apollo.BaseMutationOptions<
  RemoveActivityFromFavoritesMutation,
  RemoveActivityFromFavoritesMutationVariables
>
export const SearchLearningFeatureDocument = gql`
  query searchLearningFeature($searchLearningFeatureInput: SearchLearningFeatureInput!) {
    searchLearningFeature(searchLearningFeatureInput: $searchLearningFeatureInput) {
      ...LearningFeatureShortDetail
    }
  }
  ${LearningFeatureShortDetailFragmentDoc}
`

/**
 * __useSearchLearningFeatureQuery__
 *
 * To run a query within a React component, call `useSearchLearningFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLearningFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLearningFeatureQuery({
 *   variables: {
 *      searchLearningFeatureInput: // value for 'searchLearningFeatureInput'
 *   },
 * });
 */
export function useSearchLearningFeatureQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<SearchLearningFeatureQuery, SearchLearningFeatureQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SearchLearningFeatureQuery, SearchLearningFeatureQueryVariables>(
    SearchLearningFeatureDocument,
    options
  )
}
export function useSearchLearningFeatureLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchLearningFeatureQuery, SearchLearningFeatureQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SearchLearningFeatureQuery, SearchLearningFeatureQueryVariables>(
    SearchLearningFeatureDocument,
    options
  )
}
export type SearchLearningFeatureQueryHookResult = ReturnType<typeof useSearchLearningFeatureQuery>
export type SearchLearningFeatureLazyQueryHookResult = ReturnType<typeof useSearchLearningFeatureLazyQuery>
export type SearchLearningFeatureQueryResult = Apollo.QueryResult<
  SearchLearningFeatureQuery,
  SearchLearningFeatureQueryVariables
>
export const GetTutorialProgressDocument = gql`
  query getTutorialProgress {
    tutorialProgress {
      tutorialStepCompleted
      isSkipped
    }
  }
`

/**
 * __useGetTutorialProgressQuery__
 *
 * To run a query within a React component, call `useGetTutorialProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTutorialProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTutorialProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTutorialProgressQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetTutorialProgressQuery, GetTutorialProgressQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetTutorialProgressQuery, GetTutorialProgressQueryVariables>(
    GetTutorialProgressDocument,
    options
  )
}
export function useGetTutorialProgressLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTutorialProgressQuery, GetTutorialProgressQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetTutorialProgressQuery, GetTutorialProgressQueryVariables>(
    GetTutorialProgressDocument,
    options
  )
}
export type GetTutorialProgressQueryHookResult = ReturnType<typeof useGetTutorialProgressQuery>
export type GetTutorialProgressLazyQueryHookResult = ReturnType<typeof useGetTutorialProgressLazyQuery>
export type GetTutorialProgressQueryResult = Apollo.QueryResult<
  GetTutorialProgressQuery,
  GetTutorialProgressQueryVariables
>
export const UpdateTutorialProgressDocument = gql`
  mutation updateTutorialProgress($tutorialStepCompleted: Int!, $isSkipped: Boolean!) {
    updateTutorialProgress(tutorialStepCompleted: $tutorialStepCompleted, isSkipped: $isSkipped) {
      isSkipped
      tutorialStepCompleted
    }
  }
`
export type UpdateTutorialProgressMutationFn = Apollo.MutationFunction<
  UpdateTutorialProgressMutation,
  UpdateTutorialProgressMutationVariables
>

/**
 * __useUpdateTutorialProgressMutation__
 *
 * To run a mutation, you first call `useUpdateTutorialProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTutorialProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTutorialProgressMutation, { data, loading, error }] = useUpdateTutorialProgressMutation({
 *   variables: {
 *      tutorialStepCompleted: // value for 'tutorialStepCompleted'
 *      isSkipped: // value for 'isSkipped'
 *   },
 * });
 */
export function useUpdateTutorialProgressMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateTutorialProgressMutation,
    UpdateTutorialProgressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateTutorialProgressMutation, UpdateTutorialProgressMutationVariables>(
    UpdateTutorialProgressDocument,
    options
  )
}
export type UpdateTutorialProgressMutationHookResult = ReturnType<typeof useUpdateTutorialProgressMutation>
export type UpdateTutorialProgressMutationResult = Apollo.MutationResult<UpdateTutorialProgressMutation>
export type UpdateTutorialProgressMutationOptions = Apollo.BaseMutationOptions<
  UpdateTutorialProgressMutation,
  UpdateTutorialProgressMutationVariables
>
export const GetQuizGameDocument = gql`
  query getQuizGame($quizId: ID!) {
    quizGame(quizId: $quizId) {
      id
      name
      code
      gameState
      numOfQuestions
      countdownInSeconds
      currentQuestion {
        id
        index
        secondsPerQuestion
        showQuestionInClient
        assignment {
          __typename @skip(if: true)
          id
          imageUrl
          soundURL
          videoURL
          text
        }
        assignmentType
        responses {
          __typename @skip(if: true)
          id
          text
        }
        numOfAnswers
        questionResult {
          correctResponseIndexes
          answerDistribution
        }
        hasNext
      }
      connectedPlayers {
        id
        lastName
        firstName
        pictureUrl
        newPosition
        oldPosition
        totalPoints
        newPoints
      }
    }
  }
`

/**
 * __useGetQuizGameQuery__
 *
 * To run a query within a React component, call `useGetQuizGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizGameQuery({
 *   variables: {
 *      quizId: // value for 'quizId'
 *   },
 * });
 */
export function useGetQuizGameQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetQuizGameQuery, GetQuizGameQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetQuizGameQuery, GetQuizGameQueryVariables>(GetQuizGameDocument, options)
}
export function useGetQuizGameLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuizGameQuery, GetQuizGameQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetQuizGameQuery, GetQuizGameQueryVariables>(GetQuizGameDocument, options)
}
export type GetQuizGameQueryHookResult = ReturnType<typeof useGetQuizGameQuery>
export type GetQuizGameLazyQueryHookResult = ReturnType<typeof useGetQuizGameLazyQuery>
export type GetQuizGameQueryResult = Apollo.QueryResult<GetQuizGameQuery, GetQuizGameQueryVariables>
export const NextQuizQuestionDocument = gql`
  mutation nextQuizQuestion($quizId: ID!) {
    nextQuizQuestion(quizId: $quizId)
  }
`
export type NextQuizQuestionMutationFn = Apollo.MutationFunction<
  NextQuizQuestionMutation,
  NextQuizQuestionMutationVariables
>

/**
 * __useNextQuizQuestionMutation__
 *
 * To run a mutation, you first call `useNextQuizQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNextQuizQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nextQuizQuestionMutation, { data, loading, error }] = useNextQuizQuestionMutation({
 *   variables: {
 *      quizId: // value for 'quizId'
 *   },
 * });
 */
export function useNextQuizQuestionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<NextQuizQuestionMutation, NextQuizQuestionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<NextQuizQuestionMutation, NextQuizQuestionMutationVariables>(
    NextQuizQuestionDocument,
    options
  )
}
export type NextQuizQuestionMutationHookResult = ReturnType<typeof useNextQuizQuestionMutation>
export type NextQuizQuestionMutationResult = Apollo.MutationResult<NextQuizQuestionMutation>
export type NextQuizQuestionMutationOptions = Apollo.BaseMutationOptions<
  NextQuizQuestionMutation,
  NextQuizQuestionMutationVariables
>
export const QuizBasedGameConfigurationByActivityIdDocument = gql`
  query quizBasedGameConfigurationByActivityId($learningActivityId: ID!, $gameType: QuizBasedGameType!) {
    quizBasedGameConfigurationByActivityId(learningActivityId: $learningActivityId, gameType: $gameType) {
      id
      subject
      name
      label
      learningActivityId
      gameType
      groups {
        id
        name
        timeLimit
        customSettings {
          showQuestionInClient
          pointsMultiplier
        }
        questions {
          index
          timeLimit
          learningFeature {
            id
            type
            sourceLanguage
            sourceLanguageText
            targetLanguage
            targetLanguageText
            images {
              default
            }
          }
          originalLearningFeature {
            id
            type
            sourceLanguage
            sourceLanguageText
            targetLanguage
            targetLanguageText
            images {
              default
            }
          }
          learningFeatureDirection
          text
          lexicalType
          groupId
          options {
            index
            isCorrect
            learningFeature {
              id
              type
              sourceLanguage
              sourceLanguageText
              targetLanguage
              targetLanguageText
              images {
                default
              }
            }
            text
            media {
              imageUrl
              soundUrl
              videoUrl
            }
          }
          type
          media {
            imageUrl
            soundUrl
            videoUrl
          }
        }
      }
    }
  }
`

/**
 * __useQuizBasedGameConfigurationByActivityIdQuery__
 *
 * To run a query within a React component, call `useQuizBasedGameConfigurationByActivityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizBasedGameConfigurationByActivityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizBasedGameConfigurationByActivityIdQuery({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *      gameType: // value for 'gameType'
 *   },
 * });
 */
export function useQuizBasedGameConfigurationByActivityIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    QuizBasedGameConfigurationByActivityIdQuery,
    QuizBasedGameConfigurationByActivityIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    QuizBasedGameConfigurationByActivityIdQuery,
    QuizBasedGameConfigurationByActivityIdQueryVariables
  >(QuizBasedGameConfigurationByActivityIdDocument, options)
}
export function useQuizBasedGameConfigurationByActivityIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    QuizBasedGameConfigurationByActivityIdQuery,
    QuizBasedGameConfigurationByActivityIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    QuizBasedGameConfigurationByActivityIdQuery,
    QuizBasedGameConfigurationByActivityIdQueryVariables
  >(QuizBasedGameConfigurationByActivityIdDocument, options)
}
export type QuizBasedGameConfigurationByActivityIdQueryHookResult = ReturnType<
  typeof useQuizBasedGameConfigurationByActivityIdQuery
>
export type QuizBasedGameConfigurationByActivityIdLazyQueryHookResult = ReturnType<
  typeof useQuizBasedGameConfigurationByActivityIdLazyQuery
>
export type QuizBasedGameConfigurationByActivityIdQueryResult = Apollo.QueryResult<
  QuizBasedGameConfigurationByActivityIdQuery,
  QuizBasedGameConfigurationByActivityIdQueryVariables
>
export const QuizBasedGameConfigurationByIdDocument = gql`
  query quizBasedGameConfigurationById($configurationId: ID!, $gameType: QuizBasedGameType!) {
    quizBasedGameConfigurationById(configurationId: $configurationId, gameType: $gameType) {
      id
      subject
      name
      label
      learningActivityId
      gameType
      groups {
        id
        name
        timeLimit
        customSettings {
          showQuestionInClient
          pointsMultiplier
        }
        questions {
          index
          timeLimit
          learningFeature {
            id
            type
            sourceLanguage
            sourceLanguageText
            targetLanguage
            targetLanguageText
            images {
              default
            }
          }
          originalLearningFeature {
            id
            type
            sourceLanguage
            sourceLanguageText
            targetLanguage
            targetLanguageText
            images {
              default
            }
          }
          learningFeatureDirection
          text
          lexicalType
          groupId
          options {
            index
            isCorrect
            learningFeature {
              id
              type
              sourceLanguage
              sourceLanguageText
              targetLanguage
              targetLanguageText
              images {
                default
              }
            }
            text
            media {
              imageUrl
              soundUrl
              videoUrl
            }
          }
          type
          media {
            imageUrl
            soundUrl
            videoUrl
          }
        }
      }
    }
  }
`

/**
 * __useQuizBasedGameConfigurationByIdQuery__
 *
 * To run a query within a React component, call `useQuizBasedGameConfigurationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizBasedGameConfigurationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizBasedGameConfigurationByIdQuery({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *      gameType: // value for 'gameType'
 *   },
 * });
 */
export function useQuizBasedGameConfigurationByIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    QuizBasedGameConfigurationByIdQuery,
    QuizBasedGameConfigurationByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<QuizBasedGameConfigurationByIdQuery, QuizBasedGameConfigurationByIdQueryVariables>(
    QuizBasedGameConfigurationByIdDocument,
    options
  )
}
export function useQuizBasedGameConfigurationByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    QuizBasedGameConfigurationByIdQuery,
    QuizBasedGameConfigurationByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    QuizBasedGameConfigurationByIdQuery,
    QuizBasedGameConfigurationByIdQueryVariables
  >(QuizBasedGameConfigurationByIdDocument, options)
}
export type QuizBasedGameConfigurationByIdQueryHookResult = ReturnType<typeof useQuizBasedGameConfigurationByIdQuery>
export type QuizBasedGameConfigurationByIdLazyQueryHookResult = ReturnType<
  typeof useQuizBasedGameConfigurationByIdLazyQuery
>
export type QuizBasedGameConfigurationByIdQueryResult = Apollo.QueryResult<
  QuizBasedGameConfigurationByIdQuery,
  QuizBasedGameConfigurationByIdQueryVariables
>
export const RelatedWrongAnswersDocument = gql`
  query relatedWrongAnswers($learningFeatureIds: [ID!]!) {
    relatedWrongAnswers(learningFeatureIds: $learningFeatureIds) {
      wrongText
      wrongLearningFeature {
        id
        sourceLanguage
        sourceLanguageText
        targetLanguage
        targetLanguageText
      }
    }
  }
`

/**
 * __useRelatedWrongAnswersQuery__
 *
 * To run a query within a React component, call `useRelatedWrongAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedWrongAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedWrongAnswersQuery({
 *   variables: {
 *      learningFeatureIds: // value for 'learningFeatureIds'
 *   },
 * });
 */
export function useRelatedWrongAnswersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<RelatedWrongAnswersQuery, RelatedWrongAnswersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<RelatedWrongAnswersQuery, RelatedWrongAnswersQueryVariables>(
    RelatedWrongAnswersDocument,
    options
  )
}
export function useRelatedWrongAnswersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RelatedWrongAnswersQuery, RelatedWrongAnswersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<RelatedWrongAnswersQuery, RelatedWrongAnswersQueryVariables>(
    RelatedWrongAnswersDocument,
    options
  )
}
export type RelatedWrongAnswersQueryHookResult = ReturnType<typeof useRelatedWrongAnswersQuery>
export type RelatedWrongAnswersLazyQueryHookResult = ReturnType<typeof useRelatedWrongAnswersLazyQuery>
export type RelatedWrongAnswersQueryResult = Apollo.QueryResult<
  RelatedWrongAnswersQuery,
  RelatedWrongAnswersQueryVariables
>
export const SaveQuizBasedGameConfigurationDocument = gql`
  mutation saveQuizBasedGameConfiguration($input: QuizBasedGameConfigurationInput!) {
    saveQuizBasedGameConfiguration(input: $input)
  }
`
export type SaveQuizBasedGameConfigurationMutationFn = Apollo.MutationFunction<
  SaveQuizBasedGameConfigurationMutation,
  SaveQuizBasedGameConfigurationMutationVariables
>

/**
 * __useSaveQuizBasedGameConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveQuizBasedGameConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuizBasedGameConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuizBasedGameConfigurationMutation, { data, loading, error }] = useSaveQuizBasedGameConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuizBasedGameConfigurationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SaveQuizBasedGameConfigurationMutation,
    SaveQuizBasedGameConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SaveQuizBasedGameConfigurationMutation,
    SaveQuizBasedGameConfigurationMutationVariables
  >(SaveQuizBasedGameConfigurationDocument, options)
}
export type SaveQuizBasedGameConfigurationMutationHookResult = ReturnType<
  typeof useSaveQuizBasedGameConfigurationMutation
>
export type SaveQuizBasedGameConfigurationMutationResult = Apollo.MutationResult<SaveQuizBasedGameConfigurationMutation>
export type SaveQuizBasedGameConfigurationMutationOptions = Apollo.BaseMutationOptions<
  SaveQuizBasedGameConfigurationMutation,
  SaveQuizBasedGameConfigurationMutationVariables
>
export const SearchQuizBasedGameConfigurationQuestionContentDocument = gql`
  query searchQuizBasedGameConfigurationQuestionContent($searchLearningFeatureInput: SearchLearningFeatureInput!) {
    searchQuizBasedGameConfigurationQuestionContent(searchLearningFeatureInput: $searchLearningFeatureInput) {
      definitions
      learningFeature {
        id
        sourceLanguage
        sourceLanguageText
        targetLanguage
        targetLanguageText
        images {
          default
        }
        targetSoundUrls
        sourceSoundUrls
        targetVideoUrls
      }
    }
  }
`

/**
 * __useSearchQuizBasedGameConfigurationQuestionContentQuery__
 *
 * To run a query within a React component, call `useSearchQuizBasedGameConfigurationQuestionContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuizBasedGameConfigurationQuestionContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuizBasedGameConfigurationQuestionContentQuery({
 *   variables: {
 *      searchLearningFeatureInput: // value for 'searchLearningFeatureInput'
 *   },
 * });
 */
export function useSearchQuizBasedGameConfigurationQuestionContentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchQuizBasedGameConfigurationQuestionContentQuery,
    SearchQuizBasedGameConfigurationQuestionContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SearchQuizBasedGameConfigurationQuestionContentQuery,
    SearchQuizBasedGameConfigurationQuestionContentQueryVariables
  >(SearchQuizBasedGameConfigurationQuestionContentDocument, options)
}
export function useSearchQuizBasedGameConfigurationQuestionContentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchQuizBasedGameConfigurationQuestionContentQuery,
    SearchQuizBasedGameConfigurationQuestionContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SearchQuizBasedGameConfigurationQuestionContentQuery,
    SearchQuizBasedGameConfigurationQuestionContentQueryVariables
  >(SearchQuizBasedGameConfigurationQuestionContentDocument, options)
}
export type SearchQuizBasedGameConfigurationQuestionContentQueryHookResult = ReturnType<
  typeof useSearchQuizBasedGameConfigurationQuestionContentQuery
>
export type SearchQuizBasedGameConfigurationQuestionContentLazyQueryHookResult = ReturnType<
  typeof useSearchQuizBasedGameConfigurationQuestionContentLazyQuery
>
export type SearchQuizBasedGameConfigurationQuestionContentQueryResult = Apollo.QueryResult<
  SearchQuizBasedGameConfigurationQuestionContentQuery,
  SearchQuizBasedGameConfigurationQuestionContentQueryVariables
>
export const StartQuizGameDocument = gql`
  mutation startQuizGame($learningActivityId: ID!) {
    startQuizGame(learningActivityId: $learningActivityId) {
      id
      code
    }
  }
`
export type StartQuizGameMutationFn = Apollo.MutationFunction<StartQuizGameMutation, StartQuizGameMutationVariables>

/**
 * __useStartQuizGameMutation__
 *
 * To run a mutation, you first call `useStartQuizGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartQuizGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startQuizGameMutation, { data, loading, error }] = useStartQuizGameMutation({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *   },
 * });
 */
export function useStartQuizGameMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<StartQuizGameMutation, StartQuizGameMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<StartQuizGameMutation, StartQuizGameMutationVariables>(
    StartQuizGameDocument,
    options
  )
}
export type StartQuizGameMutationHookResult = ReturnType<typeof useStartQuizGameMutation>
export type StartQuizGameMutationResult = Apollo.MutationResult<StartQuizGameMutation>
export type StartQuizGameMutationOptions = Apollo.BaseMutationOptions<
  StartQuizGameMutation,
  StartQuizGameMutationVariables
>
export const AddUserLearningFeatureDocument = gql`
  mutation addUserLearningFeature($userLearningFeature: UserLearningFeatureInput!) {
    addUserLearningFeature(userLearningFeature: $userLearningFeature) {
      id
      targetLanguageText
      origin
    }
  }
`
export type AddUserLearningFeatureMutationFn = Apollo.MutationFunction<
  AddUserLearningFeatureMutation,
  AddUserLearningFeatureMutationVariables
>

/**
 * __useAddUserLearningFeatureMutation__
 *
 * To run a mutation, you first call `useAddUserLearningFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserLearningFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserLearningFeatureMutation, { data, loading, error }] = useAddUserLearningFeatureMutation({
 *   variables: {
 *      userLearningFeature: // value for 'userLearningFeature'
 *   },
 * });
 */
export function useAddUserLearningFeatureMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddUserLearningFeatureMutation,
    AddUserLearningFeatureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddUserLearningFeatureMutation, AddUserLearningFeatureMutationVariables>(
    AddUserLearningFeatureDocument,
    options
  )
}
export type AddUserLearningFeatureMutationHookResult = ReturnType<typeof useAddUserLearningFeatureMutation>
export type AddUserLearningFeatureMutationResult = Apollo.MutationResult<AddUserLearningFeatureMutation>
export type AddUserLearningFeatureMutationOptions = Apollo.BaseMutationOptions<
  AddUserLearningFeatureMutation,
  AddUserLearningFeatureMutationVariables
>
export const CreateLearningActivityV2Document = gql`
  mutation createLearningActivityV2($classroomId: ID!, $learningActivityInput: LearningActivityInput!) {
    createLearningActivityV2(classroomId: $classroomId, learningActivityInput: $learningActivityInput) {
      id
      state
      activityType
      assignmentMode
      estimatedTimeInSeconds
      timeLimitSeconds
      skills {
        skill
        isActive
      }
      progress {
        deadline
        progress
        total
        type
      }
      learningFeatureCount
      gameProperties {
        questionCount
        coverStyle
        isSoundEnabled
        wheelOfFortuneType
        worksheetLexicalType
        huntwordsAllDirections
      }
    }
  }
`
export type CreateLearningActivityV2MutationFn = Apollo.MutationFunction<
  CreateLearningActivityV2Mutation,
  CreateLearningActivityV2MutationVariables
>

/**
 * __useCreateLearningActivityV2Mutation__
 *
 * To run a mutation, you first call `useCreateLearningActivityV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningActivityV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningActivityV2Mutation, { data, loading, error }] = useCreateLearningActivityV2Mutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      learningActivityInput: // value for 'learningActivityInput'
 *   },
 * });
 */
export function useCreateLearningActivityV2Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateLearningActivityV2Mutation,
    CreateLearningActivityV2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateLearningActivityV2Mutation, CreateLearningActivityV2MutationVariables>(
    CreateLearningActivityV2Document,
    options
  )
}
export type CreateLearningActivityV2MutationHookResult = ReturnType<typeof useCreateLearningActivityV2Mutation>
export type CreateLearningActivityV2MutationResult = Apollo.MutationResult<CreateLearningActivityV2Mutation>
export type CreateLearningActivityV2MutationOptions = Apollo.BaseMutationOptions<
  CreateLearningActivityV2Mutation,
  CreateLearningActivityV2MutationVariables
>
export const CreateLearningPlanDocument = gql`
  mutation createLearningPlan($classroomId: ID!, $learningPlanInput: LearningPlanInput!) {
    createLearningPlan(classroomId: $classroomId, learningPlanInput: $learningPlanInput) {
      id
      title
      color
      unitNaming
      unitNumbering
      isActive
      isArchived
      extendLessons
      book {
        id
        name
        image {
          default
          small
        }
      }
    }
  }
`
export type CreateLearningPlanMutationFn = Apollo.MutationFunction<
  CreateLearningPlanMutation,
  CreateLearningPlanMutationVariables
>

/**
 * __useCreateLearningPlanMutation__
 *
 * To run a mutation, you first call `useCreateLearningPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningPlanMutation, { data, loading, error }] = useCreateLearningPlanMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      learningPlanInput: // value for 'learningPlanInput'
 *   },
 * });
 */
export function useCreateLearningPlanMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLearningPlanMutation, CreateLearningPlanMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateLearningPlanMutation, CreateLearningPlanMutationVariables>(
    CreateLearningPlanDocument,
    options
  )
}
export type CreateLearningPlanMutationHookResult = ReturnType<typeof useCreateLearningPlanMutation>
export type CreateLearningPlanMutationResult = Apollo.MutationResult<CreateLearningPlanMutation>
export type CreateLearningPlanMutationOptions = Apollo.BaseMutationOptions<
  CreateLearningPlanMutation,
  CreateLearningPlanMutationVariables
>
export const CreateLearningPlanPageCategoryDocument = gql`
  mutation createLearningPlanPageCategory($learningPlanId: ID!, $input: LearningPlanPageCategoryInput!) {
    createLearningPlanPageCategory(learningPlanId: $learningPlanId, input: $input) {
      id
      name
      pageCount
      finishedPageCount
      archivedPageCount
      isArchived
      categoryType
    }
  }
`
export type CreateLearningPlanPageCategoryMutationFn = Apollo.MutationFunction<
  CreateLearningPlanPageCategoryMutation,
  CreateLearningPlanPageCategoryMutationVariables
>

/**
 * __useCreateLearningPlanPageCategoryMutation__
 *
 * To run a mutation, you first call `useCreateLearningPlanPageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningPlanPageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningPlanPageCategoryMutation, { data, loading, error }] = useCreateLearningPlanPageCategoryMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningPlanPageCategoryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateLearningPlanPageCategoryMutation,
    CreateLearningPlanPageCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateLearningPlanPageCategoryMutation,
    CreateLearningPlanPageCategoryMutationVariables
  >(CreateLearningPlanPageCategoryDocument, options)
}
export type CreateLearningPlanPageCategoryMutationHookResult = ReturnType<
  typeof useCreateLearningPlanPageCategoryMutation
>
export type CreateLearningPlanPageCategoryMutationResult = Apollo.MutationResult<CreateLearningPlanPageCategoryMutation>
export type CreateLearningPlanPageCategoryMutationOptions = Apollo.BaseMutationOptions<
  CreateLearningPlanPageCategoryMutation,
  CreateLearningPlanPageCategoryMutationVariables
>
export const CreateLearningPlanPageFromLessonsDocument = gql`
  mutation createLearningPlanPageFromLessons($learningPlanId: ID!, $categoryId: ID!, $pageIds: [ID!]!) {
    createLearningPlanPageFromLessons(learningPlanId: $learningPlanId, categoryId: $categoryId, pageIds: $pageIds) {
      id
      learningPlanId
      title
      isFinished
      isArchived
      isGenerated
      learningFeatureCount
      learningFeatures(preview: true) {
        __typename
        id
        type
        origin
        ... on LearningFeatureTranslationV2 {
          targetLanguageText
        }
        ... on LearningFeatureGrammarV2 {
          name
          subtitle
          level
          example {
            fullText
            template
          }
        }
      }
      category {
        id
        name
        pageCount
        archivedPageCount
      }
    }
  }
`
export type CreateLearningPlanPageFromLessonsMutationFn = Apollo.MutationFunction<
  CreateLearningPlanPageFromLessonsMutation,
  CreateLearningPlanPageFromLessonsMutationVariables
>

/**
 * __useCreateLearningPlanPageFromLessonsMutation__
 *
 * To run a mutation, you first call `useCreateLearningPlanPageFromLessonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningPlanPageFromLessonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningPlanPageFromLessonsMutation, { data, loading, error }] = useCreateLearningPlanPageFromLessonsMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      categoryId: // value for 'categoryId'
 *      pageIds: // value for 'pageIds'
 *   },
 * });
 */
export function useCreateLearningPlanPageFromLessonsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateLearningPlanPageFromLessonsMutation,
    CreateLearningPlanPageFromLessonsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateLearningPlanPageFromLessonsMutation,
    CreateLearningPlanPageFromLessonsMutationVariables
  >(CreateLearningPlanPageFromLessonsDocument, options)
}
export type CreateLearningPlanPageFromLessonsMutationHookResult = ReturnType<
  typeof useCreateLearningPlanPageFromLessonsMutation
>
export type CreateLearningPlanPageFromLessonsMutationResult =
  Apollo.MutationResult<CreateLearningPlanPageFromLessonsMutation>
export type CreateLearningPlanPageFromLessonsMutationOptions = Apollo.BaseMutationOptions<
  CreateLearningPlanPageFromLessonsMutation,
  CreateLearningPlanPageFromLessonsMutationVariables
>
export const CreateLearningPlanPageStreamDocument = gql`
  mutation createLearningPlanPageStream($pageId: ID!, $learningPlanPageStreamInput: LearningPlanPageStreamInput!) {
    createLearningPlanPageStream(pageId: $pageId, learningPlanPageStreamInput: $learningPlanPageStreamInput) {
      id
      name
      blocks {
        ...LessonBlockShortFragment
      }
    }
  }
  ${LessonBlockShortFragmentFragmentDoc}
`
export type CreateLearningPlanPageStreamMutationFn = Apollo.MutationFunction<
  CreateLearningPlanPageStreamMutation,
  CreateLearningPlanPageStreamMutationVariables
>

/**
 * __useCreateLearningPlanPageStreamMutation__
 *
 * To run a mutation, you first call `useCreateLearningPlanPageStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningPlanPageStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningPlanPageStreamMutation, { data, loading, error }] = useCreateLearningPlanPageStreamMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      learningPlanPageStreamInput: // value for 'learningPlanPageStreamInput'
 *   },
 * });
 */
export function useCreateLearningPlanPageStreamMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateLearningPlanPageStreamMutation,
    CreateLearningPlanPageStreamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateLearningPlanPageStreamMutation,
    CreateLearningPlanPageStreamMutationVariables
  >(CreateLearningPlanPageStreamDocument, options)
}
export type CreateLearningPlanPageStreamMutationHookResult = ReturnType<typeof useCreateLearningPlanPageStreamMutation>
export type CreateLearningPlanPageStreamMutationResult = Apollo.MutationResult<CreateLearningPlanPageStreamMutation>
export type CreateLearningPlanPageStreamMutationOptions = Apollo.BaseMutationOptions<
  CreateLearningPlanPageStreamMutation,
  CreateLearningPlanPageStreamMutationVariables
>
export const CreateLearningPlanPageV2Document = gql`
  mutation createLearningPlanPageV2(
    $learningPlanId: ID!
    $categoryId: ID!
    $learningPlanPageInput: LearningPlanPageInputV2!
  ) {
    createLearningPlanPageV2(
      learningPlanId: $learningPlanId
      categoryId: $categoryId
      learningPlanPageInput: $learningPlanPageInput
    ) {
      id
      learningPlanId
      title
      isFinished
      isArchived
      isGenerated
      learningFeatureCount
      learningFeatures(preview: true) {
        __typename
        id
        type
        origin
        ... on LearningFeatureTranslationV2 {
          targetLanguageText
        }
        ... on LearningFeatureGrammarV2 {
          name
          subtitle
          level
          example {
            fullText
            template
          }
        }
      }
      category {
        id
        name
        pageCount
        archivedPageCount
      }
    }
  }
`
export type CreateLearningPlanPageV2MutationFn = Apollo.MutationFunction<
  CreateLearningPlanPageV2Mutation,
  CreateLearningPlanPageV2MutationVariables
>

/**
 * __useCreateLearningPlanPageV2Mutation__
 *
 * To run a mutation, you first call `useCreateLearningPlanPageV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningPlanPageV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningPlanPageV2Mutation, { data, loading, error }] = useCreateLearningPlanPageV2Mutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      categoryId: // value for 'categoryId'
 *      learningPlanPageInput: // value for 'learningPlanPageInput'
 *   },
 * });
 */
export function useCreateLearningPlanPageV2Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateLearningPlanPageV2Mutation,
    CreateLearningPlanPageV2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateLearningPlanPageV2Mutation, CreateLearningPlanPageV2MutationVariables>(
    CreateLearningPlanPageV2Document,
    options
  )
}
export type CreateLearningPlanPageV2MutationHookResult = ReturnType<typeof useCreateLearningPlanPageV2Mutation>
export type CreateLearningPlanPageV2MutationResult = Apollo.MutationResult<CreateLearningPlanPageV2Mutation>
export type CreateLearningPlanPageV2MutationOptions = Apollo.BaseMutationOptions<
  CreateLearningPlanPageV2Mutation,
  CreateLearningPlanPageV2MutationVariables
>
export const CreateLearningPlanPagesFromLearningsDocument = gql`
  mutation createLearningPlanPagesFromLearnings($learningPlanId: ID!, $learningIds: [ID!]!) {
    createLearningPlanPagesFromLearnings(learningPlanId: $learningPlanId, learningIds: $learningIds)
  }
`
export type CreateLearningPlanPagesFromLearningsMutationFn = Apollo.MutationFunction<
  CreateLearningPlanPagesFromLearningsMutation,
  CreateLearningPlanPagesFromLearningsMutationVariables
>

/**
 * __useCreateLearningPlanPagesFromLearningsMutation__
 *
 * To run a mutation, you first call `useCreateLearningPlanPagesFromLearningsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningPlanPagesFromLearningsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningPlanPagesFromLearningsMutation, { data, loading, error }] = useCreateLearningPlanPagesFromLearningsMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      learningIds: // value for 'learningIds'
 *   },
 * });
 */
export function useCreateLearningPlanPagesFromLearningsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateLearningPlanPagesFromLearningsMutation,
    CreateLearningPlanPagesFromLearningsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateLearningPlanPagesFromLearningsMutation,
    CreateLearningPlanPagesFromLearningsMutationVariables
  >(CreateLearningPlanPagesFromLearningsDocument, options)
}
export type CreateLearningPlanPagesFromLearningsMutationHookResult = ReturnType<
  typeof useCreateLearningPlanPagesFromLearningsMutation
>
export type CreateLearningPlanPagesFromLearningsMutationResult =
  Apollo.MutationResult<CreateLearningPlanPagesFromLearningsMutation>
export type CreateLearningPlanPagesFromLearningsMutationOptions = Apollo.BaseMutationOptions<
  CreateLearningPlanPagesFromLearningsMutation,
  CreateLearningPlanPagesFromLearningsMutationVariables
>
export const CreateLessonBlockDocument = gql`
  mutation createLessonBlock($streamId: ID!, $blockInput: LessonBlockInput!) {
    createLessonBlock(streamId: $streamId, blockInput: $blockInput) {
      ...LessonBlockShortFragment
    }
  }
  ${LessonBlockShortFragmentFragmentDoc}
`
export type CreateLessonBlockMutationFn = Apollo.MutationFunction<
  CreateLessonBlockMutation,
  CreateLessonBlockMutationVariables
>

/**
 * __useCreateLessonBlockMutation__
 *
 * To run a mutation, you first call `useCreateLessonBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLessonBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLessonBlockMutation, { data, loading, error }] = useCreateLessonBlockMutation({
 *   variables: {
 *      streamId: // value for 'streamId'
 *      blockInput: // value for 'blockInput'
 *   },
 * });
 */
export function useCreateLessonBlockMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLessonBlockMutation, CreateLessonBlockMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateLessonBlockMutation, CreateLessonBlockMutationVariables>(
    CreateLessonBlockDocument,
    options
  )
}
export type CreateLessonBlockMutationHookResult = ReturnType<typeof useCreateLessonBlockMutation>
export type CreateLessonBlockMutationResult = Apollo.MutationResult<CreateLessonBlockMutation>
export type CreateLessonBlockMutationOptions = Apollo.BaseMutationOptions<
  CreateLessonBlockMutation,
  CreateLessonBlockMutationVariables
>
export const DeleteLearningActivityDocument = gql`
  mutation deleteLearningActivity($learningActivityId: ID!) {
    deleteLearningActivity(learningActivityId: $learningActivityId)
  }
`
export type DeleteLearningActivityMutationFn = Apollo.MutationFunction<
  DeleteLearningActivityMutation,
  DeleteLearningActivityMutationVariables
>

/**
 * __useDeleteLearningActivityMutation__
 *
 * To run a mutation, you first call `useDeleteLearningActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningActivityMutation, { data, loading, error }] = useDeleteLearningActivityMutation({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *   },
 * });
 */
export function useDeleteLearningActivityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteLearningActivityMutation,
    DeleteLearningActivityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteLearningActivityMutation, DeleteLearningActivityMutationVariables>(
    DeleteLearningActivityDocument,
    options
  )
}
export type DeleteLearningActivityMutationHookResult = ReturnType<typeof useDeleteLearningActivityMutation>
export type DeleteLearningActivityMutationResult = Apollo.MutationResult<DeleteLearningActivityMutation>
export type DeleteLearningActivityMutationOptions = Apollo.BaseMutationOptions<
  DeleteLearningActivityMutation,
  DeleteLearningActivityMutationVariables
>
export const DeleteLearningPlanDocument = gql`
  mutation deleteLearningPlan($learningPlanId: ID!) {
    deleteLearningPlan(learningPlanId: $learningPlanId)
  }
`
export type DeleteLearningPlanMutationFn = Apollo.MutationFunction<
  DeleteLearningPlanMutation,
  DeleteLearningPlanMutationVariables
>

/**
 * __useDeleteLearningPlanMutation__
 *
 * To run a mutation, you first call `useDeleteLearningPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningPlanMutation, { data, loading, error }] = useDeleteLearningPlanMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *   },
 * });
 */
export function useDeleteLearningPlanMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLearningPlanMutation, DeleteLearningPlanMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteLearningPlanMutation, DeleteLearningPlanMutationVariables>(
    DeleteLearningPlanDocument,
    options
  )
}
export type DeleteLearningPlanMutationHookResult = ReturnType<typeof useDeleteLearningPlanMutation>
export type DeleteLearningPlanMutationResult = Apollo.MutationResult<DeleteLearningPlanMutation>
export type DeleteLearningPlanMutationOptions = Apollo.BaseMutationOptions<
  DeleteLearningPlanMutation,
  DeleteLearningPlanMutationVariables
>
export const DeleteLearningPlanPageDocument = gql`
  mutation deleteLearningPlanPage($pageId: ID!) {
    deleteLearningPlanPage(pageId: $pageId)
  }
`
export type DeleteLearningPlanPageMutationFn = Apollo.MutationFunction<
  DeleteLearningPlanPageMutation,
  DeleteLearningPlanPageMutationVariables
>

/**
 * __useDeleteLearningPlanPageMutation__
 *
 * To run a mutation, you first call `useDeleteLearningPlanPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningPlanPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningPlanPageMutation, { data, loading, error }] = useDeleteLearningPlanPageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeleteLearningPlanPageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteLearningPlanPageMutation,
    DeleteLearningPlanPageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteLearningPlanPageMutation, DeleteLearningPlanPageMutationVariables>(
    DeleteLearningPlanPageDocument,
    options
  )
}
export type DeleteLearningPlanPageMutationHookResult = ReturnType<typeof useDeleteLearningPlanPageMutation>
export type DeleteLearningPlanPageMutationResult = Apollo.MutationResult<DeleteLearningPlanPageMutation>
export type DeleteLearningPlanPageMutationOptions = Apollo.BaseMutationOptions<
  DeleteLearningPlanPageMutation,
  DeleteLearningPlanPageMutationVariables
>
export const DeleteLearningPlanPageCategoryDocument = gql`
  mutation deleteLearningPlanPageCategory($id: ID!) {
    deleteLearningPlanPageCategory(id: $id)
  }
`
export type DeleteLearningPlanPageCategoryMutationFn = Apollo.MutationFunction<
  DeleteLearningPlanPageCategoryMutation,
  DeleteLearningPlanPageCategoryMutationVariables
>

/**
 * __useDeleteLearningPlanPageCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteLearningPlanPageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningPlanPageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningPlanPageCategoryMutation, { data, loading, error }] = useDeleteLearningPlanPageCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLearningPlanPageCategoryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteLearningPlanPageCategoryMutation,
    DeleteLearningPlanPageCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteLearningPlanPageCategoryMutation,
    DeleteLearningPlanPageCategoryMutationVariables
  >(DeleteLearningPlanPageCategoryDocument, options)
}
export type DeleteLearningPlanPageCategoryMutationHookResult = ReturnType<
  typeof useDeleteLearningPlanPageCategoryMutation
>
export type DeleteLearningPlanPageCategoryMutationResult = Apollo.MutationResult<DeleteLearningPlanPageCategoryMutation>
export type DeleteLearningPlanPageCategoryMutationOptions = Apollo.BaseMutationOptions<
  DeleteLearningPlanPageCategoryMutation,
  DeleteLearningPlanPageCategoryMutationVariables
>
export const DeleteLearningPlanPageStreamDocument = gql`
  mutation deleteLearningPlanPageStream($streamId: ID!) {
    deleteLearningPlanPageStream(streamId: $streamId)
  }
`
export type DeleteLearningPlanPageStreamMutationFn = Apollo.MutationFunction<
  DeleteLearningPlanPageStreamMutation,
  DeleteLearningPlanPageStreamMutationVariables
>

/**
 * __useDeleteLearningPlanPageStreamMutation__
 *
 * To run a mutation, you first call `useDeleteLearningPlanPageStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningPlanPageStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningPlanPageStreamMutation, { data, loading, error }] = useDeleteLearningPlanPageStreamMutation({
 *   variables: {
 *      streamId: // value for 'streamId'
 *   },
 * });
 */
export function useDeleteLearningPlanPageStreamMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteLearningPlanPageStreamMutation,
    DeleteLearningPlanPageStreamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteLearningPlanPageStreamMutation,
    DeleteLearningPlanPageStreamMutationVariables
  >(DeleteLearningPlanPageStreamDocument, options)
}
export type DeleteLearningPlanPageStreamMutationHookResult = ReturnType<typeof useDeleteLearningPlanPageStreamMutation>
export type DeleteLearningPlanPageStreamMutationResult = Apollo.MutationResult<DeleteLearningPlanPageStreamMutation>
export type DeleteLearningPlanPageStreamMutationOptions = Apollo.BaseMutationOptions<
  DeleteLearningPlanPageStreamMutation,
  DeleteLearningPlanPageStreamMutationVariables
>
export const DeleteLessonBlockDocument = gql`
  mutation deleteLessonBlock($streamId: ID!, $blockId: ID!) {
    deleteLessonBlock(streamId: $streamId, blockId: $blockId)
  }
`
export type DeleteLessonBlockMutationFn = Apollo.MutationFunction<
  DeleteLessonBlockMutation,
  DeleteLessonBlockMutationVariables
>

/**
 * __useDeleteLessonBlockMutation__
 *
 * To run a mutation, you first call `useDeleteLessonBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLessonBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLessonBlockMutation, { data, loading, error }] = useDeleteLessonBlockMutation({
 *   variables: {
 *      streamId: // value for 'streamId'
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useDeleteLessonBlockMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLessonBlockMutation, DeleteLessonBlockMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteLessonBlockMutation, DeleteLessonBlockMutationVariables>(
    DeleteLessonBlockDocument,
    options
  )
}
export type DeleteLessonBlockMutationHookResult = ReturnType<typeof useDeleteLessonBlockMutation>
export type DeleteLessonBlockMutationResult = Apollo.MutationResult<DeleteLessonBlockMutation>
export type DeleteLessonBlockMutationOptions = Apollo.BaseMutationOptions<
  DeleteLessonBlockMutation,
  DeleteLessonBlockMutationVariables
>
export const DeleteUserLearningFeatureDocument = gql`
  mutation deleteUserLearningFeature($learningFeatureId: ID!) {
    deleteUserLearningFeature(learningFeatureId: $learningFeatureId)
  }
`
export type DeleteUserLearningFeatureMutationFn = Apollo.MutationFunction<
  DeleteUserLearningFeatureMutation,
  DeleteUserLearningFeatureMutationVariables
>

/**
 * __useDeleteUserLearningFeatureMutation__
 *
 * To run a mutation, you first call `useDeleteUserLearningFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserLearningFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserLearningFeatureMutation, { data, loading, error }] = useDeleteUserLearningFeatureMutation({
 *   variables: {
 *      learningFeatureId: // value for 'learningFeatureId'
 *   },
 * });
 */
export function useDeleteUserLearningFeatureMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteUserLearningFeatureMutation,
    DeleteUserLearningFeatureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteUserLearningFeatureMutation, DeleteUserLearningFeatureMutationVariables>(
    DeleteUserLearningFeatureDocument,
    options
  )
}
export type DeleteUserLearningFeatureMutationHookResult = ReturnType<typeof useDeleteUserLearningFeatureMutation>
export type DeleteUserLearningFeatureMutationResult = Apollo.MutationResult<DeleteUserLearningFeatureMutation>
export type DeleteUserLearningFeatureMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserLearningFeatureMutation,
  DeleteUserLearningFeatureMutationVariables
>
export const DuplicateLearningActivityDocument = gql`
  mutation duplicateLearningActivity($classroomId: ID!, $learningActivityId: ID!) {
    duplicateLearningActivity(classroomId: $classroomId, learningActivityId: $learningActivityId) {
      id
      state
      activityType
      assignmentMode
      estimatedTimeInSeconds
      timeLimitSeconds
      skills {
        skill
        isActive
      }
      progress {
        deadline
        progress
        total
        type
      }
      learningFeatureCount
      gameProperties {
        questionCount
        coverStyle
        isSoundEnabled
        wheelOfFortuneType
        worksheetLexicalType
        huntwordsAllDirections
      }
    }
  }
`
export type DuplicateLearningActivityMutationFn = Apollo.MutationFunction<
  DuplicateLearningActivityMutation,
  DuplicateLearningActivityMutationVariables
>

/**
 * __useDuplicateLearningActivityMutation__
 *
 * To run a mutation, you first call `useDuplicateLearningActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateLearningActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateLearningActivityMutation, { data, loading, error }] = useDuplicateLearningActivityMutation({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      learningActivityId: // value for 'learningActivityId'
 *   },
 * });
 */
export function useDuplicateLearningActivityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DuplicateLearningActivityMutation,
    DuplicateLearningActivityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DuplicateLearningActivityMutation, DuplicateLearningActivityMutationVariables>(
    DuplicateLearningActivityDocument,
    options
  )
}
export type DuplicateLearningActivityMutationHookResult = ReturnType<typeof useDuplicateLearningActivityMutation>
export type DuplicateLearningActivityMutationResult = Apollo.MutationResult<DuplicateLearningActivityMutation>
export type DuplicateLearningActivityMutationOptions = Apollo.BaseMutationOptions<
  DuplicateLearningActivityMutation,
  DuplicateLearningActivityMutationVariables
>
export const DuplicateLearningPlanPagesDocument = gql`
  mutation duplicateLearningPlanPages($pageIds: [ID!]!, $targetLearningPlanId: ID!, $categoryId: ID) {
    duplicateLearningPlanPages(pageIds: $pageIds, targetLearningPlanId: $targetLearningPlanId, categoryId: $categoryId)
  }
`
export type DuplicateLearningPlanPagesMutationFn = Apollo.MutationFunction<
  DuplicateLearningPlanPagesMutation,
  DuplicateLearningPlanPagesMutationVariables
>

/**
 * __useDuplicateLearningPlanPagesMutation__
 *
 * To run a mutation, you first call `useDuplicateLearningPlanPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateLearningPlanPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateLearningPlanPagesMutation, { data, loading, error }] = useDuplicateLearningPlanPagesMutation({
 *   variables: {
 *      pageIds: // value for 'pageIds'
 *      targetLearningPlanId: // value for 'targetLearningPlanId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDuplicateLearningPlanPagesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DuplicateLearningPlanPagesMutation,
    DuplicateLearningPlanPagesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DuplicateLearningPlanPagesMutation, DuplicateLearningPlanPagesMutationVariables>(
    DuplicateLearningPlanPagesDocument,
    options
  )
}
export type DuplicateLearningPlanPagesMutationHookResult = ReturnType<typeof useDuplicateLearningPlanPagesMutation>
export type DuplicateLearningPlanPagesMutationResult = Apollo.MutationResult<DuplicateLearningPlanPagesMutation>
export type DuplicateLearningPlanPagesMutationOptions = Apollo.BaseMutationOptions<
  DuplicateLearningPlanPagesMutation,
  DuplicateLearningPlanPagesMutationVariables
>
export const ExtendLearningPlanPageContentDocument = gql`
  mutation extendLearningPlanPageContent($pageId: ID!) {
    extendLearningPlanPageContent(pageId: $pageId) {
      ...LearningFeatureShortDetail
    }
  }
  ${LearningFeatureShortDetailFragmentDoc}
`
export type ExtendLearningPlanPageContentMutationFn = Apollo.MutationFunction<
  ExtendLearningPlanPageContentMutation,
  ExtendLearningPlanPageContentMutationVariables
>

/**
 * __useExtendLearningPlanPageContentMutation__
 *
 * To run a mutation, you first call `useExtendLearningPlanPageContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendLearningPlanPageContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendLearningPlanPageContentMutation, { data, loading, error }] = useExtendLearningPlanPageContentMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useExtendLearningPlanPageContentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ExtendLearningPlanPageContentMutation,
    ExtendLearningPlanPageContentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ExtendLearningPlanPageContentMutation,
    ExtendLearningPlanPageContentMutationVariables
  >(ExtendLearningPlanPageContentDocument, options)
}
export type ExtendLearningPlanPageContentMutationHookResult = ReturnType<
  typeof useExtendLearningPlanPageContentMutation
>
export type ExtendLearningPlanPageContentMutationResult = Apollo.MutationResult<ExtendLearningPlanPageContentMutation>
export type ExtendLearningPlanPageContentMutationOptions = Apollo.BaseMutationOptions<
  ExtendLearningPlanPageContentMutation,
  ExtendLearningPlanPageContentMutationVariables
>
export const GetFavoriteBooksDocument = gql`
  query getFavoriteBooks($subject: Subject!, $classroomId: ID!, $mainLearningId: ID) {
    favoriteBooks(subject: $subject, classroomId: $classroomId, mainLearningId: $mainLearningId) {
      id
      name
      image {
        default
        small
      }
    }
  }
`

/**
 * __useGetFavoriteBooksQuery__
 *
 * To run a query within a React component, call `useGetFavoriteBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteBooksQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      classroomId: // value for 'classroomId'
 *      mainLearningId: // value for 'mainLearningId'
 *   },
 * });
 */
export function useGetFavoriteBooksQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetFavoriteBooksQuery, GetFavoriteBooksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetFavoriteBooksQuery, GetFavoriteBooksQueryVariables>(
    GetFavoriteBooksDocument,
    options
  )
}
export function useGetFavoriteBooksLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFavoriteBooksQuery, GetFavoriteBooksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetFavoriteBooksQuery, GetFavoriteBooksQueryVariables>(
    GetFavoriteBooksDocument,
    options
  )
}
export type GetFavoriteBooksQueryHookResult = ReturnType<typeof useGetFavoriteBooksQuery>
export type GetFavoriteBooksLazyQueryHookResult = ReturnType<typeof useGetFavoriteBooksLazyQuery>
export type GetFavoriteBooksQueryResult = Apollo.QueryResult<GetFavoriteBooksQuery, GetFavoriteBooksQueryVariables>
export const GetLearningActivityDocument = gql`
  query getLearningActivity($learningActivityId: ID!) {
    learningActivity(learningActivityId: $learningActivityId) {
      id
      learningActivityExecutionId
      contentSourceLabel
      state
      activityType
      assignmentMode
      estimatedTimeInSeconds
      timeLimitSeconds
      skills {
        skill
        isActive
      }
      progress {
        deadline
        progress
        total
        type
      }
      learningFeatureCount
      learningFeatures {
        ...LearningFeatureActivityFragment
      }
      gameProperties {
        questionCount
        coverStyle
        isSoundEnabled
        wheelOfFortuneType
        worksheetLexicalType
        huntwordsAllDirections
      }
    }
  }
  ${LearningFeatureActivityFragmentFragmentDoc}
`

/**
 * __useGetLearningActivityQuery__
 *
 * To run a query within a React component, call `useGetLearningActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningActivityQuery({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *   },
 * });
 */
export function useGetLearningActivityQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetLearningActivityQuery, GetLearningActivityQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLearningActivityQuery, GetLearningActivityQueryVariables>(
    GetLearningActivityDocument,
    options
  )
}
export function useGetLearningActivityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLearningActivityQuery, GetLearningActivityQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLearningActivityQuery, GetLearningActivityQueryVariables>(
    GetLearningActivityDocument,
    options
  )
}
export type GetLearningActivityQueryHookResult = ReturnType<typeof useGetLearningActivityQuery>
export type GetLearningActivityLazyQueryHookResult = ReturnType<typeof useGetLearningActivityLazyQuery>
export type GetLearningActivityQueryResult = Apollo.QueryResult<
  GetLearningActivityQuery,
  GetLearningActivityQueryVariables
>
export const GetLearningPlanCategoriesDocument = gql`
  query getLearningPlanCategories($learningPlanId: ID!) {
    learningPlanCategories(learningPlanId: $learningPlanId) {
      id
      name
      pageCount
      finishedPageCount
      archivedPageCount
      isArchived
      categoryType
      image {
        medium
        default
      }
    }
  }
`

/**
 * __useGetLearningPlanCategoriesQuery__
 *
 * To run a query within a React component, call `useGetLearningPlanCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningPlanCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningPlanCategoriesQuery({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *   },
 * });
 */
export function useGetLearningPlanCategoriesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetLearningPlanCategoriesQuery,
    GetLearningPlanCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLearningPlanCategoriesQuery, GetLearningPlanCategoriesQueryVariables>(
    GetLearningPlanCategoriesDocument,
    options
  )
}
export function useGetLearningPlanCategoriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLearningPlanCategoriesQuery,
    GetLearningPlanCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLearningPlanCategoriesQuery, GetLearningPlanCategoriesQueryVariables>(
    GetLearningPlanCategoriesDocument,
    options
  )
}
export type GetLearningPlanCategoriesQueryHookResult = ReturnType<typeof useGetLearningPlanCategoriesQuery>
export type GetLearningPlanCategoriesLazyQueryHookResult = ReturnType<typeof useGetLearningPlanCategoriesLazyQuery>
export type GetLearningPlanCategoriesQueryResult = Apollo.QueryResult<
  GetLearningPlanCategoriesQuery,
  GetLearningPlanCategoriesQueryVariables
>
export const GetLearningPlanPageStreamDocument = gql`
  query getLearningPlanPageStream($streamId: ID!) {
    learningPlanPageStream(streamId: $streamId) {
      id
      name
      blocks {
        ...LessonBlockShortFragment
      }
    }
  }
  ${LessonBlockShortFragmentFragmentDoc}
`

/**
 * __useGetLearningPlanPageStreamQuery__
 *
 * To run a query within a React component, call `useGetLearningPlanPageStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningPlanPageStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningPlanPageStreamQuery({
 *   variables: {
 *      streamId: // value for 'streamId'
 *   },
 * });
 */
export function useGetLearningPlanPageStreamQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetLearningPlanPageStreamQuery,
    GetLearningPlanPageStreamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLearningPlanPageStreamQuery, GetLearningPlanPageStreamQueryVariables>(
    GetLearningPlanPageStreamDocument,
    options
  )
}
export function useGetLearningPlanPageStreamLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLearningPlanPageStreamQuery,
    GetLearningPlanPageStreamQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLearningPlanPageStreamQuery, GetLearningPlanPageStreamQueryVariables>(
    GetLearningPlanPageStreamDocument,
    options
  )
}
export type GetLearningPlanPageStreamQueryHookResult = ReturnType<typeof useGetLearningPlanPageStreamQuery>
export type GetLearningPlanPageStreamLazyQueryHookResult = ReturnType<typeof useGetLearningPlanPageStreamLazyQuery>
export type GetLearningPlanPageStreamQueryResult = Apollo.QueryResult<
  GetLearningPlanPageStreamQuery,
  GetLearningPlanPageStreamQueryVariables
>
export const GetLearningPlanPageV2Document = gql`
  query getLearningPlanPageV2($pageId: ID!) {
    learningPlanPageV2(pageId: $pageId) {
      id
      learningPlanId
      title
      isFinished
      isArchived
      isGenerated
      learningFeatureCount
      nextPageId
      previousPageId
      learningFeatures(preview: true) {
        ...LearningFeatureShortDetail
      }
      streams {
        id
        name
      }
      category {
        id
        name
        pageCount
        archivedPageCount
      }
      canBeExtended
      disabledLearningFeatures
    }
  }
  ${LearningFeatureShortDetailFragmentDoc}
`

/**
 * __useGetLearningPlanPageV2Query__
 *
 * To run a query within a React component, call `useGetLearningPlanPageV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningPlanPageV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningPlanPageV2Query({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useGetLearningPlanPageV2Query(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetLearningPlanPageV2Query, GetLearningPlanPageV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLearningPlanPageV2Query, GetLearningPlanPageV2QueryVariables>(
    GetLearningPlanPageV2Document,
    options
  )
}
export function useGetLearningPlanPageV2LazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLearningPlanPageV2Query, GetLearningPlanPageV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLearningPlanPageV2Query, GetLearningPlanPageV2QueryVariables>(
    GetLearningPlanPageV2Document,
    options
  )
}
export type GetLearningPlanPageV2QueryHookResult = ReturnType<typeof useGetLearningPlanPageV2Query>
export type GetLearningPlanPageV2LazyQueryHookResult = ReturnType<typeof useGetLearningPlanPageV2LazyQuery>
export type GetLearningPlanPageV2QueryResult = Apollo.QueryResult<
  GetLearningPlanPageV2Query,
  GetLearningPlanPageV2QueryVariables
>
export const GetLearningPlanPagesV2Document = gql`
  query getLearningPlanPagesV2($learningPlanId: ID!, $categoryId: ID!) {
    learningPlanPagesV2(learningPlanId: $learningPlanId, categoryId: $categoryId) {
      id
      learningPlanId
      title
      isFinished
      isArchived
      isGenerated
      learningFeatureCount
      learningFeatures(preview: true) {
        __typename
        id
        ... on LearningFeatureTranslationV2 {
          targetLanguageText
        }
        ... on LearningFeatureGrammarV2 {
          name
          subtitle
          level
          example {
            fullText
            template
          }
        }
      }
    }
  }
`

/**
 * __useGetLearningPlanPagesV2Query__
 *
 * To run a query within a React component, call `useGetLearningPlanPagesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningPlanPagesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningPlanPagesV2Query({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetLearningPlanPagesV2Query(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetLearningPlanPagesV2Query, GetLearningPlanPagesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLearningPlanPagesV2Query, GetLearningPlanPagesV2QueryVariables>(
    GetLearningPlanPagesV2Document,
    options
  )
}
export function useGetLearningPlanPagesV2LazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLearningPlanPagesV2Query, GetLearningPlanPagesV2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLearningPlanPagesV2Query, GetLearningPlanPagesV2QueryVariables>(
    GetLearningPlanPagesV2Document,
    options
  )
}
export type GetLearningPlanPagesV2QueryHookResult = ReturnType<typeof useGetLearningPlanPagesV2Query>
export type GetLearningPlanPagesV2LazyQueryHookResult = ReturnType<typeof useGetLearningPlanPagesV2LazyQuery>
export type GetLearningPlanPagesV2QueryResult = Apollo.QueryResult<
  GetLearningPlanPagesV2Query,
  GetLearningPlanPagesV2QueryVariables
>
export const GetLearningPlansDocument = gql`
  query getLearningPlans($classroomId: ID!) {
    learningPlans(classroomId: $classroomId) {
      id
      title
      color
      unitNaming
      unitNumbering
      isActive
      isArchived
      extendLessons
      book {
        id
        name
        image {
          default
          small
        }
      }
    }
  }
`

/**
 * __useGetLearningPlansQuery__
 *
 * To run a query within a React component, call `useGetLearningPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningPlansQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *   },
 * });
 */
export function useGetLearningPlansQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetLearningPlansQuery, GetLearningPlansQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLearningPlansQuery, GetLearningPlansQueryVariables>(
    GetLearningPlansDocument,
    options
  )
}
export function useGetLearningPlansLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLearningPlansQuery, GetLearningPlansQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLearningPlansQuery, GetLearningPlansQueryVariables>(
    GetLearningPlansDocument,
    options
  )
}
export type GetLearningPlansQueryHookResult = ReturnType<typeof useGetLearningPlansQuery>
export type GetLearningPlansLazyQueryHookResult = ReturnType<typeof useGetLearningPlansLazyQuery>
export type GetLearningPlansQueryResult = Apollo.QueryResult<GetLearningPlansQuery, GetLearningPlansQueryVariables>
export const GetLessonBlockDocument = gql`
  query getLessonBlock($blockId: ID!) {
    lessonBlock(blockId: $blockId) {
      __typename
      id
      name
      type
      streamId
      isPresentable
      ... on LessonBlockActivity {
        activity {
          id
          state
          activityType
          assignmentMode
          estimatedTimeInSeconds
          timeLimitSeconds
          contentSourceLabel
          skills {
            skill
            isActive
          }
          progress {
            deadline
            progress
            total
            type
          }
          learningFeatureCount
          learningFeatures {
            ...LearningFeatureActivityFragment
          }
          gameProperties {
            questionCount
            coverStyle
            isSoundEnabled
            wheelOfFortuneType
            worksheetLexicalType
            huntwordsAllDirections
          }
        }
      }
      ... on LessonBlockBookOrientation {
        book {
          id
          name
          level
          subject
          image {
            medium
          }
        }
        pageFrom
        pageTo
      }
      ... on LessonBlockFreeText {
        content
      }
      ... on LessonBlockMistakes {
        mistakeCount
        mistakes {
          name
          textWithMistake
          wrongPart
          correctAnswer
          explanation
          learningFeature {
            id
            type
          }
        }
      }
      ... on LessonBlockImages {
        description
        images {
          name
          url
        }
      }
      ... on LessonBlockVideos {
        description
        videos {
          name
          url
        }
      }
    }
  }
  ${LearningFeatureActivityFragmentFragmentDoc}
`

/**
 * __useGetLessonBlockQuery__
 *
 * To run a query within a React component, call `useGetLessonBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonBlockQuery({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useGetLessonBlockQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetLessonBlockQuery, GetLessonBlockQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLessonBlockQuery, GetLessonBlockQueryVariables>(GetLessonBlockDocument, options)
}
export function useGetLessonBlockLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLessonBlockQuery, GetLessonBlockQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLessonBlockQuery, GetLessonBlockQueryVariables>(
    GetLessonBlockDocument,
    options
  )
}
export type GetLessonBlockQueryHookResult = ReturnType<typeof useGetLessonBlockQuery>
export type GetLessonBlockLazyQueryHookResult = ReturnType<typeof useGetLessonBlockLazyQuery>
export type GetLessonBlockQueryResult = Apollo.QueryResult<GetLessonBlockQuery, GetLessonBlockQueryVariables>
export const GetSubjectsDocument = gql`
  query getSubjects {
    subjects
  }
`

/**
 * __useGetSubjectsQuery__
 *
 * To run a query within a React component, call `useGetSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubjectsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubjectsQuery, GetSubjectsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetSubjectsQuery, GetSubjectsQueryVariables>(GetSubjectsDocument, options)
}
export function useGetSubjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubjectsQuery, GetSubjectsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetSubjectsQuery, GetSubjectsQueryVariables>(GetSubjectsDocument, options)
}
export type GetSubjectsQueryHookResult = ReturnType<typeof useGetSubjectsQuery>
export type GetSubjectsLazyQueryHookResult = ReturnType<typeof useGetSubjectsLazyQuery>
export type GetSubjectsQueryResult = Apollo.QueryResult<GetSubjectsQuery, GetSubjectsQueryVariables>
export const GetWorksheetsAllowedTypesDocument = gql`
  query getWorksheetsAllowedTypes {
    worksheetsAllowedTypes {
      worksheetType
      allowedLexicalTypes
    }
  }
`

/**
 * __useGetWorksheetsAllowedTypesQuery__
 *
 * To run a query within a React component, call `useGetWorksheetsAllowedTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorksheetsAllowedTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorksheetsAllowedTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorksheetsAllowedTypesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetWorksheetsAllowedTypesQuery,
    GetWorksheetsAllowedTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetWorksheetsAllowedTypesQuery, GetWorksheetsAllowedTypesQueryVariables>(
    GetWorksheetsAllowedTypesDocument,
    options
  )
}
export function useGetWorksheetsAllowedTypesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetWorksheetsAllowedTypesQuery,
    GetWorksheetsAllowedTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetWorksheetsAllowedTypesQuery, GetWorksheetsAllowedTypesQueryVariables>(
    GetWorksheetsAllowedTypesDocument,
    options
  )
}
export type GetWorksheetsAllowedTypesQueryHookResult = ReturnType<typeof useGetWorksheetsAllowedTypesQuery>
export type GetWorksheetsAllowedTypesLazyQueryHookResult = ReturnType<typeof useGetWorksheetsAllowedTypesLazyQuery>
export type GetWorksheetsAllowedTypesQueryResult = Apollo.QueryResult<
  GetWorksheetsAllowedTypesQuery,
  GetWorksheetsAllowedTypesQueryVariables
>
export const QuizBasedGameConfigurationPreviewDocument = gql`
  query quizBasedGameConfigurationPreview($learningActivityId: ID!, $gameType: QuizBasedGameType!) {
    quizBasedGameConfigurationByActivityId(learningActivityId: $learningActivityId, gameType: $gameType) {
      id
      gameType
      groups {
        id
        name
        questions {
          index
          text
          lexicalType
          learningFeatureDirection
          learningFeature {
            id
            type
            sourceLanguageText
            targetLanguageText
          }
          options {
            index
            isCorrect
            text
            learningFeature {
              id
              sourceLanguageText
              targetLanguageText
            }
          }
          media {
            imageUrl
          }
        }
      }
    }
  }
`

/**
 * __useQuizBasedGameConfigurationPreviewQuery__
 *
 * To run a query within a React component, call `useQuizBasedGameConfigurationPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizBasedGameConfigurationPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizBasedGameConfigurationPreviewQuery({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *      gameType: // value for 'gameType'
 *   },
 * });
 */
export function useQuizBasedGameConfigurationPreviewQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    QuizBasedGameConfigurationPreviewQuery,
    QuizBasedGameConfigurationPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    QuizBasedGameConfigurationPreviewQuery,
    QuizBasedGameConfigurationPreviewQueryVariables
  >(QuizBasedGameConfigurationPreviewDocument, options)
}
export function useQuizBasedGameConfigurationPreviewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    QuizBasedGameConfigurationPreviewQuery,
    QuizBasedGameConfigurationPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    QuizBasedGameConfigurationPreviewQuery,
    QuizBasedGameConfigurationPreviewQueryVariables
  >(QuizBasedGameConfigurationPreviewDocument, options)
}
export type QuizBasedGameConfigurationPreviewQueryHookResult = ReturnType<
  typeof useQuizBasedGameConfigurationPreviewQuery
>
export type QuizBasedGameConfigurationPreviewLazyQueryHookResult = ReturnType<
  typeof useQuizBasedGameConfigurationPreviewLazyQuery
>
export type QuizBasedGameConfigurationPreviewQueryResult = Apollo.QueryResult<
  QuizBasedGameConfigurationPreviewQuery,
  QuizBasedGameConfigurationPreviewQueryVariables
>
export const SearchLearningPlanPagesDocument = gql`
  query searchLearningPlanPages($learningPlanId: ID!, $categoryId: ID!) {
    learningPlanPagesV2(learningPlanId: $learningPlanId, categoryId: $categoryId) {
      id
      title
    }
  }
`

/**
 * __useSearchLearningPlanPagesQuery__
 *
 * To run a query within a React component, call `useSearchLearningPlanPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLearningPlanPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLearningPlanPagesQuery({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useSearchLearningPlanPagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<SearchLearningPlanPagesQuery, SearchLearningPlanPagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SearchLearningPlanPagesQuery, SearchLearningPlanPagesQueryVariables>(
    SearchLearningPlanPagesDocument,
    options
  )
}
export function useSearchLearningPlanPagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchLearningPlanPagesQuery,
    SearchLearningPlanPagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SearchLearningPlanPagesQuery, SearchLearningPlanPagesQueryVariables>(
    SearchLearningPlanPagesDocument,
    options
  )
}
export type SearchLearningPlanPagesQueryHookResult = ReturnType<typeof useSearchLearningPlanPagesQuery>
export type SearchLearningPlanPagesLazyQueryHookResult = ReturnType<typeof useSearchLearningPlanPagesLazyQuery>
export type SearchLearningPlanPagesQueryResult = Apollo.QueryResult<
  SearchLearningPlanPagesQuery,
  SearchLearningPlanPagesQueryVariables
>
export const StartLearningActivityDocument = gql`
  mutation startLearningActivity($learningActivityId: ID!) {
    startLearningActivity(learningActivityId: $learningActivityId) {
      id
      state
      estimatedTimeInSeconds
      activityType
      assignmentMode
      contentSourceLabel
      subject
      progress {
        deadline
        progress
        total
        type
      }
      learningActivityExecutionId
      learningFeatureCount
      learningFeatures {
        ...LearningFeatureActivityFragment
      }
      gameProperties {
        questionCount
        coverStyle
        isSoundEnabled
        wheelOfFortuneType
        worksheetLexicalType
        huntwordsAllDirections
      }
    }
  }
  ${LearningFeatureActivityFragmentFragmentDoc}
`
export type StartLearningActivityMutationFn = Apollo.MutationFunction<
  StartLearningActivityMutation,
  StartLearningActivityMutationVariables
>

/**
 * __useStartLearningActivityMutation__
 *
 * To run a mutation, you first call `useStartLearningActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartLearningActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startLearningActivityMutation, { data, loading, error }] = useStartLearningActivityMutation({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *   },
 * });
 */
export function useStartLearningActivityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartLearningActivityMutation,
    StartLearningActivityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<StartLearningActivityMutation, StartLearningActivityMutationVariables>(
    StartLearningActivityDocument,
    options
  )
}
export type StartLearningActivityMutationHookResult = ReturnType<typeof useStartLearningActivityMutation>
export type StartLearningActivityMutationResult = Apollo.MutationResult<StartLearningActivityMutation>
export type StartLearningActivityMutationOptions = Apollo.BaseMutationOptions<
  StartLearningActivityMutation,
  StartLearningActivityMutationVariables
>
export const StopLearningActivityDocument = gql`
  mutation stopLearningActivity($learningActivityId: ID!) {
    stopLearningActivity(learningActivityId: $learningActivityId) {
      id
      state
      progress {
        deadline
        progress
        total
        type
      }
      learningActivityExecutionId
    }
  }
`
export type StopLearningActivityMutationFn = Apollo.MutationFunction<
  StopLearningActivityMutation,
  StopLearningActivityMutationVariables
>

/**
 * __useStopLearningActivityMutation__
 *
 * To run a mutation, you first call `useStopLearningActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopLearningActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopLearningActivityMutation, { data, loading, error }] = useStopLearningActivityMutation({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *   },
 * });
 */
export function useStopLearningActivityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StopLearningActivityMutation,
    StopLearningActivityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<StopLearningActivityMutation, StopLearningActivityMutationVariables>(
    StopLearningActivityDocument,
    options
  )
}
export type StopLearningActivityMutationHookResult = ReturnType<typeof useStopLearningActivityMutation>
export type StopLearningActivityMutationResult = Apollo.MutationResult<StopLearningActivityMutation>
export type StopLearningActivityMutationOptions = Apollo.BaseMutationOptions<
  StopLearningActivityMutation,
  StopLearningActivityMutationVariables
>
export const UpdateFavoriteBooksDocument = gql`
  mutation updateFavoriteBooks($subject: Subject!, $classroomId: ID!, $mainLearningId: ID, $bookIds: [ID!]!) {
    updateFavoriteBooks(
      subject: $subject
      classroomId: $classroomId
      mainLearningId: $mainLearningId
      bookIds: $bookIds
    ) {
      id
      name
      level
      image {
        default
        small
      }
    }
  }
`
export type UpdateFavoriteBooksMutationFn = Apollo.MutationFunction<
  UpdateFavoriteBooksMutation,
  UpdateFavoriteBooksMutationVariables
>

/**
 * __useUpdateFavoriteBooksMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteBooksMutation, { data, loading, error }] = useUpdateFavoriteBooksMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      classroomId: // value for 'classroomId'
 *      mainLearningId: // value for 'mainLearningId'
 *      bookIds: // value for 'bookIds'
 *   },
 * });
 */
export function useUpdateFavoriteBooksMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFavoriteBooksMutation, UpdateFavoriteBooksMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateFavoriteBooksMutation, UpdateFavoriteBooksMutationVariables>(
    UpdateFavoriteBooksDocument,
    options
  )
}
export type UpdateFavoriteBooksMutationHookResult = ReturnType<typeof useUpdateFavoriteBooksMutation>
export type UpdateFavoriteBooksMutationResult = Apollo.MutationResult<UpdateFavoriteBooksMutation>
export type UpdateFavoriteBooksMutationOptions = Apollo.BaseMutationOptions<
  UpdateFavoriteBooksMutation,
  UpdateFavoriteBooksMutationVariables
>
export const UpdateLearningActivityDocument = gql`
  mutation updateLearningActivity($learningActivityId: ID!, $learningActivityInput: LearningActivityInput!) {
    updateLearningActivity(learningActivityId: $learningActivityId, learningActivityInput: $learningActivityInput) {
      id
      state
      activityType
      assignmentMode
      estimatedTimeInSeconds
      timeLimitSeconds
      skills {
        skill
        isActive
      }
      progress {
        deadline
        progress
        total
        type
      }
      learningFeatureCount
      gameProperties {
        questionCount
        coverStyle
        isSoundEnabled
        wheelOfFortuneType
        worksheetLexicalType
        huntwordsAllDirections
      }
    }
  }
`
export type UpdateLearningActivityMutationFn = Apollo.MutationFunction<
  UpdateLearningActivityMutation,
  UpdateLearningActivityMutationVariables
>

/**
 * __useUpdateLearningActivityMutation__
 *
 * To run a mutation, you first call `useUpdateLearningActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningActivityMutation, { data, loading, error }] = useUpdateLearningActivityMutation({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *      learningActivityInput: // value for 'learningActivityInput'
 *   },
 * });
 */
export function useUpdateLearningActivityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateLearningActivityMutation,
    UpdateLearningActivityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateLearningActivityMutation, UpdateLearningActivityMutationVariables>(
    UpdateLearningActivityDocument,
    options
  )
}
export type UpdateLearningActivityMutationHookResult = ReturnType<typeof useUpdateLearningActivityMutation>
export type UpdateLearningActivityMutationResult = Apollo.MutationResult<UpdateLearningActivityMutation>
export type UpdateLearningActivityMutationOptions = Apollo.BaseMutationOptions<
  UpdateLearningActivityMutation,
  UpdateLearningActivityMutationVariables
>
export const UpdateLearningPlanDocument = gql`
  mutation updateLearningPlan($learningPlanId: ID!, $learningPlanInput: LearningPlanInput!) {
    updateLearningPlan(learningPlanId: $learningPlanId, learningPlanInput: $learningPlanInput) {
      id
      title
      color
      unitNaming
      unitNumbering
      isActive
      isArchived
      extendLessons
      book {
        id
        name
        image {
          default
          small
        }
      }
    }
  }
`
export type UpdateLearningPlanMutationFn = Apollo.MutationFunction<
  UpdateLearningPlanMutation,
  UpdateLearningPlanMutationVariables
>

/**
 * __useUpdateLearningPlanMutation__
 *
 * To run a mutation, you first call `useUpdateLearningPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningPlanMutation, { data, loading, error }] = useUpdateLearningPlanMutation({
 *   variables: {
 *      learningPlanId: // value for 'learningPlanId'
 *      learningPlanInput: // value for 'learningPlanInput'
 *   },
 * });
 */
export function useUpdateLearningPlanMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLearningPlanMutation, UpdateLearningPlanMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateLearningPlanMutation, UpdateLearningPlanMutationVariables>(
    UpdateLearningPlanDocument,
    options
  )
}
export type UpdateLearningPlanMutationHookResult = ReturnType<typeof useUpdateLearningPlanMutation>
export type UpdateLearningPlanMutationResult = Apollo.MutationResult<UpdateLearningPlanMutation>
export type UpdateLearningPlanMutationOptions = Apollo.BaseMutationOptions<
  UpdateLearningPlanMutation,
  UpdateLearningPlanMutationVariables
>
export const UpdateLearningPlanPageCategoryDocument = gql`
  mutation updateLearningPlanPageCategory($id: ID!, $input: LearningPlanPageCategoryInput!) {
    updateLearningPlanPageCategory(id: $id, input: $input) {
      id
      name
      pageCount
      finishedPageCount
      archivedPageCount
      isArchived
      categoryType
    }
  }
`
export type UpdateLearningPlanPageCategoryMutationFn = Apollo.MutationFunction<
  UpdateLearningPlanPageCategoryMutation,
  UpdateLearningPlanPageCategoryMutationVariables
>

/**
 * __useUpdateLearningPlanPageCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateLearningPlanPageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningPlanPageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningPlanPageCategoryMutation, { data, loading, error }] = useUpdateLearningPlanPageCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLearningPlanPageCategoryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateLearningPlanPageCategoryMutation,
    UpdateLearningPlanPageCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateLearningPlanPageCategoryMutation,
    UpdateLearningPlanPageCategoryMutationVariables
  >(UpdateLearningPlanPageCategoryDocument, options)
}
export type UpdateLearningPlanPageCategoryMutationHookResult = ReturnType<
  typeof useUpdateLearningPlanPageCategoryMutation
>
export type UpdateLearningPlanPageCategoryMutationResult = Apollo.MutationResult<UpdateLearningPlanPageCategoryMutation>
export type UpdateLearningPlanPageCategoryMutationOptions = Apollo.BaseMutationOptions<
  UpdateLearningPlanPageCategoryMutation,
  UpdateLearningPlanPageCategoryMutationVariables
>
export const UpdateLearningPlanPageStreamDocument = gql`
  mutation updateLearningPlanPageStream($streamId: ID!, $learningPlanPageStreamInput: LearningPlanPageStreamInput!) {
    updateLearningPlanPageStream(streamId: $streamId, learningPlanPageStreamInput: $learningPlanPageStreamInput) {
      id
      name
      blocks {
        ...LessonBlockShortFragment
      }
    }
  }
  ${LessonBlockShortFragmentFragmentDoc}
`
export type UpdateLearningPlanPageStreamMutationFn = Apollo.MutationFunction<
  UpdateLearningPlanPageStreamMutation,
  UpdateLearningPlanPageStreamMutationVariables
>

/**
 * __useUpdateLearningPlanPageStreamMutation__
 *
 * To run a mutation, you first call `useUpdateLearningPlanPageStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningPlanPageStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningPlanPageStreamMutation, { data, loading, error }] = useUpdateLearningPlanPageStreamMutation({
 *   variables: {
 *      streamId: // value for 'streamId'
 *      learningPlanPageStreamInput: // value for 'learningPlanPageStreamInput'
 *   },
 * });
 */
export function useUpdateLearningPlanPageStreamMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateLearningPlanPageStreamMutation,
    UpdateLearningPlanPageStreamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateLearningPlanPageStreamMutation,
    UpdateLearningPlanPageStreamMutationVariables
  >(UpdateLearningPlanPageStreamDocument, options)
}
export type UpdateLearningPlanPageStreamMutationHookResult = ReturnType<typeof useUpdateLearningPlanPageStreamMutation>
export type UpdateLearningPlanPageStreamMutationResult = Apollo.MutationResult<UpdateLearningPlanPageStreamMutation>
export type UpdateLearningPlanPageStreamMutationOptions = Apollo.BaseMutationOptions<
  UpdateLearningPlanPageStreamMutation,
  UpdateLearningPlanPageStreamMutationVariables
>
export const UpdateLearningPlanPageV2Document = gql`
  mutation updateLearningPlanPageV2(
    $pageId: ID!
    $learningPlanPageInput: LearningPlanPageInputV2!
    $generate: Boolean!
    $categoryId: ID
  ) {
    updateLearningPlanPageV2(
      pageId: $pageId
      learningPlanPageInput: $learningPlanPageInput
      generate: $generate
      categoryId: $categoryId
    ) {
      id
      learningPlanId
      title
      isFinished
      isArchived
      isGenerated
      learningFeatureCount
      learningFeatures(preview: true) {
        ...LearningFeatureShortDetail
      }
      category {
        id
        name
        pageCount
        archivedPageCount
      }
      streams {
        id
        name
      }
      canBeExtended
      disabledLearningFeatures
    }
  }
  ${LearningFeatureShortDetailFragmentDoc}
`
export type UpdateLearningPlanPageV2MutationFn = Apollo.MutationFunction<
  UpdateLearningPlanPageV2Mutation,
  UpdateLearningPlanPageV2MutationVariables
>

/**
 * __useUpdateLearningPlanPageV2Mutation__
 *
 * To run a mutation, you first call `useUpdateLearningPlanPageV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningPlanPageV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningPlanPageV2Mutation, { data, loading, error }] = useUpdateLearningPlanPageV2Mutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      learningPlanPageInput: // value for 'learningPlanPageInput'
 *      generate: // value for 'generate'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useUpdateLearningPlanPageV2Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateLearningPlanPageV2Mutation,
    UpdateLearningPlanPageV2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateLearningPlanPageV2Mutation, UpdateLearningPlanPageV2MutationVariables>(
    UpdateLearningPlanPageV2Document,
    options
  )
}
export type UpdateLearningPlanPageV2MutationHookResult = ReturnType<typeof useUpdateLearningPlanPageV2Mutation>
export type UpdateLearningPlanPageV2MutationResult = Apollo.MutationResult<UpdateLearningPlanPageV2Mutation>
export type UpdateLearningPlanPageV2MutationOptions = Apollo.BaseMutationOptions<
  UpdateLearningPlanPageV2Mutation,
  UpdateLearningPlanPageV2MutationVariables
>
export const UpdateLessonBlockDocument = gql`
  mutation updateLessonBlock($blockId: ID!, $blockInput: LessonBlockInput!) {
    updateLessonBlock(blockId: $blockId, blockInput: $blockInput) {
      ...LessonBlockShortFragment
    }
  }
  ${LessonBlockShortFragmentFragmentDoc}
`
export type UpdateLessonBlockMutationFn = Apollo.MutationFunction<
  UpdateLessonBlockMutation,
  UpdateLessonBlockMutationVariables
>

/**
 * __useUpdateLessonBlockMutation__
 *
 * To run a mutation, you first call `useUpdateLessonBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLessonBlockMutation, { data, loading, error }] = useUpdateLessonBlockMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *      blockInput: // value for 'blockInput'
 *   },
 * });
 */
export function useUpdateLessonBlockMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLessonBlockMutation, UpdateLessonBlockMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateLessonBlockMutation, UpdateLessonBlockMutationVariables>(
    UpdateLessonBlockDocument,
    options
  )
}
export type UpdateLessonBlockMutationHookResult = ReturnType<typeof useUpdateLessonBlockMutation>
export type UpdateLessonBlockMutationResult = Apollo.MutationResult<UpdateLessonBlockMutation>
export type UpdateLessonBlockMutationOptions = Apollo.BaseMutationOptions<
  UpdateLessonBlockMutation,
  UpdateLessonBlockMutationVariables
>
export const UpdateUserLearningFeatureDocument = gql`
  mutation updateUserLearningFeature($learningFeatureId: ID!, $userLearningFeature: UserLearningFeatureInput!) {
    updateUserLearningFeature(learningFeatureId: $learningFeatureId, userLearningFeature: $userLearningFeature) {
      __typename
      id
      sourceLanguage
      sourceLanguageText
      targetLanguage
      targetLanguageText
      level
      type
      origin
    }
  }
`
export type UpdateUserLearningFeatureMutationFn = Apollo.MutationFunction<
  UpdateUserLearningFeatureMutation,
  UpdateUserLearningFeatureMutationVariables
>

/**
 * __useUpdateUserLearningFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateUserLearningFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLearningFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLearningFeatureMutation, { data, loading, error }] = useUpdateUserLearningFeatureMutation({
 *   variables: {
 *      learningFeatureId: // value for 'learningFeatureId'
 *      userLearningFeature: // value for 'userLearningFeature'
 *   },
 * });
 */
export function useUpdateUserLearningFeatureMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateUserLearningFeatureMutation,
    UpdateUserLearningFeatureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateUserLearningFeatureMutation, UpdateUserLearningFeatureMutationVariables>(
    UpdateUserLearningFeatureDocument,
    options
  )
}
export type UpdateUserLearningFeatureMutationHookResult = ReturnType<typeof useUpdateUserLearningFeatureMutation>
export type UpdateUserLearningFeatureMutationResult = Apollo.MutationResult<UpdateUserLearningFeatureMutation>
export type UpdateUserLearningFeatureMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserLearningFeatureMutation,
  UpdateUserLearningFeatureMutationVariables
>
export const GetWorksheetsForActivityDocument = gql`
  query getWorksheetsForActivity($learningActivityId: ID!) {
    worksheetsForActivity(learningActivityId: $learningActivityId) {
      fileName
      worksheetType
      worksheetLexicalType
      contentBase64
    }
  }
`

/**
 * __useGetWorksheetsForActivityQuery__
 *
 * To run a query within a React component, call `useGetWorksheetsForActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorksheetsForActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorksheetsForActivityQuery({
 *   variables: {
 *      learningActivityId: // value for 'learningActivityId'
 *   },
 * });
 */
export function useGetWorksheetsForActivityQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetWorksheetsForActivityQuery, GetWorksheetsForActivityQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetWorksheetsForActivityQuery, GetWorksheetsForActivityQueryVariables>(
    GetWorksheetsForActivityDocument,
    options
  )
}
export function useGetWorksheetsForActivityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetWorksheetsForActivityQuery,
    GetWorksheetsForActivityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetWorksheetsForActivityQuery, GetWorksheetsForActivityQueryVariables>(
    GetWorksheetsForActivityDocument,
    options
  )
}
export type GetWorksheetsForActivityQueryHookResult = ReturnType<typeof useGetWorksheetsForActivityQuery>
export type GetWorksheetsForActivityLazyQueryHookResult = ReturnType<typeof useGetWorksheetsForActivityLazyQuery>
export type GetWorksheetsForActivityQueryResult = Apollo.QueryResult<
  GetWorksheetsForActivityQuery,
  GetWorksheetsForActivityQueryVariables
>
export const CreateLibraryItemPackageDocument = gql`
  mutation createLibraryItemPackage(
    $subject: Subject!
    $libraryItemPackageInput: LibraryItemPackageInput!
    $packageId: ID
  ) {
    createLibraryItemPackage(
      subject: $subject
      libraryItemPackageInput: $libraryItemPackageInput
      packageId: $packageId
    ) {
      __typename
      id
      name
      label
      level
      image {
        medium
        default
      }
      learningFeaturesCount
    }
  }
`
export type CreateLibraryItemPackageMutationFn = Apollo.MutationFunction<
  CreateLibraryItemPackageMutation,
  CreateLibraryItemPackageMutationVariables
>

/**
 * __useCreateLibraryItemPackageMutation__
 *
 * To run a mutation, you first call `useCreateLibraryItemPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryItemPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryItemPackageMutation, { data, loading, error }] = useCreateLibraryItemPackageMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      libraryItemPackageInput: // value for 'libraryItemPackageInput'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useCreateLibraryItemPackageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateLibraryItemPackageMutation,
    CreateLibraryItemPackageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CreateLibraryItemPackageMutation, CreateLibraryItemPackageMutationVariables>(
    CreateLibraryItemPackageDocument,
    options
  )
}
export type CreateLibraryItemPackageMutationHookResult = ReturnType<typeof useCreateLibraryItemPackageMutation>
export type CreateLibraryItemPackageMutationResult = Apollo.MutationResult<CreateLibraryItemPackageMutation>
export type CreateLibraryItemPackageMutationOptions = Apollo.BaseMutationOptions<
  CreateLibraryItemPackageMutation,
  CreateLibraryItemPackageMutationVariables
>
export const DeleteLibraryItemDocument = gql`
  mutation deleteLibraryItem($libraryItemId: ID!, $libraryItemType: LibraryItemType!) {
    deleteLibraryItem(libraryItemId: $libraryItemId, libraryItemType: $libraryItemType)
  }
`
export type DeleteLibraryItemMutationFn = Apollo.MutationFunction<
  DeleteLibraryItemMutation,
  DeleteLibraryItemMutationVariables
>

/**
 * __useDeleteLibraryItemMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryItemMutation, { data, loading, error }] = useDeleteLibraryItemMutation({
 *   variables: {
 *      libraryItemId: // value for 'libraryItemId'
 *      libraryItemType: // value for 'libraryItemType'
 *   },
 * });
 */
export function useDeleteLibraryItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLibraryItemMutation, DeleteLibraryItemMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<DeleteLibraryItemMutation, DeleteLibraryItemMutationVariables>(
    DeleteLibraryItemDocument,
    options
  )
}
export type DeleteLibraryItemMutationHookResult = ReturnType<typeof useDeleteLibraryItemMutation>
export type DeleteLibraryItemMutationResult = Apollo.MutationResult<DeleteLibraryItemMutation>
export type DeleteLibraryItemMutationOptions = Apollo.BaseMutationOptions<
  DeleteLibraryItemMutation,
  DeleteLibraryItemMutationVariables
>
export const GetBookDetailDocument = gql`
  query getBookDetail($bookId: ID!, $withPackages: Boolean!) {
    bookDetail(bookId: $bookId) {
      id
      name
      sourceLanguage
      learningFeatureCount
      level
      subject
      image {
        default
        small
        medium
      }
      units {
        id
        name
        label
        packagesCount
        packages @include(if: $withPackages) {
          id
          name
          label
          level
          learningFeaturesCount
          foxinoOwned
          image {
            default
            medium
          }
        }
      }
    }
  }
`

/**
 * __useGetBookDetailQuery__
 *
 * To run a query within a React component, call `useGetBookDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookDetailQuery({
 *   variables: {
 *      bookId: // value for 'bookId'
 *      withPackages: // value for 'withPackages'
 *   },
 * });
 */
export function useGetBookDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetBookDetailQuery, GetBookDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetBookDetailQuery, GetBookDetailQueryVariables>(GetBookDetailDocument, options)
}
export function useGetBookDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookDetailQuery, GetBookDetailQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetBookDetailQuery, GetBookDetailQueryVariables>(GetBookDetailDocument, options)
}
export type GetBookDetailQueryHookResult = ReturnType<typeof useGetBookDetailQuery>
export type GetBookDetailLazyQueryHookResult = ReturnType<typeof useGetBookDetailLazyQuery>
export type GetBookDetailQueryResult = Apollo.QueryResult<GetBookDetailQuery, GetBookDetailQueryVariables>
export const GetLibraryBookItemsDocument = gql`
  query getLibraryBookItems($filters: LibraryItemsFilterInput!, $page: PageableInput!) {
    libraryBookItems(filters: $filters, page: $page) {
      filters {
        level
        tags
      }
      books {
        __typename
        id
        name
        level
        image {
          imageId {
            namespace
            commonName
          }
          medium
          default
        }
      }
    }
  }
`

/**
 * __useGetLibraryBookItemsQuery__
 *
 * To run a query within a React component, call `useGetLibraryBookItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryBookItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryBookItemsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetLibraryBookItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetLibraryBookItemsQuery, GetLibraryBookItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLibraryBookItemsQuery, GetLibraryBookItemsQueryVariables>(
    GetLibraryBookItemsDocument,
    options
  )
}
export function useGetLibraryBookItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLibraryBookItemsQuery, GetLibraryBookItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLibraryBookItemsQuery, GetLibraryBookItemsQueryVariables>(
    GetLibraryBookItemsDocument,
    options
  )
}
export type GetLibraryBookItemsQueryHookResult = ReturnType<typeof useGetLibraryBookItemsQuery>
export type GetLibraryBookItemsLazyQueryHookResult = ReturnType<typeof useGetLibraryBookItemsLazyQuery>
export type GetLibraryBookItemsQueryResult = Apollo.QueryResult<
  GetLibraryBookItemsQuery,
  GetLibraryBookItemsQueryVariables
>
export const GetLibraryCollectionItemsDocument = gql`
  query getLibraryCollectionItems($filters: LibraryItemsFilterInput!, $page: PageableInput!) {
    libraryCollectionItems(filters: $filters, page: $page) {
      filters {
        level
        tags
      }
      collections {
        id
        name
        label
        level
        packagesCount
        image {
          imageId {
            namespace
            commonName
          }
          medium
          default
        }
      }
    }
  }
`

/**
 * __useGetLibraryCollectionItemsQuery__
 *
 * To run a query within a React component, call `useGetLibraryCollectionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryCollectionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryCollectionItemsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetLibraryCollectionItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetLibraryCollectionItemsQuery,
    GetLibraryCollectionItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLibraryCollectionItemsQuery, GetLibraryCollectionItemsQueryVariables>(
    GetLibraryCollectionItemsDocument,
    options
  )
}
export function useGetLibraryCollectionItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLibraryCollectionItemsQuery,
    GetLibraryCollectionItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLibraryCollectionItemsQuery, GetLibraryCollectionItemsQueryVariables>(
    GetLibraryCollectionItemsDocument,
    options
  )
}
export type GetLibraryCollectionItemsQueryHookResult = ReturnType<typeof useGetLibraryCollectionItemsQuery>
export type GetLibraryCollectionItemsLazyQueryHookResult = ReturnType<typeof useGetLibraryCollectionItemsLazyQuery>
export type GetLibraryCollectionItemsQueryResult = Apollo.QueryResult<
  GetLibraryCollectionItemsQuery,
  GetLibraryCollectionItemsQueryVariables
>
export const GetLibraryItemCollectionDetailDocument = gql`
  query getLibraryItemCollectionDetail($libraryItemId: ID!, $textSearch: String!, $withLearningFeatures: Boolean!) {
    libraryItemCollectionDetail(libraryItemId: $libraryItemId, textSearch: $textSearch) {
      __typename
      id
      image {
        imageId {
          namespace
          commonName
        }
        medium
        default
      }
      name
      label
      type
      level
      packages {
        id
        name
        learningFeaturesCount
        foxinoOwned
        createdBy {
          firstName
          lastName
          email
        }
        learningFeatures @include(if: $withLearningFeatures) {
          ...LearningFeatureShortDetail
        }
        level
        image {
          medium
          default
        }
      }
    }
  }
  ${LearningFeatureShortDetailFragmentDoc}
`

/**
 * __useGetLibraryItemCollectionDetailQuery__
 *
 * To run a query within a React component, call `useGetLibraryItemCollectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryItemCollectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryItemCollectionDetailQuery({
 *   variables: {
 *      libraryItemId: // value for 'libraryItemId'
 *      textSearch: // value for 'textSearch'
 *      withLearningFeatures: // value for 'withLearningFeatures'
 *   },
 * });
 */
export function useGetLibraryItemCollectionDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetLibraryItemCollectionDetailQuery,
    GetLibraryItemCollectionDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLibraryItemCollectionDetailQuery, GetLibraryItemCollectionDetailQueryVariables>(
    GetLibraryItemCollectionDetailDocument,
    options
  )
}
export function useGetLibraryItemCollectionDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLibraryItemCollectionDetailQuery,
    GetLibraryItemCollectionDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetLibraryItemCollectionDetailQuery,
    GetLibraryItemCollectionDetailQueryVariables
  >(GetLibraryItemCollectionDetailDocument, options)
}
export type GetLibraryItemCollectionDetailQueryHookResult = ReturnType<typeof useGetLibraryItemCollectionDetailQuery>
export type GetLibraryItemCollectionDetailLazyQueryHookResult = ReturnType<
  typeof useGetLibraryItemCollectionDetailLazyQuery
>
export type GetLibraryItemCollectionDetailQueryResult = Apollo.QueryResult<
  GetLibraryItemCollectionDetailQuery,
  GetLibraryItemCollectionDetailQueryVariables
>
export const GetLibraryMyPackageItemsDocument = gql`
  query getLibraryMyPackageItems($filters: LibraryItemsFilterInput!, $page: PageableInput!) {
    libraryMyContentItems(filters: $filters, page: $page) {
      filters {
        level
        tags
      }
      myContent {
        id
        name
        label
        borderColor
        image {
          small
          medium
          default
        }
        level
        learningFeaturesCount
      }
    }
  }
`

/**
 * __useGetLibraryMyPackageItemsQuery__
 *
 * To run a query within a React component, call `useGetLibraryMyPackageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryMyPackageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryMyPackageItemsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetLibraryMyPackageItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetLibraryMyPackageItemsQuery, GetLibraryMyPackageItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetLibraryMyPackageItemsQuery, GetLibraryMyPackageItemsQueryVariables>(
    GetLibraryMyPackageItemsDocument,
    options
  )
}
export function useGetLibraryMyPackageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetLibraryMyPackageItemsQuery,
    GetLibraryMyPackageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetLibraryMyPackageItemsQuery, GetLibraryMyPackageItemsQueryVariables>(
    GetLibraryMyPackageItemsDocument,
    options
  )
}
export type GetLibraryMyPackageItemsQueryHookResult = ReturnType<typeof useGetLibraryMyPackageItemsQuery>
export type GetLibraryMyPackageItemsLazyQueryHookResult = ReturnType<typeof useGetLibraryMyPackageItemsLazyQuery>
export type GetLibraryMyPackageItemsQueryResult = Apollo.QueryResult<
  GetLibraryMyPackageItemsQuery,
  GetLibraryMyPackageItemsQueryVariables
>
export const GetWorksheetsFromLibraryDocument = gql`
  query getWorksheetsFromLibrary(
    $activityType: ActivityType!
    $lexicalType: GQLWorksheetLexicalType!
    $name: String!
    $learningFeaturesIds: [ID]!
  ) {
    worksheetsFromLibrary(
      activityType: $activityType
      lexicalType: $lexicalType
      name: $name
      learningFeaturesIds: $learningFeaturesIds
    ) {
      fileName
      contentBase64
      worksheetType
      worksheetLexicalType
    }
  }
`

/**
 * __useGetWorksheetsFromLibraryQuery__
 *
 * To run a query within a React component, call `useGetWorksheetsFromLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorksheetsFromLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorksheetsFromLibraryQuery({
 *   variables: {
 *      activityType: // value for 'activityType'
 *      lexicalType: // value for 'lexicalType'
 *      name: // value for 'name'
 *      learningFeaturesIds: // value for 'learningFeaturesIds'
 *   },
 * });
 */
export function useGetWorksheetsFromLibraryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetWorksheetsFromLibraryQuery, GetWorksheetsFromLibraryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetWorksheetsFromLibraryQuery, GetWorksheetsFromLibraryQueryVariables>(
    GetWorksheetsFromLibraryDocument,
    options
  )
}
export function useGetWorksheetsFromLibraryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetWorksheetsFromLibraryQuery,
    GetWorksheetsFromLibraryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetWorksheetsFromLibraryQuery, GetWorksheetsFromLibraryQueryVariables>(
    GetWorksheetsFromLibraryDocument,
    options
  )
}
export type GetWorksheetsFromLibraryQueryHookResult = ReturnType<typeof useGetWorksheetsFromLibraryQuery>
export type GetWorksheetsFromLibraryLazyQueryHookResult = ReturnType<typeof useGetWorksheetsFromLibraryLazyQuery>
export type GetWorksheetsFromLibraryQueryResult = Apollo.QueryResult<
  GetWorksheetsFromLibraryQuery,
  GetWorksheetsFromLibraryQueryVariables
>
export const SearchCoverImagesDocument = gql`
  query searchCoverImages($search: String!, $subject: Subject!, $page: PageableInput!) {
    searchCoverImages(search: $search, subject: $subject, page: $page) {
      imageId {
        namespace
        commonName
      }
      small
      default
    }
  }
`

/**
 * __useSearchCoverImagesQuery__
 *
 * To run a query within a React component, call `useSearchCoverImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCoverImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCoverImagesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      subject: // value for 'subject'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchCoverImagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<SearchCoverImagesQuery, SearchCoverImagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SearchCoverImagesQuery, SearchCoverImagesQueryVariables>(
    SearchCoverImagesDocument,
    options
  )
}
export function useSearchCoverImagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCoverImagesQuery, SearchCoverImagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<SearchCoverImagesQuery, SearchCoverImagesQueryVariables>(
    SearchCoverImagesDocument,
    options
  )
}
export type SearchCoverImagesQueryHookResult = ReturnType<typeof useSearchCoverImagesQuery>
export type SearchCoverImagesLazyQueryHookResult = ReturnType<typeof useSearchCoverImagesLazyQuery>
export type SearchCoverImagesQueryResult = Apollo.QueryResult<SearchCoverImagesQuery, SearchCoverImagesQueryVariables>
export const SearchDictionaryLearningFeatureDocument = gql`
  query searchDictionaryLearningFeature(
    $searchLearningFeatureInput: SearchDictionaryLearningFeatureInput!
    $page: PageableInput!
    $filter: SearchDictionaryFilterInput
  ) {
    searchDictionaryLearningFeature(
      searchLearningFeatureInput: $searchLearningFeatureInput
      page: $page
      filter: $filter
    ) {
      __typename
      id
      origin
      type
      sourceLanguage
      targetLanguage
      sourceLanguageText
      targetLanguageText
      level
    }
  }
`

/**
 * __useSearchDictionaryLearningFeatureQuery__
 *
 * To run a query within a React component, call `useSearchDictionaryLearningFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDictionaryLearningFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDictionaryLearningFeatureQuery({
 *   variables: {
 *      searchLearningFeatureInput: // value for 'searchLearningFeatureInput'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchDictionaryLearningFeatureQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchDictionaryLearningFeatureQuery,
    SearchDictionaryLearningFeatureQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<SearchDictionaryLearningFeatureQuery, SearchDictionaryLearningFeatureQueryVariables>(
    SearchDictionaryLearningFeatureDocument,
    options
  )
}
export function useSearchDictionaryLearningFeatureLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchDictionaryLearningFeatureQuery,
    SearchDictionaryLearningFeatureQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SearchDictionaryLearningFeatureQuery,
    SearchDictionaryLearningFeatureQueryVariables
  >(SearchDictionaryLearningFeatureDocument, options)
}
export type SearchDictionaryLearningFeatureQueryHookResult = ReturnType<typeof useSearchDictionaryLearningFeatureQuery>
export type SearchDictionaryLearningFeatureLazyQueryHookResult = ReturnType<
  typeof useSearchDictionaryLearningFeatureLazyQuery
>
export type SearchDictionaryLearningFeatureQueryResult = Apollo.QueryResult<
  SearchDictionaryLearningFeatureQuery,
  SearchDictionaryLearningFeatureQueryVariables
>
export const UpdateLibraryItemPackageDocument = gql`
  mutation updateLibraryItemPackage($packageId: ID!, $libraryItemPackageInput: LibraryItemPackageInput!) {
    updateLibraryItemPackage(packageId: $packageId, libraryItemPackageInput: $libraryItemPackageInput) {
      id
      name
      label
      borderColor
      image {
        medium
        default
      }
      learningFeaturesCount
      createdBy {
        firstName
        lastName
        email
      }
      learningFeatures {
        ...LearningFeatureShortDetail
      }
    }
  }
  ${LearningFeatureShortDetailFragmentDoc}
`
export type UpdateLibraryItemPackageMutationFn = Apollo.MutationFunction<
  UpdateLibraryItemPackageMutation,
  UpdateLibraryItemPackageMutationVariables
>

/**
 * __useUpdateLibraryItemPackageMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryItemPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryItemPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryItemPackageMutation, { data, loading, error }] = useUpdateLibraryItemPackageMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      libraryItemPackageInput: // value for 'libraryItemPackageInput'
 *   },
 * });
 */
export function useUpdateLibraryItemPackageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateLibraryItemPackageMutation,
    UpdateLibraryItemPackageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateLibraryItemPackageMutation, UpdateLibraryItemPackageMutationVariables>(
    UpdateLibraryItemPackageDocument,
    options
  )
}
export type UpdateLibraryItemPackageMutationHookResult = ReturnType<typeof useUpdateLibraryItemPackageMutation>
export type UpdateLibraryItemPackageMutationResult = Apollo.MutationResult<UpdateLibraryItemPackageMutation>
export type UpdateLibraryItemPackageMutationOptions = Apollo.BaseMutationOptions<
  UpdateLibraryItemPackageMutation,
  UpdateLibraryItemPackageMutationVariables
>
export const AddUserRoleDocument = gql`
  mutation addUserRole($userRole: UserRole!) {
    addUserRole(userRole: $userRole)
  }
`
export type AddUserRoleMutationFn = Apollo.MutationFunction<AddUserRoleMutation, AddUserRoleMutationVariables>

/**
 * __useAddUserRoleMutation__
 *
 * To run a mutation, you first call `useAddUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserRoleMutation, { data, loading, error }] = useAddUserRoleMutation({
 *   variables: {
 *      userRole: // value for 'userRole'
 *   },
 * });
 */
export function useAddUserRoleMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserRoleMutation, AddUserRoleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<AddUserRoleMutation, AddUserRoleMutationVariables>(AddUserRoleDocument, options)
}
export type AddUserRoleMutationHookResult = ReturnType<typeof useAddUserRoleMutation>
export type AddUserRoleMutationResult = Apollo.MutationResult<AddUserRoleMutation>
export type AddUserRoleMutationOptions = Apollo.BaseMutationOptions<AddUserRoleMutation, AddUserRoleMutationVariables>
export const GetUserProfileDocument = gql`
  query getUserProfile {
    userProfile {
      id
      pictureUrl
      firstName
      lastName
      username
      email
      hasPin
      pinType
    }
  }
`

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options)
}
export function useGetUserProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
    GetUserProfileDocument,
    options
  )
}
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>
export const UpdateUserProfileDocument = gql`
  mutation updateUserProfile($userProfile: UserProfileInput) {
    updateUserProfile(userProfile: $userProfile) {
      id
      firstName
      lastName
      pictureUrl
      appLanguage
    }
  }
`
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables
>

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      userProfile: // value for 'userProfile'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(
    UpdateUserProfileDocument,
    options
  )
}
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables
>
